/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(419);
	__webpack_require__(342);
	__webpack_require__(421);
	__webpack_require__(422);
	__webpack_require__(424);
	__webpack_require__(425);
	__webpack_require__(426);
	__webpack_require__(427);
	__webpack_require__(329);
	__webpack_require__(428);
	__webpack_require__(429);
	__webpack_require__(430);
	__webpack_require__(431);
	__webpack_require__(432);
	__webpack_require__(328);
	__webpack_require__(434);
	module.exports = __webpack_require__(435);


/***/ }),

/***/ 328:
/***/ (function(module, exports) {

	/* **********************************************
	 Begin bootstrap-slider.js
	 ********************************************** */
	
	/* =========================================================
	 * bootstrap-slider.js v3.0.0
	 * http://www.eyecon.ro/bootstrap-slider
	 * =========================================================
	 * Copyright 2012 Stefan Petre
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * ========================================================= */
	
	(function( $ ) {
	
		var ErrorMsgs = {
			formatInvalidInputErrorMsg : function(input) {
				return "Invalid input value '" + input + "' passed in";
			},
			callingContextNotSliderInstance : "Calling context element does not have instance of Slider bound to it. Check your code to make sure the JQuery object returned from the call to the slider() initializer is calling the method"
		};
	
		var Slider = function(element, options) {
			var el = this.element = $(element).hide();
			var origWidth =  $(element)[0].style.width;
	
			var updateSlider = false;
			var parent = this.element.parent();
	
	
			if (parent.hasClass('slider') === true) {
				updateSlider = true;
				this.picker = parent;
			} else {
				this.picker = $('<div class="range-slider">'+
					'<div class="slider-track">'+
					'<div class="slider-selection"></div>'+
					'<div class="slider-handle"></div>'+
					'<div class="slider-handle"></div>'+
					'</div>'+
					'<div id="tooltip" class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'+
					'<div id="tooltip_min" class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'+
					'<div id="tooltip_max" class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'+
					'</div>')
					.insertBefore(this.element)
					.append(this.element);
			}
	
			this.id = this.element.data('slider-id')||options.id;
			if (this.id) {
				this.picker[0].id = this.id;
			}
	
			if (typeof Modernizr !== 'undefined' && Modernizr.touch) {
				this.touchCapable = true;
			}
	
			var tooltip = this.element.data('slider-tooltip')||options.tooltip;
	
			this.tooltip = this.picker.find('#tooltip');
			this.tooltipInner = this.tooltip.find('div.tooltip-inner');
	
			this.tooltip_min = this.picker.find('#tooltip_min');
			this.tooltipInner_min = this.tooltip_min.find('div.tooltip-inner');
	
			this.tooltip_max = this.picker.find('#tooltip_max');
			this.tooltipInner_max= this.tooltip_max.find('div.tooltip-inner');
	
			if (updateSlider === true) {
				// Reset classes
				this.picker.removeClass('slider-horizontal');
				this.picker.removeClass('slider-vertical');
				this.tooltip.removeClass('hide');
				this.tooltip_min.removeClass('hide');
				this.tooltip_max.removeClass('hide');
	
			}
	
			this.orientation = this.element.data('slider-orientation')||options.orientation;
			switch(this.orientation) {
				case 'vertical':
					this.picker.addClass('slider-vertical');
					this.stylePos = 'top';
					this.mousePos = 'pageY';
					this.sizePos = 'offsetHeight';
					this.tooltip.addClass('right')[0].style.left = '100%';
					this.tooltip_min.addClass('right')[0].style.left = '100%';
					this.tooltip_max.addClass('right')[0].style.left = '100%';
					break;
				default:
					this.picker
						.addClass('slider-horizontal')
						.css('width', origWidth);
					this.orientation = 'horizontal';
					this.stylePos = 'left';
					this.mousePos = 'pageX';
					this.sizePos = 'offsetWidth';
					this.tooltip.addClass('top')[0].style.top = -this.tooltip.outerHeight() - 14 + 'px';
					this.tooltip_min.addClass('top')[0].style.top = -this.tooltip_min.outerHeight() - 14 + 'px';
					this.tooltip_max.addClass('top')[0].style.top = -this.tooltip_max.outerHeight() - 14 + 'px';
					break;
			}
	
			var self = this;
			$.each(['min', 'max', 'step', 'value'], function(i, attr) {
				if (typeof el.data('slider-' + attr) !== 'undefined') {
					self[attr] = el.data('slider-' + attr);
				} else if (typeof options[attr] !== 'undefined') {
					self[attr] = options[attr];
				} else if (typeof el.prop(attr) !== 'undefined') {
					self[attr] = el.prop(attr);
				} else {
					self[attr] = 0; // to prevent empty string issues in calculations in IE
				}
			});
	
			if (this.value instanceof Array) {
				if (updateSlider && !this.range) {
					this.value = this.value[0];
				} else {
					this.range = true;
				}
			} else if (this.range) {
				// User wants a range, but value is not an array
				this.value = [this.value, this.max];
			}
	
			this.selection = this.element.data('slider-selection')||options.selection;
			this.selectionEl = this.picker.find('.slider-selection');
			if (this.selection === 'none') {
				this.selectionEl.addClass('hide');
			}
	
			this.selectionElStyle = this.selectionEl[0].style;
	
			this.handle1 = this.picker.find('.slider-handle:first');
			this.handle1Stype = this.handle1[0].style;
	
			this.handle2 = this.picker.find('.slider-handle:last');
			this.handle2Stype = this.handle2[0].style;
	
			if (updateSlider === true) {
				// Reset classes
				this.handle1.removeClass('round triangle');
				this.handle2.removeClass('round triangle hide');
			}
	
			var handle = this.element.data('slider-handle')||options.handle;
			switch(handle) {
				case 'round':
					this.handle1.addClass('round');
					this.handle2.addClass('round');
					break;
				case 'triangle':
					this.handle1.addClass('triangle');
					this.handle2.addClass('triangle');
					break;
			}
	
			if (this.range) {
				this.value[0] = Math.max(this.min, Math.min(this.max, this.value[0]));
				this.value[1] = Math.max(this.min, Math.min(this.max, this.value[1]));
			} else {
				this.value = [ Math.max(this.min, Math.min(this.max, this.value))];
				this.handle2.addClass('hide');
				if (this.selection === 'after') {
					this.value[1] = this.max;
				} else {
					this.value[1] = this.min;
				}
			}
			this.diff = this.max - this.min;
			this.percentage = [
				(this.value[0]-this.min)*100/this.diff,
				(this.value[1]-this.min)*100/this.diff,
				this.step*100/this.diff
			];
	
			this.offset = this.picker.offset();
			this.size = this.picker[0][this.sizePos];
	
			this.formater = options.formater;
			this.tooltip_separator = options.tooltip_separator;
			this.tooltip_split = options.tooltip_split;
	
			this.reversed = this.element.data('slider-reversed')||options.reversed;
	
			this.layout();
			this.layout();
	
			this.handle1.on({
				keydown: $.proxy(this.keydown, this, 0)
			});
	
			this.handle2.on({
				keydown: $.proxy(this.keydown, this, 1)
			});
	
			if (this.touchCapable) {
				// Touch: Bind touch events:
				this.picker.on({
					touchstart: $.proxy(this.mousedown, this)
				});
			} else {
				this.picker.on({
					mousedown: $.proxy(this.mousedown, this)
				});
			}
	
			if(tooltip === 'hide') {
				this.tooltip.addClass('hide');
				this.tooltip_min.addClass('hide');
				this.tooltip_max.addClass('hide');
			} else if(tooltip === 'always') {
				this.showTooltip();
				this.alwaysShowTooltip = true;
			} else {
				this.picker.on({
					mouseenter: $.proxy(this.showTooltip, this),
					mouseleave: $.proxy(this.hideTooltip, this)
				});
				this.handle1.on({
					focus: $.proxy(this.showTooltip, this),
					blur: $.proxy(this.hideTooltip, this)
				});
				this.handle2.on({
					focus: $.proxy(this.showTooltip, this),
					blur: $.proxy(this.hideTooltip, this)
				});
			}
	
			this.enabled = options.enabled &&
				(this.element.data('slider-enabled') === undefined || this.element.data('slider-enabled') === true);
			if(this.enabled) {
				this.enable();
			} else {
				this.disable();
			}
		};
	
		Slider.prototype = {
			constructor: Slider,
	
			over: false,
			inDrag: false,
	
			showTooltip: function(){
				if (this.tooltip_split === false ){
					this.tooltip.addClass('in');
				} else {
					this.tooltip_min.addClass('in');
					this.tooltip_max.addClass('in');
				}
	
				this.over = true;
			},
	
			hideTooltip: function(){
				if (this.inDrag === false && this.alwaysShowTooltip !== true) {
					this.tooltip.removeClass('in');
					this.tooltip_min.removeClass('in');
					this.tooltip_max.removeClass('in');
				}
				this.over = false;
			},
	
			layout: function(){
				var positionPercentages;
	
				if(this.reversed) {
					positionPercentages = [ 100 - this.percentage[0], this.percentage[1] ];
				} else {
					positionPercentages = [ this.percentage[0], this.percentage[1] ];
				}
	
				this.handle1Stype[this.stylePos] = positionPercentages[0]+'%';
				this.handle2Stype[this.stylePos] = positionPercentages[1]+'%';
	
				if (this.orientation === 'vertical') {
					this.selectionElStyle.top = Math.min(positionPercentages[0], positionPercentages[1]) +'%';
					this.selectionElStyle.height = Math.abs(positionPercentages[0] - positionPercentages[1]) +'%';
				} else {
					this.selectionElStyle.left = Math.min(positionPercentages[0], positionPercentages[1]) +'%';
					this.selectionElStyle.width = Math.abs(positionPercentages[0] - positionPercentages[1]) +'%';
	
					var offset_min = this.tooltip_min[0].getBoundingClientRect();
					var offset_max = this.tooltip_max[0].getBoundingClientRect();
	
					if (offset_min.right > offset_max.left) {
						this.tooltip_max.removeClass('top');
						this.tooltip_max.addClass('bottom')[0].style.top = 18 + 'px';
					} else {
						this.tooltip_max.removeClass('bottom');
						this.tooltip_max.addClass('top')[0].style.top = -30 + 'px';
					}
				}
	
				if (this.range) {
					this.tooltipInner.text(
						this.formater(this.value[0]) + this.tooltip_separator + this.formater(this.value[1])
					);
					this.tooltip[0].style[this.stylePos] = this.size * (positionPercentages[0] + (positionPercentages[1] - positionPercentages[0])/2)/100 - (this.orientation === 'vertical' ? this.tooltip.outerHeight()/2 : this.tooltip.outerWidth()/2) +'px';
	
					this.tooltipInner_min.text(
						this.formater(this.value[0])
					);
					this.tooltipInner_max.text(
						this.formater(this.value[1])
					);
	
					this.tooltip_min[0].style[this.stylePos] = this.size * ( (positionPercentages[0])/100) - (this.orientation === 'vertical' ? this.tooltip_min.outerHeight()/2 : this.tooltip_min.outerWidth()/2) +'px';
					this.tooltip_max[0].style[this.stylePos] = this.size * ( (positionPercentages[1])/100) - (this.orientation === 'vertical' ? this.tooltip_max.outerHeight()/2 : this.tooltip_max.outerWidth()/2) +'px';
	
				} else {
					this.tooltipInner.text(
						this.formater(this.value[0])
					);
					this.tooltip[0].style[this.stylePos] = this.size * positionPercentages[0]/100 - (this.orientation === 'vertical' ? this.tooltip.outerHeight()/2 : this.tooltip.outerWidth()/2) +'px';
				}
			},
	
			mousedown: function(ev) {
				if(!this.isEnabled()) {
					return false;
				}
				// Touch: Get the original event:
				if (this.touchCapable && ev.type === 'touchstart') {
					ev = ev.originalEvent;
				}
	
				this.triggerFocusOnHandle();
	
				this.offset = this.picker.offset();
				this.size = this.picker[0][this.sizePos];
	
				var percentage = this.getPercentage(ev);
	
				if (this.range) {
					var diff1 = Math.abs(this.percentage[0] - percentage);
					var diff2 = Math.abs(this.percentage[1] - percentage);
					this.dragged = (diff1 < diff2) ? 0 : 1;
				} else {
					this.dragged = 0;
				}
	
				this.percentage[this.dragged] = this.reversed ? 100 - percentage : percentage;
				this.layout();
	
				if (this.touchCapable) {
					// Touch: Bind touch events:
					$(document).on({
						touchmove: $.proxy(this.mousemove, this),
						touchend: $.proxy(this.mouseup, this)
					});
				} else {
					$(document).on({
						mousemove: $.proxy(this.mousemove, this),
						mouseup: $.proxy(this.mouseup, this)
					});
				}
	
				this.inDrag = true;
				var val = this.calculateValue();
				this.setValue(val);
				this.element.trigger({
					type: 'slideStart',
					value: val
				}).trigger({
					type: 'slide',
					value: val
				});
				return true;
			},
	
			triggerFocusOnHandle: function(handleIdx) {
				if(handleIdx === 0) {
					this.handle1.focus();
				}
				if(handleIdx === 1) {
					this.handle2.focus();
				}
			},
	
			keydown: function(handleIdx, ev) {
				if(!this.isEnabled()) {
					return false;
				}
	
				var dir;
				switch (ev.which) {
					case 37: // left
					case 40: // down
						dir = -1;
						break;
					case 39: // right
					case 38: // up
						dir = 1;
						break;
				}
				if (!dir) {
					return;
				}
	
				var oneStepValuePercentageChange = dir * this.percentage[2];
				var percentage = this.percentage[handleIdx] + oneStepValuePercentageChange;
	
				if (percentage > 100) {
					percentage = 100;
				} else if (percentage < 0) {
					percentage = 0;
				}
	
				this.dragged = handleIdx;
				this.adjustPercentageForRangeSliders(percentage);
				this.percentage[this.dragged] = percentage;
				this.layout();
	
				var val = this.calculateValue();
				this.setValue(val);
				this.element
					.trigger({
						type: 'slide',
						value: val
					})
					.trigger({
						type: 'slideStop',
						value: val
					})
					.data('value', val)
					.prop('value', val);
				return false;
			},
	
			mousemove: function(ev) {
				if(!this.isEnabled()) {
					return false;
				}
				// Touch: Get the original event:
				if (this.touchCapable && ev.type === 'touchmove') {
					ev = ev.originalEvent;
				}
	
				var percentage = this.getPercentage(ev);
				this.adjustPercentageForRangeSliders(percentage);
				this.percentage[this.dragged] = this.reversed ? 100 - percentage : percentage;
				this.layout();
	
				var val = this.calculateValue();
				this.setValue(val);
				this.element
					.trigger({
						type: 'slide',
						value: val
					})
					.data('value', val)
					.prop('value', val);
				return false;
			},
	
			adjustPercentageForRangeSliders: function(percentage) {
				if (this.range) {
					if (this.dragged === 0 && this.percentage[1] < percentage) {
						this.percentage[0] = this.percentage[1];
						this.dragged = 1;
					} else if (this.dragged === 1 && this.percentage[0] > percentage) {
						this.percentage[1] = this.percentage[0];
						this.dragged = 0;
					}
				}
			},
	
			mouseup: function() {
				if(!this.isEnabled()) {
					return false;
				}
				if (this.touchCapable) {
					// Touch: Bind touch events:
					$(document).off({
						touchmove: this.mousemove,
						touchend: this.mouseup
					});
				} else {
					$(document).off({
						mousemove: this.mousemove,
						mouseup: this.mouseup
					});
				}
	
				this.inDrag = false;
				if (this.over === false) {
					this.hideTooltip();
				}
				var val = this.calculateValue();
				this.layout();
				this.element
					.data('value', val)
					.prop('value', val)
					.trigger({
						type: 'slideStop',
						value: val
					});
				return false;
			},
	
			calculateValue: function() {
				var val;
				if (this.range) {
					val = [this.min,this.max];
					if (this.percentage[0] !== 0){
						val[0] = (Math.max(this.min, this.min + Math.round((this.diff * this.percentage[0]/100)/this.step)*this.step));
					}
					if (this.percentage[1] !== 100){
						val[1] = (Math.min(this.max, this.min + Math.round((this.diff * this.percentage[1]/100)/this.step)*this.step));
					}
					this.value = val;
				} else {
					val = (this.min + Math.round((this.diff * this.percentage[0]/100)/this.step)*this.step);
					if (val < this.min) {
						val = this.min;
					}
					else if (val > this.max) {
						val = this.max;
					}
					val = parseFloat(val);
					this.value = [val, this.value[1]];
				}
				return val;
			},
	
			getPercentage: function(ev) {
				if (this.touchCapable) {
					ev = ev.touches[0];
				}
				var percentage = (ev[this.mousePos] - this.offset[this.stylePos])*100/this.size;
				percentage = Math.round(percentage/this.percentage[2])*this.percentage[2];
				return Math.max(0, Math.min(100, percentage));
			},
	
			getValue: function() {
				if (this.range) {
					return this.value;
				}
				return this.value[0];
			},
	
			setValue: function(val) {
				this.value = this.validateInputValue(val);
	
				if (this.range) {
					this.value[0] = Math.max(this.min, Math.min(this.max, this.value[0]));
					this.value[1] = Math.max(this.min, Math.min(this.max, this.value[1]));
				} else {
					this.value = [ Math.max(this.min, Math.min(this.max, this.value))];
					this.handle2.addClass('hide');
					if (this.selection === 'after') {
						this.value[1] = this.max;
					} else {
						this.value[1] = this.min;
					}
				}
				this.diff = this.max - this.min;
				this.percentage = [
					(this.value[0]-this.min)*100/this.diff,
					(this.value[1]-this.min)*100/this.diff,
					this.step*100/this.diff
				];
				this.layout();
	
				this.element
					.trigger({
						'type': 'slide',
						'value': this.value
					})
					.data('value', this.value)
					.prop('value', this.value);
			},
	
			validateInputValue : function(val) {
				if(typeof val === 'number') {
					return val;
				} else if(val instanceof Array) {
					$.each(val, function(i, input) { if (typeof input !== 'number') { throw new Error( ErrorMsgs.formatInvalidInputErrorMsg(input) ); }});
					return val;
				} else {
					throw new Error( ErrorMsgs.formatInvalidInputErrorMsg(val) );
				}
			},
	
			destroy: function(){
				this.handle1.off();
				this.handle2.off();
				this.element.off().show().insertBefore(this.picker);
				this.picker.off().remove();
				$(this.element).removeData('slider');
			},
	
			disable: function() {
				this.enabled = false;
				this.handle1.removeAttr("tabindex");
				this.handle2.removeAttr("tabindex");
				this.picker.addClass('slider-disabled');
				this.element.trigger('slideDisabled');
			},
	
			enable: function() {
				this.enabled = true;
				this.handle1.attr("tabindex", 0);
				this.handle2.attr("tabindex", 0);
				this.picker.removeClass('slider-disabled');
				this.element.trigger('slideEnabled');
			},
	
			toggle: function() {
				if(this.enabled) {
					this.disable();
				} else {
					this.enable();
				}
			},
	
			isEnabled: function() {
				return this.enabled;
			},
	
			setAttribute: function(attribute, value) {
				this[attribute] = value;
			}
		};
	
		var publicMethods = {
			getValue : Slider.prototype.getValue,
			setValue : Slider.prototype.setValue,
			setAttribute : Slider.prototype.setAttribute,
			destroy : Slider.prototype.destroy,
			disable : Slider.prototype.disable,
			enable : Slider.prototype.enable,
			toggle : Slider.prototype.toggle,
			isEnabled: Slider.prototype.isEnabled
		};
	
		$.fn.slider = function (option) {
			if (typeof option === 'string' && option !== 'refresh') {
				var args = Array.prototype.slice.call(arguments, 1);
				return invokePublicMethod.call(this, option, args);
			} else {
				return createNewSliderInstance.call(this, option);
			}
		};
	
		function invokePublicMethod(methodName, args) {
			if(publicMethods[methodName]) {
				var sliderObject = retrieveSliderObjectFromElement(this);
				var result = publicMethods[methodName].apply(sliderObject, args);
	
				if (typeof result === "undefined") {
					return $(this);
				} else {
					return result;
				}
			} else {
				throw new Error("method '" + methodName + "()' does not exist for slider.");
			}
		}
	
		function retrieveSliderObjectFromElement(element) {
			var sliderObject = $(element).data('slider');
			if(sliderObject && sliderObject instanceof Slider) {
				return sliderObject;
			} else {
				throw new Error(ErrorMsgs.callingContextNotSliderInstance);
			}
		}
	
		function createNewSliderInstance(opts) {
			var $this = $(this);
			$this.each(function() {
				var $this = $(this),
					slider = $this.data('slider'),
					options = typeof opts === 'object' && opts;
	
				// If slider already exists, use its attributes
				// as options so slider refreshes properly
				if (slider && !options) {
					options = {};
	
					$.each($.fn.slider.defaults, function(key) {
						options[key] = slider[key];
					});
				}
	
				$this.data('slider', (new Slider(this, $.extend({}, $.fn.slider.defaults, options))));
			});
			return $this;
		}
	
		$.fn.slider.defaults = {
			min: 0,
			max: 10,
			step: 1,
			orientation: 'horizontal',
			value: 5,
			range: false,
			selection: 'before',
			tooltip: 'show',
			tooltip_separator: ':',
			tooltip_split: false,
			handle: 'round',
			reversed : false,
			enabled: true,
			formater: function(value) {
				return value;
			}
		};
	
		$.fn.slider.Constructor = Slider;
	
	})( window.jQuery );


/***/ }),

/***/ 329:
/***/ (function(module, exports) {

	/* **********************************************
	 Begin tab.js
	 ********************************************** */
	
	/* ========================================================================
	 * Bootstrap: tab.js v3.1.0
	 * http://getbootstrap.com/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2014 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
		'use strict';
	
		// TAB CLASS DEFINITION
		// ====================
	
		var Tab = function (element) {
			this.element = $(element)
		}
	
		Tab.prototype.show = function () {
			var $this    = this.element
			var $ul      = $this.closest('ul:not(.dropdown-menu)')
			var selector = $this.data('target')
	
			if (!selector) {
				selector = $this.attr('href')
				selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') //strip for ie7
			}
	
			if ($this.parent('li').hasClass('active')) return
	
			var previous = $ul.find('.active:last a')[0]
			var e        = $.Event('show.bs.tab', {
				relatedTarget: previous
			})
	
			$this.trigger(e)
	
			if (e.isDefaultPrevented()) return
	
			var $target = $(selector)
	
			this.activate($this.parent('li'), $ul)
			this.activate($target, $target.parent(), function () {
				$this.trigger({
					type: 'shown.bs.tab',
					relatedTarget: previous
				})
			})
		}
	
		Tab.prototype.activate = function (element, container, callback) {
			var $active    = container.find('> .active')
			var transition = callback
				&& $.support.transition
				&& $active.hasClass('fade')
	
			function next() {
				$active
					.removeClass('active')
					.find('> .dropdown-menu > .active')
					.removeClass('active')
	
				element.addClass('active')
	
				if (transition) {
					element[0].offsetWidth // reflow for transition
					element.addClass('in')
				} else {
					element.removeClass('fade')
				}
	
				if (element.parent('.dropdown-menu')) {
					element.closest('li.dropdown').addClass('active')
				}
	
				callback && callback()
			}
	
			transition ?
				$active
					.one($.support.transition.end, next)
					.emulateTransitionEnd(150) :
				next()
	
			$active.removeClass('in')
		}
	
	
		// TAB PLUGIN DEFINITION
		// =====================
	
		var old = $.fn.tab
	
		$.fn.tab = function ( option ) {
			return this.each(function () {
				var $this = $(this)
				var data  = $this.data('bs.tab')
	
				if (!data) $this.data('bs.tab', (data = new Tab(this)))
				if (typeof option == 'string') data[option]()
			})
		}
	
		$.fn.tab.Constructor = Tab
	
	
		// TAB NO CONFLICT
		// ===============
	
		$.fn.tab.noConflict = function () {
			$.fn.tab = old
			return this
		}
	
	
		// TAB DATA-API
		// ============
	
		$(document).on('click.bs.tab.data-api', '[data-toggle="tab"], [data-toggle="pill"]', function (e) {
			e.preventDefault()
			$(this).tab('show')
		})
	
	}(jQuery);


/***/ }),

/***/ 342:
/***/ (function(module, exports) {

	/**!
	 * jQuery i18n plugin
	 * @requires jQuery v1.1 or later
	 *
	 * See https://github.com/recurser/jquery-i18n
	 *
	 * Licensed under the MIT license.
	 *
	 * Version: 1.1.1 (Sun, 05 Jan 2014 05:26:50 GMT)
	 */
	(function($) {
		/**
		 * i18n provides a mechanism for translating strings using a jscript dictionary.
		 *
		 */
	
		var __slice = Array.prototype.slice;
	
		/*
		 * i18n property list
		 */
		var i18n = {
	
			dict: null,
	
			/**
			 * load()
			 *
			 * Load translations.
			 *
			 * @param  property_list i18n_dict : The dictionary to use for translation.
			 */
			load: function(i18n_dict) {
				if (this.dict !== null) {
					$.extend(this.dict, i18n_dict);
				} else {
					this.dict = i18n_dict;
				}
			},
	
			/**
			 * _()
			 *
			 * Looks the given string up in the dictionary and returns the translation if
			 * one exists. If a translation is not found, returns the original word.
			 *
			 * @param  string str           : The string to translate.
			 * @param  property_list params.. : params for using printf() on the string.
			 *
			 * @return string               : Translated word.
			 */
			_: function (str) {
				dict = this.dict;
				if (dict && dict.hasOwnProperty(str)) {
					str = dict[str];
				}
				args = __slice.call(arguments);
				args[0] = str;
				// Substitute any params.
				return this.printf.apply(this, args);
			},
	
			/*
			 * printf()
			 *
			 * Substitutes %s with parameters given in list. %%s is used to escape %s.
			 *
			 * @param  string str    : String to perform printf on.
			 * @param  string args   : Array of arguments for printf.
			 *
			 * @return string result : Substituted string
			 */
			printf: function(str, args) {
				if (arguments.length < 2) return str;
				args = $.isArray(args) ? args : __slice.call(arguments, 1);
				return str.replace(/([^%]|^)%(?:(\d+)\$)?s/g, function(p0, p, position) {
					if (position) {
						return p + args[parseInt(position)-1];
					}
					return p + args.shift();
				}).replace(/%%s/g, '%s');
			}
	
		};
	
		/*
		 * _t()
		 *
		 * Allows you to translate a jQuery selector.
		 *
		 * eg $('h1')._t('some text')
		 *
		 * @param  string str           : The string to translate .
		 * @param  property_list params : Params for using printf() on the string.
		 *
		 * @return element              : Chained and translated element(s).
		 */
		$.fn._t = function(str, params) {
			return $(this).html(i18n._.apply(i18n, arguments));
		};
	
		$.i18n = i18n;
	})(jQuery);

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["FastClick"] = __webpack_require__(420);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * ====================================================
	 * ====================================================
	 * = ATTENTION: Line 575 is changed because of PI-798 =
	 * ====================================================
	 * ====================================================
	 */
	(function () {
		'use strict';
	
		/**
		 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
		 *
		 * @version 1.0.3
		 * @codingstandard ftlabs-jsv2
		 * @copyright The Financial Times Limited [All Rights Reserved]
		 * @license MIT License (see LICENSE.txt)
		 */
	
		/*jslint browser:true, node:true*/
		/*global define, Event, Node*/
	
	
		/**
		 * Instantiate fast-clicking listeners on the specified layer.
		 *
		 * @constructor
		 * @param {Element} layer The layer to listen on
		 * @param {Object} options The options to override the defaults
		 */
		function FastClick(layer, options) {
			var oldOnClick;
	
			options = options || {};
	
			/**
			 * Whether a click is currently being tracked.
			 *
			 * @type boolean
			 */
			this.trackingClick = false;
	
	
			/**
			 * Timestamp for when click tracking started.
			 *
			 * @type number
			 */
			this.trackingClickStart = 0;
	
	
			/**
			 * The element being tracked for a click.
			 *
			 * @type EventTarget
			 */
			this.targetElement = null;
	
	
			/**
			 * X-coordinate of touch start event.
			 *
			 * @type number
			 */
			this.touchStartX = 0;
	
	
			/**
			 * Y-coordinate of touch start event.
			 *
			 * @type number
			 */
			this.touchStartY = 0;
	
	
			/**
			 * ID of the last touch, retrieved from Touch.identifier.
			 *
			 * @type number
			 */
			this.lastTouchIdentifier = 0;
	
	
			/**
			 * Touchmove boundary, beyond which a click will be cancelled.
			 *
			 * @type number
			 */
			this.touchBoundary = options.touchBoundary || 10;
	
	
			/**
			 * The FastClick layer.
			 *
			 * @type Element
			 */
			this.layer = layer;
	
			/**
			 * The minimum time between tap(touchstart and touchend) events
			 *
			 * @type number
			 */
			this.tapDelay = options.tapDelay || 200;
	
			if (FastClick.notNeeded(layer)) {
				return;
			}
	
			// Some old versions of Android don't have Function.prototype.bind
			function bind(method, context) {
				return function() { return method.apply(context, arguments); };
			}
	
	
			var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
			var context = this;
			for (var i = 0, l = methods.length; i < l; i++) {
				context[methods[i]] = bind(context[methods[i]], context);
			}
	
			// Set up event handlers as required
			if (deviceIsAndroid) {
				layer.addEventListener('mouseover', this.onMouse, true);
				layer.addEventListener('mousedown', this.onMouse, true);
				layer.addEventListener('mouseup', this.onMouse, true);
			}
	
			layer.addEventListener('click', this.onClick, true);
			layer.addEventListener('touchstart', this.onTouchStart, false);
			layer.addEventListener('touchmove', this.onTouchMove, false);
			layer.addEventListener('touchend', this.onTouchEnd, false);
			layer.addEventListener('touchcancel', this.onTouchCancel, false);
	
			// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
			// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
			// layer when they are cancelled.
			if (!Event.prototype.stopImmediatePropagation) {
				layer.removeEventListener = function(type, callback, capture) {
					var rmv = Node.prototype.removeEventListener;
					if (type === 'click') {
						rmv.call(layer, type, callback.hijacked || callback, capture);
					} else {
						rmv.call(layer, type, callback, capture);
					}
				};
	
				layer.addEventListener = function(type, callback, capture) {
					var adv = Node.prototype.addEventListener;
					if (type === 'click') {
						adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
							if (!event.propagationStopped) {
								callback(event);
							}
						}), capture);
					} else {
						adv.call(layer, type, callback, capture);
					}
				};
			}
	
			// If a handler is already declared in the element's onclick attribute, it will be fired before
			// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
			// adding it as listener.
			if (typeof layer.onclick === 'function') {
	
				// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
				// - the old one won't work if passed to addEventListener directly.
				oldOnClick = layer.onclick;
				layer.addEventListener('click', function(event) {
					oldOnClick(event);
				}, false);
				layer.onclick = null;
			}
		}
	
	
		/**
		 * Android requires exceptions.
		 *
		 * @type boolean
		 */
		var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0;
	
	
		/**
		 * iOS requires exceptions.
		 *
		 * @type boolean
		 */
		var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent);
	
	
		/**
		 * iOS 4 requires an exception for select elements.
		 *
		 * @type boolean
		 */
		var deviceIsIOS4 = deviceIsIOS && (/OS 4_\d(_\d)?/).test(navigator.userAgent);
	
	
		/**
		 * iOS 6.0(+?) requires the target element to be manually derived
		 *
		 * @type boolean
		 */
		var deviceIsIOSWithBadTarget = deviceIsIOS && (/OS ([6-9]|\d{2})_\d/).test(navigator.userAgent);
	
		/**
		 * BlackBerry requires exceptions.
		 *
		 * @type boolean
		 */
		var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;
	
		/**
		 * Determine whether a given element requires a native click.
		 *
		 * @param {EventTarget|Element} target Target DOM element
		 * @returns {boolean} Returns true if the element needs a native click
		 */
		FastClick.prototype.needsClick = function(target) {
			switch (target.nodeName.toLowerCase()) {
	
				// Don't send a synthetic click to disabled inputs (issue #62)
				case 'button':
				case 'select':
				case 'textarea':
					if (target.disabled) {
						return true;
					}
	
					break;
				case 'input':
	
					// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
					if ((deviceIsIOS && target.type === 'file') || target.disabled) {
						return true;
					}
	
					break;
				case 'label':
				case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
				case 'video':
					return true;
			}
	
			return (/\bneedsclick\b/).test(target.className);
		};
	
	
		/**
		 * Determine whether a given element requires a call to focus to simulate click into element.
		 *
		 * @param {EventTarget|Element} target Target DOM element
		 * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
		 */
		FastClick.prototype.needsFocus = function(target) {
			switch (target.nodeName.toLowerCase()) {
				case 'textarea':
					return true;
				case 'select':
					return !deviceIsAndroid;
				case 'input':
					switch (target.type) {
						case 'button':
						case 'checkbox':
						case 'file':
						case 'image':
						case 'radio':
						case 'submit':
							return false;
					}
	
					// No point in attempting to focus disabled inputs
					return !target.disabled && !target.readOnly;
				default:
					return (/\bneedsfocus\b/).test(target.className);
			}
		};
	
	
		/**
		 * Send a click event to the specified element.
		 *
		 * @param {EventTarget|Element} targetElement
		 * @param {Event} event
		 */
		FastClick.prototype.sendClick = function(targetElement, event) {
			var clickEvent, touch;
	
			// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
			if (document.activeElement && document.activeElement !== targetElement) {
				document.activeElement.blur();
			}
	
			touch = event.changedTouches[0];
	
			// Synthesise a click event, with an extra attribute so it can be tracked
			clickEvent = document.createEvent('MouseEvents');
			clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
			clickEvent.forwardedTouchEvent = true;
			targetElement.dispatchEvent(clickEvent);
		};
	
		FastClick.prototype.determineEventType = function(targetElement) {
	
			//Issue #159: Android Chrome Select Box does not open with a synthetic click event
			if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
				return 'mousedown';
			}
	
			return 'click';
		};
	
	
		/**
		 * @param {EventTarget|Element} targetElement
		 */
		FastClick.prototype.focus = function(targetElement) {
			var length;
	
			// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
			if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
				length = targetElement.value.length;
				targetElement.setSelectionRange(length, length);
			} else {
				targetElement.focus();
			}
		};
	
	
		/**
		 * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
		 *
		 * @param {EventTarget|Element} targetElement
		 */
		FastClick.prototype.updateScrollParent = function(targetElement) {
			var scrollParent, parentElement;
	
			scrollParent = targetElement.fastClickScrollParent;
	
			// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
			// target element was moved to another parent.
			if (!scrollParent || !scrollParent.contains(targetElement)) {
				parentElement = targetElement;
				do {
					if (parentElement.scrollHeight > parentElement.offsetHeight) {
						scrollParent = parentElement;
						targetElement.fastClickScrollParent = parentElement;
						break;
					}
	
					parentElement = parentElement.parentElement;
				} while (parentElement);
			}
	
			// Always update the scroll top tracker if possible.
			if (scrollParent) {
				scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
			}
		};
	
	
		/**
		 * @param {EventTarget} targetElement
		 * @returns {Element|EventTarget}
		 */
		FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {
	
			// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
			if (eventTarget.nodeType === Node.TEXT_NODE) {
				return eventTarget.parentNode;
			}
	
			return eventTarget;
		};
	
	
		/**
		 * On touch start, record the position and scroll offset.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onTouchStart = function(event) {
			var targetElement, touch, selection;
	
			// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
			if (event.targetTouches.length > 1) {
				return true;
			}
	
			targetElement = this.getTargetElementFromEventTarget(event.target);
			touch = event.targetTouches[0];
	
			if (deviceIsIOS) {
	
				// Only trusted events will deselect text on iOS (issue #49)
				selection = window.getSelection();
				if (selection.rangeCount && !selection.isCollapsed) {
					return true;
				}
	
				if (!deviceIsIOS4) {
	
					// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
					// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
					// with the same identifier as the touch event that previously triggered the click that triggered the alert.
					// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
					// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
					// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
					// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
					// random integers, it's safe to to continue if the identifier is 0 here.
					if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
						event.preventDefault();
						return false;
					}
	
					this.lastTouchIdentifier = touch.identifier;
	
					// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
					// 1) the user does a fling scroll on the scrollable layer
					// 2) the user stops the fling scroll with another tap
					// then the event.target of the last 'touchend' event will be the element that was under the user's finger
					// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
					// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
					this.updateScrollParent(targetElement);
				}
			}
	
			this.trackingClick = true;
			this.trackingClickStart = event.timeStamp;
			this.targetElement = targetElement;
	
			this.touchStartX = touch.pageX;
			this.touchStartY = touch.pageY;
	
			// Prevent phantom clicks on fast double-tap (issue #36)
			if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
				event.preventDefault();
			}
	
			return true;
		};
	
	
		/**
		 * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.touchHasMoved = function(event) {
			var touch = event.changedTouches[0], boundary = this.touchBoundary;
	
			if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
				return true;
			}
	
			return false;
		};
	
	
		/**
		 * Update the last position.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onTouchMove = function(event) {
			if (!this.trackingClick) {
				return true;
			}
	
			// If the touch has moved, cancel the click tracking
			if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
				this.trackingClick = false;
				this.targetElement = null;
			}
	
			return true;
		};
	
	
		/**
		 * Attempt to find the labelled control for the given label element.
		 *
		 * @param {EventTarget|HTMLLabelElement} labelElement
		 * @returns {Element|null}
		 */
		FastClick.prototype.findControl = function(labelElement) {
	
			// Fast path for newer browsers supporting the HTML5 control attribute
			if (labelElement.control !== undefined) {
				return labelElement.control;
			}
	
			// All browsers under test that support touch events also support the HTML5 htmlFor attribute
			if (labelElement.htmlFor) {
				return document.getElementById(labelElement.htmlFor);
			}
	
			// If no for attribute exists, attempt to retrieve the first labellable descendant element
			// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
			return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
		};
	
	
		/**
		 * On touch end, determine whether to send a click event at once.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onTouchEnd = function(event) {
			var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;
	
			if (!this.trackingClick) {
				return true;
			}
	
			// Prevent phantom clicks on fast double-tap (issue #36)
			if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
				this.cancelNextClick = true;
				return true;
			}
	
			// Reset to prevent wrong click cancel on input (issue #156).
			this.cancelNextClick = false;
	
			this.lastClickTime = event.timeStamp;
	
			trackingClickStart = this.trackingClickStart;
			this.trackingClick = false;
			this.trackingClickStart = 0;
	
			// On some iOS devices, the targetElement supplied with the event is invalid if the layer
			// is performing a transition or scroll, and has to be re-detected manually. Note that
			// for this to function correctly, it must be called *after* the event target is checked!
			// See issue #57; also filed as rdar://13048589 .
			if (deviceIsIOSWithBadTarget) {
				touch = event.changedTouches[0];
	
				// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
				targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
				targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
			}
	
			targetTagName = targetElement.tagName.toLowerCase();
			if (targetTagName === 'label') {
				forElement = this.findControl(targetElement);
				if (forElement) {
					this.focus(targetElement);
					if (deviceIsAndroid) {
						return false;
					}
	
					targetElement = forElement;
				}
			} else if (this.needsFocus(targetElement)) {
	
				// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
				// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
				if ((event.timeStamp - trackingClickStart) > 100 || (deviceIsIOS && window.top !== window && targetTagName === 'input')) {
					this.targetElement = null;
					return false;
				}
	
				this.focus(targetElement);
				this.sendClick(targetElement, event);
	
				// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
				// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
				if (!deviceIsIOS4 || targetTagName !== 'select') { // original: if (!deviceIsIOS || targetTagName !== 'select')
					this.targetElement = null;
					event.preventDefault();
				}
	
				return false;
			}
	
			if (deviceIsIOS && !deviceIsIOS4) {
	
				// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
				// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
				scrollParent = targetElement.fastClickScrollParent;
				if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
					return true;
				}
			}
	
			// Prevent the actual click from going though - unless the target node is marked as requiring
			// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
			if (!this.needsClick(targetElement)) {
				event.preventDefault();
				this.sendClick(targetElement, event);
			}
	
			return false;
		};
	
	
		/**
		 * On touch cancel, stop tracking the click.
		 *
		 * @returns {void}
		 */
		FastClick.prototype.onTouchCancel = function() {
			this.trackingClick = false;
			this.targetElement = null;
		};
	
	
		/**
		 * Determine mouse events which should be permitted.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onMouse = function(event) {
	
			// If a target element was never set (because a touch event was never fired) allow the event
			if (!this.targetElement) {
				return true;
			}
	
			if (event.forwardedTouchEvent) {
				return true;
			}
	
			// Programmatically generated events targeting a specific element should be permitted
			if (!event.cancelable) {
				return true;
			}
	
			// Derive and check the target element to see whether the mouse event needs to be permitted;
			// unless explicitly enabled, prevent non-touch click events from triggering actions,
			// to prevent ghost/doubleclicks.
			if (!this.needsClick(this.targetElement) || this.cancelNextClick) {
	
				// Prevent any user-added listeners declared on FastClick element from being fired.
				if (event.stopImmediatePropagation) {
					event.stopImmediatePropagation();
				} else {
	
					// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
					event.propagationStopped = true;
				}
	
				// Cancel the event
				event.stopPropagation();
				event.preventDefault();
	
				return false;
			}
	
			// If the mouse event is permitted, return true for the action to go through.
			return true;
		};
	
	
		/**
		 * On actual clicks, determine whether this is a touch-generated click, a click action occurring
		 * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
		 * an actual click which should be permitted.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onClick = function(event) {
			var permitted;
	
			// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
			if (this.trackingClick) {
				this.targetElement = null;
				this.trackingClick = false;
				return true;
			}
	
			// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
			if (event.target.type === 'submit' && event.detail === 0) {
				return true;
			}
	
			permitted = this.onMouse(event);
	
			// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
			if (!permitted) {
				this.targetElement = null;
			}
	
			// If clicks are permitted, return true for the action to go through.
			return permitted;
		};
	
	
		/**
		 * Remove all FastClick's event listeners.
		 *
		 * @returns {void}
		 */
		FastClick.prototype.destroy = function() {
			var layer = this.layer;
	
			if (deviceIsAndroid) {
				layer.removeEventListener('mouseover', this.onMouse, true);
				layer.removeEventListener('mousedown', this.onMouse, true);
				layer.removeEventListener('mouseup', this.onMouse, true);
			}
	
			layer.removeEventListener('click', this.onClick, true);
			layer.removeEventListener('touchstart', this.onTouchStart, false);
			layer.removeEventListener('touchmove', this.onTouchMove, false);
			layer.removeEventListener('touchend', this.onTouchEnd, false);
			layer.removeEventListener('touchcancel', this.onTouchCancel, false);
		};
	
	
		/**
		 * Check whether FastClick is needed.
		 *
		 * @param {Element} layer The layer to listen on
		 */
		FastClick.notNeeded = function(layer) {
			var metaViewport;
			var chromeVersion;
			var blackberryVersion;
	
			// Devices that don't support touch don't need FastClick
			if (typeof window.ontouchstart === 'undefined') {
				return true;
			}
	
			// Chrome version - zero for other browsers
			chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];
	
			if (chromeVersion) {
	
				if (deviceIsAndroid) {
					metaViewport = document.querySelector('meta[name=viewport]');
	
					if (metaViewport) {
						// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
						if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
							return true;
						}
						// Chrome 32 and above with width=device-width or less don't need FastClick
						if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
							return true;
						}
					}
	
					// Chrome desktop doesn't need FastClick (issue #15)
				} else {
					return true;
				}
			}
	
			if (deviceIsBlackBerry10) {
				blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);
	
				// BlackBerry 10.3+ does not require Fastclick library.
				// https://github.com/ftlabs/fastclick/issues/251
				if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
					metaViewport = document.querySelector('meta[name=viewport]');
	
					if (metaViewport) {
						// user-scalable=no eliminates click delay.
						if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
							return true;
						}
						// width=device-width (or less than device-width) eliminates click delay.
						if (document.documentElement.scrollWidth <= window.outerWidth) {
							return true;
						}
					}
				}
			}
	
			// IE10 with -ms-touch-action: none, which disables double-tap-to-zoom (issue #97)
			if (layer.style.msTouchAction === 'none') {
				return true;
			}
	
			return false;
		};
	
	
		/**
		 * Factory method for creating a FastClick object
		 *
		 * @param {Element} layer The layer to listen on
		 * @param {Object} options The options to override the defaults
		 */
		FastClick.attach = function(layer, options) {
			return new FastClick(layer, options);
		};
	
	
		if (true) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return FastClick;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = FastClick.attach;
			module.exports.FastClick = FastClick;
		} else {
			window.FastClick = FastClick;
		}
	}());

/***/ }),

/***/ 421:
/***/ (function(module, exports) {

	/* Modernizr 2.6.2 (Custom Build) | MIT & BSD
	 * Build: http://modernizr.com/download/#-fontface-backgroundsize-borderimage-borderradius-boxshadow-flexbox-hsla-multiplebgs-opacity-rgba-textshadow-cssanimations-csscolumns-generatedcontent-cssgradients-cssreflections-csstransforms-csstransforms3d-csstransitions-applicationcache-canvas-canvastext-draganddrop-hashchange-history-audio-video-indexeddb-input-inputtypes-localstorage-postmessage-sessionstorage-websockets-websqldatabase-webworkers-geolocation-inlinesvg-smil-svg-svgclippaths-touch-webgl-shiv-mq-cssclasses-addtest-prefixed-teststyles-testprop-testallprops-hasevent-prefixes-domprefixes-load
	 */window.Modernizr=function(e,t,n){function r(e){g.cssText=e}function i(e,t){return r(E.join(e+";")+(t||""))}function s(e,t){return typeof e===t}function o(e,t){return!!~(""+e).indexOf(t)}function u(e,t){for(var r in e){var i=e[r];if(!o(i,"-")&&g[i]!==n)return t=="pfx"?i:!0}return!1}function a(e,t,r){for(var i in e){var o=t[e[i]];if(o!==n)return r===!1?e[i]:s(o,"function")?o.bind(r||t):o}return!1}function f(e,t,n){var r=e.charAt(0).toUpperCase()+e.slice(1),i=(e+" "+x.join(r+" ")+r).split(" ");return s(t,"string")||s(t,"undefined")?u(i,t):(i=(e+" "+T.join(r+" ")+r).split(" "),a(i,t,n))}function l(){h.input=function(n){for(var r=0,i=n.length;r<i;r++)L[n[r]]=n[r]in y;return L.list&&(L.list=!!t.createElement("datalist")&&!!e.HTMLDataListElement),L}("autocomplete autofocus list placeholder max min multiple pattern required step".split(" ")),h.inputtypes=function(e){for(var r=0,i,s,o,u=e.length;r<u;r++)y.setAttribute("type",s=e[r]),i=y.type!=="text",i&&(y.value=b,y.style.cssText="position:absolute;visibility:hidden;",/^range$/.test(s)&&y.style.WebkitAppearance!==n?(d.appendChild(y),o=t.defaultView,i=o.getComputedStyle&&o.getComputedStyle(y,null).WebkitAppearance!=="textfield"&&y.offsetHeight!==0,d.removeChild(y)):/^(search|tel)$/.test(s)||(/^(url|email)$/.test(s)?i=y.checkValidity&&y.checkValidity()===!1:i=y.value!=b)),k[e[r]]=!!i;return k}("search tel url email datetime date month week time datetime-local number range color".split(" "))}var c="2.6.2",h={},p=!0,d=t.documentElement,v="modernizr",m=t.createElement(v),g=m.style,y=t.createElement("input"),b=":)",w={}.toString,E=" -webkit- -moz- -o- -ms- ".split(" "),S="Webkit Moz O ms",x=S.split(" "),T=S.toLowerCase().split(" "),N={svg:"http://www.w3.org/2000/svg"},C={},k={},L={},A=[],O=A.slice,M,_=function(e,n,r,i){var s,o,u,a,f=t.createElement("div"),l=t.body,c=l||t.createElement("body");if(parseInt(r,10))while(r--)u=t.createElement("div"),u.id=i?i[r]:v+(r+1),f.appendChild(u);return s=["&#173;",'<style id="s',v,'">',e,"</style>"].join(""),f.id=v,(l?f:c).innerHTML+=s,c.appendChild(f),l||(c.style.background="",c.style.overflow="hidden",a=d.style.overflow,d.style.overflow="hidden",d.appendChild(c)),o=n(f,e),l?f.parentNode.removeChild(f):(c.parentNode.removeChild(c),d.style.overflow=a),!!o},D=function(t){var n=e.matchMedia||e.msMatchMedia;if(n)return n(t).matches;var r;return _("@media "+t+" { #"+v+" { position: absolute; } }",function(t){r=(e.getComputedStyle?getComputedStyle(t,null):t.currentStyle)["position"]=="absolute"}),r},P=function(){function e(e,i){i=i||t.createElement(r[e]||"div"),e="on"+e;var o=e in i;return o||(i.setAttribute||(i=t.createElement("div")),i.setAttribute&&i.removeAttribute&&(i.setAttribute(e,""),o=s(i[e],"function"),s(i[e],"undefined")||(i[e]=n),i.removeAttribute(e))),i=null,o}var r={select:"input",change:"input",submit:"form",reset:"form",error:"img",load:"img",abort:"img"};return e}(),H={}.hasOwnProperty,B;!s(H,"undefined")&&!s(H.call,"undefined")?B=function(e,t){return H.call(e,t)}:B=function(e,t){return t in e&&s(e.constructor.prototype[t],"undefined")},Function.prototype.bind||(Function.prototype.bind=function(e){var t=this;if(typeof t!="function")throw new TypeError;var n=O.call(arguments,1),r=function(){if(this instanceof r){var i=function(){};i.prototype=t.prototype;var s=new i,o=t.apply(s,n.concat(O.call(arguments)));return Object(o)===o?o:s}return t.apply(e,n.concat(O.call(arguments)))};return r}),C.flexbox=function(){return f("flexWrap")},C.canvas=function(){var e=t.createElement("canvas");return!!e.getContext&&!!e.getContext("2d")},C.canvastext=function(){return!!h.canvas&&!!s(t.createElement("canvas").getContext("2d").fillText,"function")},C.webgl=function(){return!!e.WebGLRenderingContext},C.touch=function(){var n;return"ontouchstart"in e||e.DocumentTouch&&t instanceof DocumentTouch?n=!0:_(["@media (",E.join("touch-enabled),("),v,")","{#modernizr{top:9px;position:absolute}}"].join(""),function(e){n=e.offsetTop===9}),n},C.geolocation=function(){return"geolocation"in navigator},C.postmessage=function(){return!!e.postMessage},C.websqldatabase=function(){return!!e.openDatabase},C.indexedDB=function(){return!!f("indexedDB",e)},C.hashchange=function(){return P("hashchange",e)&&(t.documentMode===n||t.documentMode>7)},C.history=function(){return!!e.history&&!!history.pushState},C.draganddrop=function(){var e=t.createElement("div");return"draggable"in e||"ondragstart"in e&&"ondrop"in e},C.websockets=function(){return"WebSocket"in e||"MozWebSocket"in e},C.rgba=function(){return r("background-color:rgba(150,255,150,.5)"),o(g.backgroundColor,"rgba")},C.hsla=function(){return r("background-color:hsla(120,40%,100%,.5)"),o(g.backgroundColor,"rgba")||o(g.backgroundColor,"hsla")},C.multiplebgs=function(){return r("background:url(https://),url(https://),red url(https://)"),/(url\s*\(.*?){3}/.test(g.background)},C.backgroundsize=function(){return f("backgroundSize")},C.borderimage=function(){return f("borderImage")},C.borderradius=function(){return f("borderRadius")},C.boxshadow=function(){return f("boxShadow")},C.textshadow=function(){return t.createElement("div").style.textShadow===""},C.opacity=function(){return i("opacity:.55"),/^0.55$/.test(g.opacity)},C.cssanimations=function(){return f("animationName")},C.csscolumns=function(){return f("columnCount")},C.cssgradients=function(){var e="background-image:",t="gradient(linear,left top,right bottom,from(#9f9),to(white));",n="linear-gradient(left top,#9f9, white);";return r((e+"-webkit- ".split(" ").join(t+e)+E.join(n+e)).slice(0,-e.length)),o(g.backgroundImage,"gradient")},C.cssreflections=function(){return f("boxReflect")},C.csstransforms=function(){return!!f("transform")},C.csstransforms3d=function(){var e=!!f("perspective");return e&&"webkitPerspective"in d.style&&_("@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}",function(t,n){e=t.offsetLeft===9&&t.offsetHeight===3}),e},C.csstransitions=function(){return f("transition")},C.fontface=function(){var e;return _('@font-face {font-family:"font";src:url("https://")}',function(n,r){var i=t.getElementById("smodernizr"),s=i.sheet||i.styleSheet,o=s?s.cssRules&&s.cssRules[0]?s.cssRules[0].cssText:s.cssText||"":"";e=/src/i.test(o)&&o.indexOf(r.split(" ")[0])===0}),e},C.generatedcontent=function(){var e;return _(["#",v,"{font:0/0 a}#",v,':after{content:"',b,'";visibility:hidden;font:3px/1 a}'].join(""),function(t){e=t.offsetHeight>=3}),e},C.video=function(){var e=t.createElement("video"),n=!1;try{if(n=!!e.canPlayType)n=new Boolean(n),n.ogg=e.canPlayType('video/ogg; codecs="theora"').replace(/^no$/,""),n.h264=e.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/,""),n.webm=e.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/,"")}catch(r){}return n},C.audio=function(){var e=t.createElement("audio"),n=!1;try{if(n=!!e.canPlayType)n=new Boolean(n),n.ogg=e.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/,""),n.mp3=e.canPlayType("audio/mpeg;").replace(/^no$/,""),n.wav=e.canPlayType('audio/wav; codecs="1"').replace(/^no$/,""),n.m4a=(e.canPlayType("audio/x-m4a;")||e.canPlayType("audio/aac;")).replace(/^no$/,"")}catch(r){}return n},C.localstorage=function(){try{return localStorage.setItem(v,v),localStorage.removeItem(v),!0}catch(e){return!1}},C.sessionstorage=function(){try{return sessionStorage.setItem(v,v),sessionStorage.removeItem(v),!0}catch(e){return!1}},C.webworkers=function(){return!!e.Worker},C.applicationcache=function(){return!!e.applicationCache},C.svg=function(){return!!t.createElementNS&&!!t.createElementNS(N.svg,"svg").createSVGRect},C.inlinesvg=function(){var e=t.createElement("div");return e.innerHTML="<svg/>",(e.firstChild&&e.firstChild.namespaceURI)==N.svg},C.smil=function(){return!!t.createElementNS&&/SVGAnimate/.test(w.call(t.createElementNS(N.svg,"animate")))},C.svgclippaths=function(){return!!t.createElementNS&&/SVGClipPath/.test(w.call(t.createElementNS(N.svg,"clipPath")))};for(var j in C)B(C,j)&&(M=j.toLowerCase(),h[M]=C[j](),A.push((h[M]?"":"no-")+M));return h.input||l(),h.addTest=function(e,t){if(typeof e=="object")for(var r in e)B(e,r)&&h.addTest(r,e[r]);else{e=e.toLowerCase();if(h[e]!==n)return h;t=typeof t=="function"?t():t,typeof p!="undefined"&&p&&(d.className+=" "+(t?"":"no-")+e),h[e]=t}return h},r(""),m=y=null,function(e,t){function n(e,t){var n=e.createElement("p"),r=e.getElementsByTagName("head")[0]||e.documentElement;return n.innerHTML="x<style>"+t+"</style>",r.insertBefore(n.lastChild,r.firstChild)}function r(){var e=g.elements;return typeof e=="string"?e.split(" "):e}function i(e){var t=v[e[p]];return t||(t={},d++,e[p]=d,v[d]=t),t}function s(e,n,r){n||(n=t);if(m)return n.createElement(e);r||(r=i(n));var s;return r.cache[e]?s=r.cache[e].cloneNode():c.test(e)?s=(r.cache[e]=r.createElem(e)).cloneNode():s=r.createElem(e),s.canHaveChildren&&!l.test(e)?r.frag.appendChild(s):s}function o(e,n){e||(e=t);if(m)return e.createDocumentFragment();n=n||i(e);var s=n.frag.cloneNode(),o=0,u=r(),a=u.length;for(;o<a;o++)s.createElement(u[o]);return s}function u(e,t){t.cache||(t.cache={},t.createElem=e.createElement,t.createFrag=e.createDocumentFragment,t.frag=t.createFrag()),e.createElement=function(n){return g.shivMethods?s(n,e,t):t.createElem(n)},e.createDocumentFragment=Function("h,f","return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&("+r().join().replace(/\w+/g,function(e){return t.createElem(e),t.frag.createElement(e),'c("'+e+'")'})+");return n}")(g,t.frag)}function a(e){e||(e=t);var r=i(e);return g.shivCSS&&!h&&!r.hasCSS&&(r.hasCSS=!!n(e,"article,aside,figcaption,figure,footer,header,hgroup,nav,section{display:block}mark{background:#FF0;color:#000}")),m||u(e,r),e}var f=e.html5||{},l=/^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,c=/^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,h,p="_html5shiv",d=0,v={},m;(function(){try{var e=t.createElement("a");e.innerHTML="<xyz></xyz>",h="hidden"in e,m=e.childNodes.length==1||function(){t.createElement("a");var e=t.createDocumentFragment();return typeof e.cloneNode=="undefined"||typeof e.createDocumentFragment=="undefined"||typeof e.createElement=="undefined"}()}catch(n){h=!0,m=!0}})();var g={elements:f.elements||"abbr article aside audio bdi canvas data datalist details figcaption figure footer header hgroup mark meter nav output progress section summary time video",shivCSS:f.shivCSS!==!1,supportsUnknownElements:m,shivMethods:f.shivMethods!==!1,type:"default",shivDocument:a,createElement:s,createDocumentFragment:o};e.html5=g,a(t)}(this,t),h._version=c,h._prefixes=E,h._domPrefixes=T,h._cssomPrefixes=x,h.mq=D,h.hasEvent=P,h.testProp=function(e){return u([e])},h.testAllProps=f,h.testStyles=_,h.prefixed=function(e,t,n){return t?f(e,t,n):f(e,"pfx")},d.className=d.className.replace(/(^|\s)no-js(\s|$)/,"$1$2")+(p?" js "+A.join(" "):""),h}(window,window.document),function(e,t,n){function r(e){return"[object Function]"==d.call(e)}function i(e){return"string"==typeof e}function s(){}function o(e){return!e||"loaded"==e||"complete"==e||"uninitialized"==e}function u(){var e=v.shift();m=1,e?e.t?h(function(){("c"==e.t?k.injectCss:k.injectJs)(e.s,0,e.a,e.x,e.e,1)},0):(e(),u()):m=0}function a(e,n,r,i,s,a,f){function l(t){if(!d&&o(c.readyState)&&(w.r=d=1,!m&&u(),c.onload=c.onreadystatechange=null,t)){"img"!=e&&h(function(){b.removeChild(c)},50);for(var r in T[n])T[n].hasOwnProperty(r)&&T[n][r].onload()}}var f=f||k.errorTimeout,c=t.createElement(e),d=0,g=0,w={t:r,s:n,e:s,a:a,x:f};1===T[n]&&(g=1,T[n]=[]),"object"==e?c.data=n:(c.src=n,c.type=e),c.width=c.height="0",c.onerror=c.onload=c.onreadystatechange=function(){l.call(this,g)},v.splice(i,0,w),"img"!=e&&(g||2===T[n]?(b.insertBefore(c,y?null:p),h(l,f)):T[n].push(c))}function f(e,t,n,r,s){return m=0,t=t||"j",i(e)?a("c"==t?E:w,e,t,this.i++,n,r,s):(v.splice(this.i++,0,e),1==v.length&&u()),this}function l(){var e=k;return e.loader={load:f,i:0},e}var c=t.documentElement,h=e.setTimeout,p=t.getElementsByTagName("script")[0],d={}.toString,v=[],m=0,g="MozAppearance"in c.style,y=g&&!!t.createRange().compareNode,b=y?c:p.parentNode,c=e.opera&&"[object Opera]"==d.call(e.opera),c=!!t.attachEvent&&!c,w=g?"object":c?"script":"img",E=c?"script":w,S=Array.isArray||function(e){return"[object Array]"==d.call(e)},x=[],T={},N={timeout:function(e,t){return t.length&&(e.timeout=t[0]),e}},C,k;k=function(e){function t(e){var e=e.split("!"),t=x.length,n=e.pop(),r=e.length,n={url:n,origUrl:n,prefixes:e},i,s,o;for(s=0;s<r;s++)o=e[s].split("="),(i=N[o.shift()])&&(n=i(n,o));for(s=0;s<t;s++)n=x[s](n);return n}function o(e,i,s,o,u){var a=t(e),f=a.autoCallback;a.url.split(".").pop().split("?").shift(),a.bypass||(i&&(i=r(i)?i:i[e]||i[o]||i[e.split("/").pop().split("?")[0]]),a.instead?a.instead(e,i,s,o,u):(T[a.url]?a.noexec=!0:T[a.url]=1,s.load(a.url,a.forceCSS||!a.forceJS&&"css"==a.url.split(".").pop().split("?").shift()?"c":n,a.noexec,a.attrs,a.timeout),(r(i)||r(f))&&s.load(function(){l(),i&&i(a.origUrl,u,o),f&&f(a.origUrl,u,o),T[a.url]=2})))}function u(e,t){function n(e,n){if(e){if(i(e))n||(f=function(){var e=[].slice.call(arguments);l.apply(this,e),c()}),o(e,f,t,0,u);else if(Object(e)===e)for(p in h=function(){var t=0,n;for(n in e)e.hasOwnProperty(n)&&t++;return t}(),e)e.hasOwnProperty(p)&&(!n&&!--h&&(r(f)?f=function(){var e=[].slice.call(arguments);l.apply(this,e),c()}:f[p]=function(e){return function(){var t=[].slice.call(arguments);e&&e.apply(this,t),c()}}(l[p])),o(e[p],f,t,p,u))}else!n&&c()}var u=!!e.test,a=e.load||e.both,f=e.callback||s,l=f,c=e.complete||s,h,p;n(u?e.yep:e.nope,!!a),a&&n(a)}var a,f,c=this.yepnope.loader;if(i(e))o(e,0,c,0);else if(S(e))for(a=0;a<e.length;a++)f=e[a],i(f)?o(f,0,c,0):S(f)?k(f):Object(f)===f&&u(f,c);else Object(e)===e&&u(e,c)},k.addPrefix=function(e,t){N[e]=t},k.addFilter=function(e){x.push(e)},k.errorTimeout=1e4,null==t.readyState&&t.addEventListener&&(t.readyState="loading",t.addEventListener("DOMContentLoaded",C=function(){t.removeEventListener("DOMContentLoaded",C,0),t.readyState="complete"},0)),e.yepnope=l(),e.yepnope.executeStack=u,e.yepnope.injectJs=function(e,n,r,i,a,f){var l=t.createElement("script"),c,d,i=i||k.errorTimeout;l.src=e;for(d in r)l.setAttribute(d,r[d]);n=f?u:n||s,l.onreadystatechange=l.onload=function(){!c&&o(l.readyState)&&(c=1,n(),l.onload=l.onreadystatechange=null)},h(function(){c||(c=1,n(1))},i),a?l.onload():p.parentNode.insertBefore(l,p)},e.yepnope.injectCss=function(e,n,r,i,o,a){var i=t.createElement("link"),f,n=a?u:n||s;i.href=e,i.rel="stylesheet",i.type="text/css";for(f in r)i.setAttribute(f,r[f]);o||(p.parentNode.insertBefore(i,p),h(n,0))}}(this,document),Modernizr.load=function(){yepnope.apply(window,[].slice.call(arguments,0))};

/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Swiper"] = __webpack_require__(423);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * ========================================================
	 * ========================================================
	 * = ATTENTION: Changes after line 705 because of PI-2009 =
	 * ========================================================
	 * ========================================================
	 *
	 * swiper 2.4.3
	 * Mobile touch slider and framework with hardware accelerated transitions
	 *
	 * http://www.idangero.us/sliders/swiper/
	 *
	 * Copyright 2010-2014, Vladimir Kharlampidi
	 * The iDangero.us
	 * http://www.idangero.us/
	 *
	 * Licensed under GPL & MIT
	 *
	 * Released on: January 29, 2014
	 */
	var Swiper = function (selector, params) {
		/*=========================
		 A little bit dirty but required part for IE8 and old FF support
		 ===========================*/
		if (document.body.__defineGetter__) {
			if (HTMLElement) {
				var element = HTMLElement.prototype;
				if (element.__defineGetter__) {
					element.__defineGetter__("outerHTML", function () { return new XMLSerializer().serializeToString(this); } );
				}
			}
		}
	
		if (!window.getComputedStyle) {
			window.getComputedStyle = function (el, pseudo) {
				this.el = el;
				this.getPropertyValue = function (prop) {
					var re = /(\-([a-z]){1})/g;
					if (prop === 'float') prop = 'styleFloat';
					if (re.test(prop)) {
						prop = prop.replace(re, function () {
							return arguments[2].toUpperCase();
						});
					}
					return el.currentStyle[prop] ? el.currentStyle[prop] : null;
				}
				return this;
			}
		}
		if (!Array.prototype.indexOf) {
			Array.prototype.indexOf = function(obj, start) {
				for (var i = (start || 0), j = this.length; i < j; i++) {
					if (this[i] === obj) { return i; }
				}
				return -1;
			}
		}
		if (!document.querySelectorAll) {
			if (!window.jQuery) return;
		}
		function $$(selector, context) {
			if (document.querySelectorAll)
				return (context || document).querySelectorAll(selector);
			else
				return jQuery(selector, context);
		}
	
		/*=========================
		 Check for correct selector
		 ===========================*/
		if(typeof selector === 'undefined') return;
	
		if(!(selector.nodeType)){
			if ($$(selector).length === 0) return;
		}
	
		/*=========================
		 _this
		 ===========================*/
		var _this = this;
	
		/*=========================
		 Default Flags and vars
		 ===========================*/
		_this.touches = {
			start:0,
			startX:0,
			startY:0,
			current:0,
			currentX:0,
			currentY:0,
			diff:0,
			abs:0
		};
		_this.positions = {
			start:0,
			abs:0,
			diff:0,
			current:0
		};
		_this.times = {
			start:0,
			end:0
		};
	
		_this.id = (new Date()).getTime();
		_this.container = (selector.nodeType) ? selector : $$(selector)[0];
		_this.isTouched = false;
		_this.isMoved = false;
		_this.activeIndex = 0;
		_this.centerIndex = 0;
		_this.activeLoaderIndex = 0;
		_this.activeLoopIndex = 0;
		_this.previousIndex = null;
		_this.velocity = 0;
		_this.snapGrid = [];
		_this.slidesGrid = [];
		_this.imagesToLoad = [];
		_this.imagesLoaded = 0;
		_this.wrapperLeft=0;
		_this.wrapperRight=0;
		_this.wrapperTop=0;
		_this.wrapperBottom=0;
		_this.isAndroid = navigator.userAgent.toLowerCase().indexOf('android')>=0;
		var wrapper, slideSize, wrapperSize, direction, isScrolling, containerSize;
	
		/*=========================
		 Default Parameters
		 ===========================*/
		var defaults = {
			eventTarget: 'wrapper', // or 'container'
			mode : 'horizontal', // or 'vertical'
			touchRatio : 1,
			speed : 300,
			freeMode : false,
			freeModeFluid : false,
			momentumRatio: 1,
			momentumBounce: true,
			momentumBounceRatio: 1,
			slidesPerView : 1,
			slidesPerGroup : 1,
			simulateTouch : true,
			followFinger : true,
			shortSwipes : true,
			longSwipesRatio: 0.5,
			moveStartThreshold:false,
			onlyExternal : false,
			createPagination : true,
			pagination : false,
			paginationElement: 'span',
			paginationClickable: false,
			paginationAsRange: true,
			resistance : true, // or false or 100%
			scrollContainer : false,
			preventLinks : true,
			preventLinksPropagation: false,
			noSwiping : false, // or class
			noSwipingClass : 'swiper-no-swiping', //:)
			initialSlide: 0,
			keyboardControl: false,
			mousewheelControl : false,
			mousewheelControlForceToAxis : false,
			useCSS3Transforms : true,
			// Autoplay
			autoplay: false,
			autoplayDisableOnInteraction: true,
			autoplayStopOnLast: false,
			//Loop mode
			loop:false,
			loopAdditionalSlides:0,
			//Auto Height
			calculateHeight: false,
			cssWidthAndHeight: false,
			//Images Preloader
			updateOnImagesReady : true,
			//Form elements
			releaseFormElements : true,
			//Watch for active slide, useful when use effects on different slide states
			watchActiveIndex: false,
			//Slides Visibility Fit
			visibilityFullFit : false,
			//Slides Offset
			offsetPxBefore : 0,
			offsetPxAfter : 0,
			offsetSlidesBefore : 0,
			offsetSlidesAfter : 0,
			centeredSlides: false,
			//Queue callbacks
			queueStartCallbacks : false,
			queueEndCallbacks : false,
			//Auto Resize
			autoResize : true,
			resizeReInit : false,
			//DOMAnimation
			DOMAnimation : true,
			//Slides Loader
			loader: {
				slides:[], //array with slides
				slidesHTMLType:'inner', // or 'outer'
				surroundGroups: 1, //keep preloaded slides groups around view
				logic: 'reload', //or 'change'
				loadAllSlides: false
			},
			//Namespace
			slideElement : 'div',
			slideClass : 'swiper-slide',
			slideActiveClass : 'swiper-slide-active',
			slideVisibleClass : 'swiper-slide-visible',
			slideDuplicateClass: 'swiper-slide-duplicate',
			wrapperClass : 'swiper-wrapper',
			paginationElementClass: 'swiper-pagination-switch',
			paginationActiveClass : 'swiper-active-switch',
			paginationVisibleClass : 'swiper-visible-switch'
		}
		params = params || {};
		for (var prop in defaults) {
			if (prop in params && typeof params[prop]==='object') {
				for (var subProp in defaults[prop]) {
					if (! (subProp in params[prop])) {
						params[prop][subProp] = defaults[prop][subProp];
					}
				}
			}
			else if (! (prop in params)) {
				params[prop] = defaults[prop]
			}
		}
		_this.params = params;
		if (params.scrollContainer) {
			params.freeMode = true;
			params.freeModeFluid = true;
		}
		if (params.loop) {
			params.resistance = '100%';
		}
		var isH = params.mode==='horizontal';
	
		/*=========================
		 Define Touch Events
		 ===========================*/
		var desktopEvents = ['mousedown','mousemove', 'mouseup'];
		if (_this.browser.ie10) desktopEvents = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp'];
		if (_this.browser.ie11) desktopEvents = ['pointerdown', 'pointermove', 'pointerup'];
	
		_this.touchEvents = {
			touchStart : _this.support.touch || !params.simulateTouch  ? 'touchstart' : desktopEvents[0],
			touchMove : _this.support.touch || !params.simulateTouch ? 'touchmove' : desktopEvents[1],
			touchEnd : _this.support.touch || !params.simulateTouch ? 'touchend' : desktopEvents[2]
		};
	
		/*=========================
		 Wrapper
		 ===========================*/
		for (var i = _this.container.childNodes.length - 1; i >= 0; i--) {
			if (_this.container.childNodes[i].className) {
				var _wrapperClasses = _this.container.childNodes[i].className.split(' ')
				for (var j = 0; j < _wrapperClasses.length; j++) {
					if (_wrapperClasses[j]===params.wrapperClass) {
						wrapper = _this.container.childNodes[i];
					}
				};
			}
		};
	
		_this.wrapper = wrapper;
		/*=========================
		 Slide API
		 ===========================*/
		_this._extendSwiperSlide = function  (el) {
			el.append = function () {
				if (params.loop) {
					el.insertAfter(_this.slides.length-_this.loopedSlides);
				}
				else {
					_this.wrapper.appendChild(el);
					_this.reInit();
				}
	
				return el;
			}
			el.prepend = function () {
				if (params.loop) {
					_this.wrapper.insertBefore(el, _this.slides[_this.loopedSlides]);
					_this.removeLoopedSlides();
					_this.calcSlides();
					_this.createLoop();
				}
				else {
					_this.wrapper.insertBefore(el, _this.wrapper.firstChild);
				}
				_this.reInit();
				return el;
			}
			el.insertAfter = function (index) {
				if(typeof index === 'undefined') return false;
				var beforeSlide;
	
				if (params.loop) {
					beforeSlide = _this.slides[index + 1 + _this.loopedSlides];
					if (beforeSlide) {
						_this.wrapper.insertBefore(el, beforeSlide);
					}
					else {
						_this.wrapper.appendChild(el);
					}
					_this.removeLoopedSlides();
					_this.calcSlides();
					_this.createLoop();
				}
				else {
					beforeSlide = _this.slides[index + 1];
					_this.wrapper.insertBefore(el, beforeSlide)
				}
				_this.reInit();
				return el;
			}
			el.clone = function () {
				return _this._extendSwiperSlide(el.cloneNode(true))
			}
			el.remove = function () {
				_this.wrapper.removeChild(el);
				_this.reInit();
			}
			el.html = function (html) {
				if (typeof html === 'undefined') {
					return el.innerHTML;
				}
				else {
					el.innerHTML = html;
					return el;
				}
			}
			el.index = function () {
				var index;
				for (var i = _this.slides.length - 1; i >= 0; i--) {
					if(el === _this.slides[i]) index = i;
				}
				return index;
			}
			el.isActive = function () {
				if (el.index() === _this.activeIndex) return true;
				else return false;
			}
			if (!el.swiperSlideDataStorage) el.swiperSlideDataStorage={};
			el.getData = function (name) {
				return el.swiperSlideDataStorage[name];
			}
			el.setData = function (name, value) {
				el.swiperSlideDataStorage[name] = value;
				return el;
			}
			el.data = function (name, value) {
				if (!value) {
					return el.getAttribute('data-'+name);
				}
				else {
					el.setAttribute('data-'+name,value);
					return el;
				}
			}
			el.getWidth = function (outer) {
				return _this.h.getWidth(el, outer);
			}
			el.getHeight = function (outer) {
				return _this.h.getHeight(el, outer);
			}
			el.getOffset = function() {
				return _this.h.getOffset(el);
			}
			return el;
		}
	
		//Calculate information about number of slides
		_this.calcSlides = function (forceCalcSlides) {
			var oldNumber = _this.slides ? _this.slides.length : false;
			_this.slides = [];
			_this.displaySlides = [];
			for (var i = 0; i < _this.wrapper.childNodes.length; i++) {
				if (_this.wrapper.childNodes[i].className) {
					var _className = _this.wrapper.childNodes[i].className;
					var _slideClasses = _className.split(' ');
					for (var j = 0; j < _slideClasses.length; j++) {
						if(_slideClasses[j]===params.slideClass) {
							_this.slides.push(_this.wrapper.childNodes[i]);
						}
					}
				}
			}
			for (i = _this.slides.length - 1; i >= 0; i--) {
				_this._extendSwiperSlide(_this.slides[i]);
			}
			if (oldNumber===false) return;
			if(oldNumber!==_this.slides.length || forceCalcSlides) {
	
				// Number of slides has been changed
				removeSlideEvents();
				addSlideEvents();
				_this.updateActiveSlide();
				if (_this.params.pagination) _this.createPagination();
				_this.callPlugins('numberOfSlidesChanged');
			}
		}
	
		//Create Slide
		_this.createSlide = function (html, slideClassList, el) {
			var slideClassList = slideClassList || _this.params.slideClass;
			var el = el||params.slideElement;
			var newSlide = document.createElement(el);
			newSlide.innerHTML = html||'';
			newSlide.className = slideClassList;
			return _this._extendSwiperSlide(newSlide);
		}
	
		//Append Slide
		_this.appendSlide = function (html, slideClassList, el) {
			if (!html) return;
			if (html.nodeType) {
				return _this._extendSwiperSlide(html).append()
			}
			else {
				return _this.createSlide(html, slideClassList, el).append()
			}
		}
		_this.prependSlide = function (html, slideClassList, el) {
			if (!html) return;
			if (html.nodeType) {
				return _this._extendSwiperSlide(html).prepend()
			}
			else {
				return _this.createSlide(html, slideClassList, el).prepend()
			}
		}
		_this.insertSlideAfter = function (index, html, slideClassList, el) {
			if (typeof index === 'undefined') return false;
			if (html.nodeType) {
				return _this._extendSwiperSlide(html).insertAfter(index);
			}
			else {
				return _this.createSlide(html, slideClassList, el).insertAfter(index);
			}
		}
		_this.removeSlide = function (index) {
			if (_this.slides[index]) {
				if (params.loop) {
					if (!_this.slides[index+_this.loopedSlides]) return false;
					_this.slides[index+_this.loopedSlides].remove();
					_this.removeLoopedSlides();
					_this.calcSlides();
					_this.createLoop();
				}
				else _this.slides[index].remove();
				return true;
			}
			else return false;
		}
		_this.removeLastSlide = function () {
			if (_this.slides.length>0) {
				if (params.loop) {
					_this.slides[_this.slides.length - 1 - _this.loopedSlides].remove();
					_this.removeLoopedSlides();
					_this.calcSlides();
					_this.createLoop();
				}
				else _this.slides[ (_this.slides.length-1) ].remove();
				return true;
			}
			else {
				return false;
			}
		}
		_this.removeAllSlides = function () {
			for (var i = _this.slides.length - 1; i >= 0; i--) {
				_this.slides[i].remove()
			}
		}
		_this.getSlide = function (index) {
			return _this.slides[index]
		}
		_this.getLastSlide = function () {
			return _this.slides[ _this.slides.length-1 ]
		}
		_this.getFirstSlide = function () {
			return _this.slides[0]
		}
	
		//Currently Active Slide
		_this.activeSlide = function () {
			return _this.slides[_this.activeIndex]
		}
	
		/*=========================
		 Wrapper for Callbacks : Allows additive callbacks via function arrays
		 ===========================*/
		_this.fireCallback = function() {
			var callback = arguments[0];
			if( Object.prototype.toString.call( callback ) === '[object Array]' ) {
				for (var i = 0; i < callback.length; i++) {
					if (typeof callback[i] === 'function') {
						callback[i](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5])
					}
				}
			} else if (Object.prototype.toString.call( callback ) === '[object String]') {
				if (params['on'+callback]) _this.fireCallback(params['on'+callback]);
			} else {
				callback(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
			}
		}
		function isArray (obj) {
			"use strict";
			if (Object.prototype.toString.apply( obj ) === '[object Array]') return true;
			return false;
		}
	
		/**
		 * Allows user to add callbacks, rather than replace them
		 * @param callback
		 * @param func
		 * @return {*}
		 */
		_this.addCallback = function (callback, func) {
			"use strict";
			var _this = this, tempFunc;
			if (_this.params['on' + callback]) {
				if (isArray(this.params['on' + callback])) {
					return this.params['on' + callback].push(func);
				} else if (typeof this.params['on' + callback] === 'function') {
					tempFunc = this.params['on' + callback];
					this.params['on' + callback] = [];
					this.params['on' + callback].push(tempFunc);
					return this.params['on' + callback].push(func);
				}
			} else {
				this.params['on' + callback] = [];
				return this.params['on' + callback].push(func);
			}
		}
		_this.removeCallbacks = function (callback) {
			if (_this.params['on' + callback]) {
				return _this.params['on' + callback] = null;
			}
		}
	
		/*=========================
		 Plugins API
		 ===========================*/
		var _plugins = [];
		for (var plugin in _this.plugins) {
			if (params[plugin]) {
				var p = _this.plugins[plugin](_this, params[plugin]);
				if (p) _plugins.push( p );
			}
		}
		_this.callPlugins = function(method, args) {
			if (!args) args = {}
			for (var i=0; i<_plugins.length; i++) {
				if (method in _plugins[i]) {
					_plugins[i][method](args);
				}
			}
		}
	
		/*=========================
		 Windows Phone 8 Fix
		 ===========================*/
		if ( (_this.browser.ie10 || _this.browser.ie11) && !params.onlyExternal) {
			_this.wrapper.classList.add('swiper-wp8-' + (isH ? 'horizontal' : 'vertical'));
		}
	
		/*=========================
		 Free Mode Class
		 ===========================*/
		if (params.freeMode) {
			_this.container.className+=' swiper-free-mode';
		}
	
		/*==================================================
		 Init/Re-init/Resize Fix
		 ====================================================*/
		_this.initialized = false;
		_this.init = function(force, forceCalcSlides) {
			var _width = _this.h.getWidth(_this.container);
			var _height = _this.h.getHeight(_this.container);
			if (_width===_this.width && _height===_this.height && !force) return;
			_this.width = _width;
			_this.height = _height;
	
			containerSize = isH ? _width : _height;
			var wrapper = _this.wrapper;
	
			if (force) {
				_this.calcSlides(forceCalcSlides);
			}
	
			if (params.slidesPerView==='auto') {
				//Auto mode
				var slidesWidth = 0;
				var slidesHeight = 0;
	
				//Unset Styles
				if (params.slidesOffset>0) {
					wrapper.style.paddingLeft = '';
					wrapper.style.paddingRight = '';
					wrapper.style.paddingTop = '';
					wrapper.style.paddingBottom = '';
				}
				wrapper.style.width = '';
				wrapper.style.height = '';
				if (params.offsetPxBefore>0) {
					if (isH) _this.wrapperLeft = params.offsetPxBefore;
					else _this.wrapperTop = params.offsetPxBefore;
				}
				if (params.offsetPxAfter>0) {
					if (isH) _this.wrapperRight = params.offsetPxAfter;
					else _this.wrapperBottom = params.offsetPxAfter;
				}
	
				if (params.centeredSlides) {
					if (isH) {
						_this.wrapperLeft = (containerSize - this.slides[0].getWidth(true) )/2;
						_this.wrapperRight = (containerSize - _this.slides[ _this.slides.length-1 ].getWidth(true))/2;
					}
					else {
						_this.wrapperTop = (containerSize - _this.slides[0].getHeight(true))/2;
						_this.wrapperBottom = (containerSize - _this.slides[ _this.slides.length-1 ].getHeight(true))/2;
					}
				}
	
				if (isH) {
					if (_this.wrapperLeft>=0) wrapper.style.paddingLeft = _this.wrapperLeft+'px';
					if (_this.wrapperRight>=0) wrapper.style.paddingRight = _this.wrapperRight+'px';
				}
				else {
					if (_this.wrapperTop>=0) wrapper.style.paddingTop = _this.wrapperTop+'px';
					if (_this.wrapperBottom>=0) wrapper.style.paddingBottom = _this.wrapperBottom+'px';
				}
				var slideLeft = 0;
				var centeredSlideLeft=0;
				_this.snapGrid = [];
				_this.slidesGrid = [];
	
				var slideMaxHeight = 0;
				for(var i = 0; i<_this.slides.length; i++) {
					var slideWidth = _this.slides[i].getWidth(true);
					var slideHeight = _this.slides[i].getHeight(true);
					if (params.calculateHeight) {
						slideMaxHeight = Math.max(slideMaxHeight, slideHeight)
					}
					var _slideSize = isH ? slideWidth : slideHeight;
					if (params.centeredSlides) {
						var nextSlideWidth = i === _this.slides.length-1 ? 0 : _this.slides[i+1].getWidth(true);
						var nextSlideHeight = i === _this.slides.length-1 ? 0 : _this.slides[i+1].getHeight(true);
						var nextSlideSize = isH ? nextSlideWidth : nextSlideHeight;
						if (_slideSize>containerSize) {
							for (var j=0; j<=Math.floor(_slideSize/(containerSize+_this.wrapperLeft)); j++) {
								if (j === 0) _this.snapGrid.push(slideLeft+_this.wrapperLeft);
								else _this.snapGrid.push(slideLeft+_this.wrapperLeft+containerSize*j);
							}
							_this.slidesGrid.push(slideLeft+_this.wrapperLeft);
						}
						else {
							_this.snapGrid.push(centeredSlideLeft);
							_this.slidesGrid.push(centeredSlideLeft);
						}
	
						centeredSlideLeft += _slideSize/2 + nextSlideSize/2;
	
					}
					else {
						if (_slideSize>containerSize) {
							for (var j=0; j<=Math.floor(_slideSize/containerSize); j++) {
								_this.snapGrid.push(slideLeft+containerSize*j);
							}
						}
						else {
							_this.snapGrid.push(slideLeft);
						}
						_this.slidesGrid.push(slideLeft);
					}
	
					slideLeft += _slideSize;
	
					slidesWidth += slideWidth;
					slidesHeight += slideHeight;
				}
				if (params.calculateHeight) _this.height = slideMaxHeight;
				if(isH) {
					wrapperSize = slidesWidth + _this.wrapperRight + _this.wrapperLeft;
					wrapper.style.width = (slidesWidth)+'px';
					wrapper.style.height = (_this.height)+'px';
				}
				else {
					wrapperSize = slidesHeight + _this.wrapperTop + _this.wrapperBottom;
					wrapper.style.width = (_this.width)+'px';
					wrapper.style.height = (slidesHeight)+'px';
				}
	
			}
			else if (params.scrollContainer) {
				//Scroll Container
				wrapper.style.width = '';
				wrapper.style.height = '';
				var wrapperWidth = _this.slides[0].getWidth(true);
				var wrapperHeight = _this.slides[0].getHeight(true);
				wrapperSize = isH ? wrapperWidth : wrapperHeight;
				wrapper.style.width = wrapperWidth+'px';
				wrapper.style.height = wrapperHeight+'px';
				slideSize = isH ? wrapperWidth : wrapperHeight;
	
			}
			else {
				// the width of the Elements have to be set first, because the
				// offsetHeight depends on the aspect ratio of the picture,
				// which cahnges with another width
				var slideWidth = isH ? _this.width / params.slidesPerView : _this.width;
	
				if (!params.cssWidthAndHeight) {
					for (var i = 0; i < _this.slides.length; i++) {
						if (parseFloat(slideWidth) > 0) {
							_this.slides[i].style.width = slideWidth + 'px';
						}
					}
				}
	
				//For usual slides
				if (params.calculateHeight) {
					var slideMaxHeight = 0;
					var wrapperHeight = 0;
					//ResetWrapperSize
					if (!isH) _this.container.style.height= '';
					wrapper.style.height='';
	
					for (var i=0; i<_this.slides.length; i++) {
						//ResetSlideSize
						_this.slides[i].style.height='';
						slideMaxHeight = Math.max( _this.slides[i].getHeight(true), slideMaxHeight );
						if (!isH) wrapperHeight+=_this.slides[i].getHeight(true);
					}
					var slideHeight = slideMaxHeight;
					_this.height = slideHeight;
	
					if (isH) wrapperHeight = slideHeight;
					else containerSize = slideHeight, _this.container.style.height= containerSize+'px';
				}
				else {
					var slideHeight = isH ? _this.height : _this.height/params.slidesPerView;
					var wrapperHeight = isH ? _this.height : _this.slides.length*slideHeight;
				}
				var wrapperWidth = isH ? _this.slides.length*slideWidth : _this.width;
				slideSize = isH ? slideWidth : slideHeight;
	
				if (params.offsetSlidesBefore>0) {
					if (isH) _this.wrapperLeft = slideSize*params.offsetSlidesBefore;
					else _this.wrapperTop = slideSize*params.offsetSlidesBefore;
				}
				if (params.offsetSlidesAfter>0) {
					if (isH) _this.wrapperRight = slideSize*params.offsetSlidesAfter;
					else _this.wrapperBottom = slideSize*params.offsetSlidesAfter;
				}
				if (params.offsetPxBefore>0) {
					if (isH) _this.wrapperLeft = params.offsetPxBefore;
					else _this.wrapperTop = params.offsetPxBefore;
				}
				if (params.offsetPxAfter>0) {
					if (isH) _this.wrapperRight = params.offsetPxAfter;
					else _this.wrapperBottom = params.offsetPxAfter;
				}
				if (params.centeredSlides) {
					if (isH) {
						_this.wrapperLeft = (containerSize - slideSize)/2;
						_this.wrapperRight = (containerSize - slideSize)/2;
					}
					else {
						_this.wrapperTop = (containerSize - slideSize)/2;
						_this.wrapperBottom = (containerSize - slideSize)/2;
					}
				}
				if (isH) {
					if (_this.wrapperLeft>0) wrapper.style.paddingLeft = _this.wrapperLeft+'px';
					if (_this.wrapperRight>0) wrapper.style.paddingRight = _this.wrapperRight+'px';
				}
				else {
					if (_this.wrapperTop>0) wrapper.style.paddingTop = _this.wrapperTop+'px';
					if (_this.wrapperBottom>0) wrapper.style.paddingBottom = _this.wrapperBottom+'px';
				}
	
				wrapperSize = isH ? wrapperWidth + _this.wrapperRight + _this.wrapperLeft : wrapperHeight + _this.wrapperTop + _this.wrapperBottom;
				if (!params.cssWidthAndHeight) {
					if (parseFloat(wrapperWidth) > 0) {
						wrapper.style.width = wrapperWidth+'px';
					}
					if (parseFloat(wrapperHeight) > 0) {
						wrapper.style.height = wrapperHeight+'px';
					}
				}
				var slideLeft = 0;
				_this.snapGrid = [];
				_this.slidesGrid = [];
				for (var i=0; i<_this.slides.length; i++) {
					_this.snapGrid.push(slideLeft);
					_this.slidesGrid.push(slideLeft);
					slideLeft+=slideSize;
					if (!params.cssWidthAndHeight) {
						if (parseFloat(slideHeight) > 0) {
							_this.slides[i].style.height = slideHeight+'px';
						}
					}
				}
	
			}
	
			if (!_this.initialized) {
				_this.callPlugins('onFirstInit');
				if (params.onFirstInit) _this.fireCallback(params.onFirstInit,_this);
			}
			else {
				_this.callPlugins('onInit');
				if (params.onInit) _this.fireCallback(params.onInit,_this);
			}
			_this.initialized = true;
		}
	
		_this.reInit = function (forceCalcSlides) {
			_this.init(true, forceCalcSlides);
		}
	
		_this.resizeFix = function (reInit) {
			_this.callPlugins('beforeResizeFix');
	
			_this.init(params.resizeReInit || reInit);
	
			// swipe to active slide in fixed mode
			if (!params.freeMode) {
				_this.swipeTo((params.loop ? _this.activeLoopIndex : _this.activeIndex), 0, false);
				// Fix autoplay
				if (params.autoplay) {
					if (_this.support.transitions && typeof autoplayTimeoutId !== 'undefined') {
						if (typeof autoplayTimeoutId !== 'undefined') {
							clearTimeout(autoplayTimeoutId);
							autoplayTimeoutId = undefined;
							_this.startAutoplay();
						}
					}
					else {
						if (typeof autoplayIntervalId !== 'undefined') {
							clearInterval(autoplayIntervalId)
							autoplayIntervalId = undefined;
							_this.startAutoplay();
						}
					}
				}
			}
	
			// move wrapper to the beginning in free mode
			else if (_this.getWrapperTranslate() < -maxWrapperPosition()) {
				_this.setWrapperTransition(0);
				_this.setWrapperTranslate(-maxWrapperPosition());
			}
	
			_this.callPlugins('afterResizeFix');
		}
	
		/*==========================================
		 Max and Min Positions
		 ============================================*/
		function maxWrapperPosition() {
			var a = (wrapperSize - containerSize);
			if (params.freeMode) {
				a = wrapperSize - containerSize;
			}
			// if (params.loop) a -= containerSize;
			if (params.slidesPerView > _this.slides.length) a = 0;
			if (a<0) a = 0;
			return a;
		}
		function minWrapperPosition() {
			var a = 0;
			// if (params.loop) a = containerSize;
			return a;
		}
	
		/*==========================================
		 Event Listeners
		 ============================================*/
		function initEvents() {
			var bind = _this.h.addEventListener;
			var eventTarget = params.eventTarget=='wrapper' ? _this.wrapper : _this.container;
			//Touch Events
			if (! (_this.browser.ie10 || _this.browser.ie11) ) {
				if (_this.support.touch) {
					bind(eventTarget, 'touchstart', onTouchStart);
					bind(eventTarget, 'touchmove', onTouchMove);
					bind(eventTarget, 'touchend', onTouchEnd);
				}
				if (params.simulateTouch) {
					bind(eventTarget, 'mousedown', onTouchStart);
					bind(document, 'mousemove', onTouchMove);
					bind(document, 'mouseup', onTouchEnd);
				}
			}
			else {
				bind(eventTarget, _this.touchEvents.touchStart, onTouchStart);
				bind(document, _this.touchEvents.touchMove, onTouchMove);
				bind(document, _this.touchEvents.touchEnd, onTouchEnd);
			}
	
			//Resize Event
			if (params.autoResize) {
				bind(window, 'resize', _this.resizeFix);
			}
			//Slide Events
			addSlideEvents();
			//Mousewheel
			_this._wheelEvent = false;
			if (params.mousewheelControl) {
				if ( document.onmousewheel !== undefined ) {
					_this._wheelEvent = "mousewheel";
				}
				try {
					WheelEvent("wheel");
					_this._wheelEvent = "wheel";
				} catch (e) {}
				if ( !_this._wheelEvent ) {
					_this._wheelEvent = "DOMMouseScroll";
				}
	
				if (_this._wheelEvent) {
					bind(_this.container, _this._wheelEvent, handleMousewheel);
				}
			}
	
			//Keyboard
			if (params.keyboardControl) {
				bind(document, 'keydown', handleKeyboardKeys);
			}
			if (params.updateOnImagesReady) {
				_this.imagesToLoad = $$('img', _this.container);
	
				for (var i=0; i<_this.imagesToLoad.length; i++) {
					_loadImage(_this.imagesToLoad[i].getAttribute('src'))
				}
			}
			function _loadImage(src) {
				var image = new Image();
				image.onload = function () {
					if (typeof _this === 'undefined' || _this === null) return;
					if (_this.imagesLoaded !== undefined) _this.imagesLoaded++;
					if (_this.imagesLoaded === _this.imagesToLoad.length) {
						_this.reInit();
						if (params.onImagesReady) _this.fireCallback(params.onImagesReady, _this);
					}
				};
				image.src = src;
			}
		}
	
		//Remove Event Listeners
		_this.destroy = function(){
			var unbind = _this.h.removeEventListener;
			var eventTarget = params.eventTarget=='wrapper' ? _this.wrapper : _this.container;
			//Touch Events
			if (! (_this.browser.ie10 || _this.browser.ie11) ) {
				if (_this.support.touch) {
					unbind(eventTarget, 'touchstart', onTouchStart);
					unbind(eventTarget, 'touchmove', onTouchMove);
					unbind(eventTarget, 'touchend', onTouchEnd);
				}
				if (params.simulateTouch) {
					unbind(eventTarget, 'mousedown', onTouchStart);
					unbind(document, 'mousemove', onTouchMove);
					unbind(document, 'mouseup', onTouchEnd);
				}
			}
			else {
				unbind(eventTarget, _this.touchEvents.touchStart, onTouchStart);
				unbind(document, _this.touchEvents.touchMove, onTouchMove);
				unbind(document, _this.touchEvents.touchEnd, onTouchEnd);
			}
	
			//Resize Event
			if (params.autoResize) {
				unbind(window, 'resize', _this.resizeFix);
			}
	
			//Init Slide Events
			removeSlideEvents();
	
			//Pagination
			if (params.paginationClickable) {
				removePaginationEvents();
			}
	
			//Mousewheel
			if (params.mousewheelControl && _this._wheelEvent) {
				unbind(_this.container, _this._wheelEvent, handleMousewheel);
			}
	
			//Keyboard
			if (params.keyboardControl) {
				unbind(document, 'keydown', handleKeyboardKeys);
			}
	
			//Stop autoplay
			if (params.autoplay) {
				_this.stopAutoplay();
			}
			_this.callPlugins('onDestroy');
	
			//Destroy variable
			_this = null;
		}
		function addSlideEvents() {
			var bind = _this.h.addEventListener,
				i;
	
			//Prevent Links Events
			if (params.preventLinks) {
				var links = $$('a', _this.container);
				for (i=0; i<links.length; i++) {
					bind(links[i], 'click', preventClick);
				}
			}
			//Release Form Elements
			if (params.releaseFormElements) {
				var formElements = $$('input, textarea, select', _this.container);
				for (i=0; i<formElements.length; i++) {
					bind(formElements[i], _this.touchEvents.touchStart, releaseForms, true);
				}
			}
	
			//Slide Clicks & Touches
			if (params.onSlideClick) {
				for (i=0; i<_this.slides.length; i++) {
					bind(_this.slides[i], 'click', slideClick);
				}
			}
			if (params.onSlideTouch) {
				for (i=0; i<_this.slides.length; i++) {
					bind(_this.slides[i], _this.touchEvents.touchStart, slideTouch);
				}
			}
		}
		function removeSlideEvents() {
			var unbind = _this.h.removeEventListener,
				i;
	
			//Slide Clicks & Touches
			if (params.onSlideClick) {
				for (i=0; i<_this.slides.length; i++) {
					unbind(_this.slides[i], 'click', slideClick);
				}
			}
			if (params.onSlideTouch) {
				for (i=0; i<_this.slides.length; i++) {
					unbind(_this.slides[i], _this.touchEvents.touchStart, slideTouch);
				}
			}
			//Release Form Elements
			if (params.releaseFormElements) {
				var formElements = $$('input, textarea, select', _this.container);
				for (i=0; i<formElements.length; i++) {
					unbind(formElements[i], _this.touchEvents.touchStart, releaseForms, true);
				}
			}
			//Prevent Links Events
			if (params.preventLinks) {
				var links = $$('a', _this.container);
				for (i=0; i<links.length; i++) {
					unbind(links[i], 'click', preventClick);
				}
			}
		}
		/*==========================================
		 Keyboard Control
		 ============================================*/
		function handleKeyboardKeys (e) {
			var kc = e.keyCode || e.charCode;
			if (kc==37 || kc==39 || kc==38 || kc==40) {
				var inView = false;
				//Check that swiper should be inside of visible area of window
				var swiperOffset = _this.h.getOffset( _this.container );
				var scrollLeft = _this.h.windowScroll().left;
				var scrollTop = _this.h.windowScroll().top;
				var windowWidth = _this.h.windowWidth();
				var windowHeight = _this.h.windowHeight();
				var swiperCoord = [
					[swiperOffset.left, swiperOffset.top],
					[swiperOffset.left + _this.width, swiperOffset.top],
					[swiperOffset.left, swiperOffset.top + _this.height],
					[swiperOffset.left + _this.width, swiperOffset.top + _this.height]
				]
				for (var i=0; i<swiperCoord.length; i++) {
					var point = swiperCoord[i];
					if (
						point[0]>=scrollLeft && point[0]<=scrollLeft+windowWidth &&
							point[1]>=scrollTop && point[1]<=scrollTop+windowHeight
						) {
						inView = true;
					}
	
				}
				if (!inView) return;
			}
			if (isH) {
				if (kc==37 || kc==39) {
					if (e.preventDefault) e.preventDefault();
					else e.returnValue = false;
				}
				if (kc == 39) _this.swipeNext();
				if (kc == 37) _this.swipePrev();
			}
			else {
				if (kc==38 || kc==40) {
					if (e.preventDefault) e.preventDefault();
					else e.returnValue = false;
				}
				if (kc == 40) _this.swipeNext();
				if (kc == 38) _this.swipePrev();
			}
		}
	
		/*==========================================
		 Mousewheel Control
		 ============================================*/
		var lastScrollTime = (new Date()).getTime();
		function handleMousewheel (e) {
			var we = _this._wheelEvent;
			var delta = 0;
	
			//Opera & IE
			if (e.detail) delta = -e.detail;
			//WebKits
			else if (we == 'mousewheel') {
				if (params.mousewheelControlForceToAxis) {
					if (isH) {
						if (Math.abs(e.wheelDeltaX)>Math.abs(e.wheelDeltaY)) delta = e.wheelDeltaX;
						else return;
					}
					else {
						if (Math.abs(e.wheelDeltaY)>Math.abs(e.wheelDeltaX)) delta = e.wheelDeltaY;
						else return;
					}
				}
				else {
					delta = e.wheelDelta;
				}
			}
			//Old FireFox
			else if (we == 'DOMMouseScroll') delta = -e.detail;
			//New FireFox
			else if (we == 'wheel') {
				if (params.mousewheelControlForceToAxis) {
					if (isH) {
						if (Math.abs(e.deltaX)>Math.abs(e.deltaY)) delta = -e.deltaX;
						else return;
					}
					else {
						if (Math.abs(e.deltaY)>Math.abs(e.deltaX)) delta = -e.deltaY;
						else return;
					}
				}
				else {
					delta = Math.abs(e.deltaX)>Math.abs(e.deltaY) ? - e.deltaX : - e.deltaY;
				}
			}
	
			if (!params.freeMode) {
				if ((new Date()).getTime() - lastScrollTime > 60) {
					if(delta<0) _this.swipeNext();
					else _this.swipePrev();
				}
				lastScrollTime = (new Date()).getTime();
	
			}
			else {
				//Freemode or scrollContainer:
				var position = _this.getWrapperTranslate() + delta;
	
				if (position > 0) position = 0;
				if (position < -maxWrapperPosition()) position = -maxWrapperPosition();
	
				_this.setWrapperTransition(0);
				_this.setWrapperTranslate(position);
				_this.updateActiveSlide(position);
	
				// Return page scroll on edge positions
				if (position == 0 || position == -maxWrapperPosition()) return;
			}
			if (params.autoplay) _this.stopAutoplay(true);
	
			if(e.preventDefault) e.preventDefault();
			else e.returnValue = false;
			return false;
		}
	
		/*=========================
		 Grab Cursor
		 ===========================*/
		if (params.grabCursor) {
			var containerStyle = _this.container.style;
			containerStyle.cursor = 'move';
			containerStyle.cursor = 'grab';
			containerStyle.cursor = '-moz-grab';
			containerStyle.cursor = '-webkit-grab';
		}
	
		/*=========================
		 Slides Events Handlers
		 ===========================*/
	
		_this.allowSlideClick = true;
		function slideClick(event) {
			if (_this.allowSlideClick) {
				setClickedSlide(event);
				_this.fireCallback(params.onSlideClick, _this, event);
			}
		}
	
		function slideTouch(event) {
			setClickedSlide(event);
			_this.fireCallback(params.onSlideTouch, _this, event);
		}
	
		function setClickedSlide(event) {
	
			// IE 6-8 support
			if (!event.currentTarget) {
				var element = event.srcElement;
				do {
					if (element.className.indexOf(params.slideClass) > -1) {
						break;
					}
				}
				while (element = element.parentNode);
				_this.clickedSlide = element;
			}
			else {
				_this.clickedSlide = event.currentTarget;
			}
	
			_this.clickedSlideIndex     = _this.slides.indexOf(_this.clickedSlide);
			_this.clickedSlideLoopIndex = _this.clickedSlideIndex - (_this.loopedSlides || 0);
		}
	
		_this.allowLinks = true;
		function preventClick(e) {
			if (!_this.allowLinks) {
				if(e.preventDefault) e.preventDefault();
				else e.returnValue = false;
				if (params.preventLinksPropagation && 'stopPropagation' in e) {
					e.stopPropagation();
				}
				return false;
			}
		}
		function releaseForms(e) {
			if (e.stopPropagation) e.stopPropagation();
			else e.returnValue = false;
			return false;
	
		}
	
		/*==================================================
		 Event Handlers
		 ====================================================*/
		var isTouchEvent = false;
		var allowThresholdMove;
		var allowMomentumBounce = true;
		function onTouchStart(event) {
			if (params.preventLinks) _this.allowLinks = true;
			//Exit if slider is already was touched
			if (_this.isTouched || params.onlyExternal) {
				return false;
			}
	
			if (params.noSwiping && (event.target || event.srcElement) && noSwipingSlide(event.target || event.srcElement)) return false;
			allowMomentumBounce = false;
			// Reset threshold
			thresholdFirstMove = false;
			//Check For Nested Swipers
			_this.isTouched = true;
			isTouchEvent = event.type=='touchstart';
	
			if (!isTouchEvent || event.targetTouches.length == 1 ) {
				_this.callPlugins('onTouchStartBegin');
	
				if(!isTouchEvent && !_this.isAndroid) {
					if(event.preventDefault) event.preventDefault();
					else event.returnValue = false;
				}
	
				var pageX = isTouchEvent ? event.targetTouches[0].pageX : (event.pageX || event.clientX);
				var pageY = isTouchEvent ? event.targetTouches[0].pageY : (event.pageY || event.clientY);
	
				//Start Touches to check the scrolling
				_this.touches.startX = _this.touches.currentX = pageX;
				_this.touches.startY = _this.touches.currentY = pageY;
	
				_this.touches.start = _this.touches.current = isH ? pageX : pageY;
	
				//Set Transition Time to 0
				_this.setWrapperTransition(0);
	
				//Get Start Translate Position
				_this.positions.start = _this.positions.current = _this.getWrapperTranslate();
	
				//Set Transform
				_this.setWrapperTranslate(_this.positions.start);
	
				//TouchStartTime
				_this.times.start = (new Date()).getTime();
	
				//Unset Scrolling
				isScrolling = undefined;
	
				//Set Treshold
				if (params.moveStartThreshold>0) {
					allowThresholdMove = false;
				}
	
				//CallBack
				if (params.onTouchStart) _this.fireCallback(params.onTouchStart, _this);
				_this.callPlugins('onTouchStartEnd');
	
			}
		}
		var velocityPrevPosition, velocityPrevTime;
		function onTouchMove(event) {
			// If slider is not touched - exit
			if (!_this.isTouched || params.onlyExternal) return;
			if (isTouchEvent && event.type=='mousemove') return;
	
			var pageX = isTouchEvent ? event.targetTouches[0].pageX : (event.pageX || event.clientX);
			var pageY = isTouchEvent ? event.targetTouches[0].pageY : (event.pageY || event.clientY);
	
			//check for scrolling
			if ( typeof isScrolling === 'undefined' && isH) {
				isScrolling = !!( isScrolling || Math.abs(pageY - _this.touches.startY) > Math.abs( pageX - _this.touches.startX ) );
			}
			if ( typeof isScrolling === 'undefined' && !isH) {
				isScrolling = !!( isScrolling || Math.abs(pageY - _this.touches.startY) < Math.abs( pageX - _this.touches.startX ) );
			}
			if (isScrolling ) {
				_this.isTouched = false;
				return;
			}
	
			//Check For Nested Swipers
			if (event.assignedToSwiper) {
				_this.isTouched = false;
				return;
			}
			event.assignedToSwiper = true;
	
			//Block inner links
			if (params.preventLinks) {
				_this.allowLinks = false;
			}
			if (params.onSlideClick) {
				_this.allowSlideClick = false;
			}
	
			//Stop AutoPlay if exist
			if (params.autoplay) {
				_this.stopAutoplay(true);
			}
			if (!isTouchEvent || event.touches.length == 1) {
	
				//Moved Flag
				if (!_this.isMoved) {
					_this.callPlugins('onTouchMoveStart');
	
					if (params.loop) {
						_this.fixLoop();
						_this.positions.start = _this.getWrapperTranslate();
					}
					if (params.onTouchMoveStart) _this.fireCallback(params.onTouchMoveStart, _this);
				}
				_this.isMoved = true;
	
				// cancel event
				if(event.preventDefault) event.preventDefault();
				else event.returnValue = false;
	
				_this.touches.current = isH ? pageX : pageY ;
	
				_this.positions.current = (_this.touches.current - _this.touches.start) * params.touchRatio + _this.positions.start;
	
				//Resistance Callbacks
				if(_this.positions.current > 0 && params.onResistanceBefore) {
					_this.fireCallback(params.onResistanceBefore, _this, _this.positions.current);
				}
				if(_this.positions.current < -maxWrapperPosition() && params.onResistanceAfter) {
					_this.fireCallback(params.onResistanceAfter, _this, Math.abs(_this.positions.current + maxWrapperPosition()));
				}
				//Resistance
				if (params.resistance && params.resistance!='100%') {
					//Resistance for Negative-Back sliding
					if(_this.positions.current > 0) {
						var resistance = 1 - _this.positions.current/containerSize/2;
						if (resistance < 0.5)
							_this.positions.current = (containerSize/2);
						else
							_this.positions.current = _this.positions.current * resistance;
					}
					//Resistance for After-End Sliding
					if ( _this.positions.current < -maxWrapperPosition() ) {
	
						var diff = (_this.touches.current - _this.touches.start)*params.touchRatio + (maxWrapperPosition()+_this.positions.start);
						var resistance = (containerSize+diff)/(containerSize);
						var newPos = _this.positions.current-diff*(1-resistance)/2;
						var stopPos = -maxWrapperPosition() - containerSize/2;
	
						if (newPos < stopPos || resistance<=0)
							_this.positions.current = stopPos;
						else
							_this.positions.current = newPos;
					}
				}
				if (params.resistance && params.resistance=='100%') {
					//Resistance for Negative-Back sliding
					if(_this.positions.current > 0 && !(params.freeMode&&!params.freeModeFluid)) {
						_this.positions.current = 0;
					}
					//Resistance for After-End Sliding
					if ( (_this.positions.current) < -maxWrapperPosition() && !(params.freeMode&&!params.freeModeFluid)) {
						_this.positions.current = -maxWrapperPosition();
					}
				}
				//Move Slides
				if (!params.followFinger) return;
	
				if (!params.moveStartThreshold) {
					_this.setWrapperTranslate(_this.positions.current);
				}
				else {
					if ( Math.abs(_this.touches.current - _this.touches.start)>params.moveStartThreshold || allowThresholdMove) {
						if (!allowThresholdMove) {
							allowThresholdMove = true;
							_this.touches.start = _this.touches.current;
							return
						}
						_this.setWrapperTranslate(_this.positions.current);
					}
					else {
						_this.positions.current = _this.positions.start;
					}
				}
	
				if (params.freeMode || params.watchActiveIndex) {
					_this.updateActiveSlide(_this.positions.current);
				}
	
				//Grab Cursor
				if (params.grabCursor) {
					_this.container.style.cursor = 'move';
					_this.container.style.cursor = 'grabbing';
					_this.container.style.cursor = '-moz-grabbin';
					_this.container.style.cursor = '-webkit-grabbing';
				}
				//Velocity
				if (!velocityPrevPosition) velocityPrevPosition = _this.touches.current;
				if (!velocityPrevTime) velocityPrevTime = (new Date).getTime();
				_this.velocity = (_this.touches.current - velocityPrevPosition)/((new Date).getTime() - velocityPrevTime)/2;
				if (Math.abs(_this.touches.current - velocityPrevPosition)<2) _this.velocity=0;
				velocityPrevPosition = _this.touches.current;
				velocityPrevTime = (new Date).getTime();
				//Callbacks
				_this.callPlugins('onTouchMoveEnd');
				if (params.onTouchMove) _this.fireCallback(params.onTouchMove, _this);
	
				return false;
			}
		}
		function onTouchEnd(event) {
			//Check For scrolling
			if (isScrolling) {
				_this.swipeReset();
			}
			// If slider is not touched exit
			if ( params.onlyExternal || !_this.isTouched ) return;
			_this.isTouched = false
	
			//Return Grab Cursor
			if (params.grabCursor) {
				_this.container.style.cursor = 'move';
				_this.container.style.cursor = 'grab';
				_this.container.style.cursor = '-moz-grab';
				_this.container.style.cursor = '-webkit-grab';
			}
	
			//Check for Current Position
			if (!_this.positions.current && _this.positions.current!==0) {
				_this.positions.current = _this.positions.start
			}
	
			//For case if slider touched but not moved
			if (params.followFinger) {
				_this.setWrapperTranslate(_this.positions.current);
			}
	
			// TouchEndTime
			_this.times.end = (new Date()).getTime();
	
			//Difference
			_this.touches.diff = _this.touches.current - _this.touches.start
			_this.touches.abs = Math.abs(_this.touches.diff)
	
			_this.positions.diff = _this.positions.current - _this.positions.start
			_this.positions.abs = Math.abs(_this.positions.diff)
	
			var diff = _this.positions.diff ;
			var diffAbs =_this.positions.abs ;
			var timeDiff = _this.times.end - _this.times.start
	
			if(diffAbs < 5 && (timeDiff) < 300 && _this.allowLinks == false) {
				if (!params.freeMode && diffAbs!=0) _this.swipeReset()
				//Release inner links
				if (params.preventLinks) {
					_this.allowLinks = true;
				}
				if (params.onSlideClick) {
					_this.allowSlideClick = true;
				}
			}
	
			setTimeout(function () {
				//Release inner links
				if (params.preventLinks) {
					_this.allowLinks = true;
				}
				if (params.onSlideClick) {
					_this.allowSlideClick = true;
				}
			}, 100);
	
			var maxPosition = maxWrapperPosition();
	
			//Not moved or Prevent Negative Back Sliding/After-End Sliding
			if (!_this.isMoved && params.freeMode) {
				_this.isMoved = false;
				if (params.onTouchEnd) _this.fireCallback(params.onTouchEnd, _this);
				_this.callPlugins('onTouchEnd');
				return;
			}
			if (!_this.isMoved || _this.positions.current > 0 || _this.positions.current < -maxPosition) {
				_this.swipeReset();
				if (params.onTouchEnd) _this.fireCallback(params.onTouchEnd, _this);
				_this.callPlugins('onTouchEnd');
				return;
			}
	
			_this.isMoved = false;
	
			//Free Mode
			if (params.freeMode) {
				if ( params.freeModeFluid ) {
					var momentumDuration = 1000*params.momentumRatio;
					var momentumDistance = _this.velocity*momentumDuration;
					var newPosition = _this.positions.current + momentumDistance
					var doBounce = false;
					var afterBouncePosition;
					var bounceAmount = Math.abs( _this.velocity )*20*params.momentumBounceRatio;
					if (newPosition < -maxPosition) {
						if (params.momentumBounce && _this.support.transitions) {
							if (newPosition + maxPosition < -bounceAmount) newPosition = -maxPosition-bounceAmount;
							afterBouncePosition = -maxPosition;
							doBounce=true;
							allowMomentumBounce = true;
						}
						else newPosition = -maxPosition;
					}
					if (newPosition > 0) {
						if (params.momentumBounce && _this.support.transitions) {
							if (newPosition>bounceAmount) newPosition = bounceAmount;
							afterBouncePosition = 0
							doBounce = true;
							allowMomentumBounce = true;
						}
						else newPosition = 0;
					}
					//Fix duration
					if (_this.velocity!=0) momentumDuration = Math.abs((newPosition - _this.positions.current)/_this.velocity)
	
					_this.setWrapperTranslate(newPosition);
	
					_this.setWrapperTransition( momentumDuration );
	
					if (params.momentumBounce && doBounce) {
						_this.wrapperTransitionEnd(function () {
							if (!allowMomentumBounce) return;
							if (params.onMomentumBounce) _this.fireCallback(params.onMomentumBounce, _this);
							_this.callPlugins('onMomentumBounce');
	
							_this.setWrapperTranslate(afterBouncePosition);
							_this.setWrapperTransition(300);
						})
					}
	
					_this.updateActiveSlide(newPosition)
				}
				if (!params.freeModeFluid || timeDiff >= 300) _this.updateActiveSlide(_this.positions.current)
	
				if (params.onTouchEnd) _this.fireCallback(params.onTouchEnd, _this);
				_this.callPlugins('onTouchEnd');
				return;
			}
	
			//Direction
			direction = diff < 0 ? "toNext" : "toPrev"
	
			//Short Touches
			if (direction=="toNext" && ( timeDiff <= 300 ) ) {
				if (diffAbs < 30 || !params.shortSwipes) _this.swipeReset()
				else _this.swipeNext(true);
			}
	
			if (direction=="toPrev" && ( timeDiff <= 300 ) ) {
				if (diffAbs < 30 || !params.shortSwipes) _this.swipeReset()
				else _this.swipePrev(true);
			}
	
			//Long Touches
			var targetSlideSize = 0;
			if(params.slidesPerView == 'auto') {
				//Define current slide's width
				var currentPosition = Math.abs(_this.getWrapperTranslate());
				var slidesOffset = 0;
				var _slideSize;
				for (var i=0; i<_this.slides.length; i++) {
					_slideSize = isH ? _this.slides[i].getWidth(true) : _this.slides[i].getHeight(true);
					slidesOffset+= _slideSize;
					if (slidesOffset>currentPosition) {
						targetSlideSize = _slideSize;
						break;
					}
				}
				if (targetSlideSize>containerSize) targetSlideSize = containerSize;
			}
			else {
				targetSlideSize = slideSize * params.slidesPerView;
			}
			if (direction=="toNext" && ( timeDiff > 300 ) ) {
				if (diffAbs >= targetSlideSize*params.longSwipesRatio) {
					_this.swipeNext(true)
				}
				else {
					_this.swipeReset()
				}
			}
			if (direction=="toPrev" && ( timeDiff > 300 ) ) {
				if (diffAbs >= targetSlideSize*params.longSwipesRatio) {
					_this.swipePrev(true);
				}
				else {
					_this.swipeReset()
				}
			}
			if (params.onTouchEnd) _this.fireCallback(params.onTouchEnd, _this);
			_this.callPlugins('onTouchEnd');
		}
	
	
		/*==================================================
		 noSwiping Bubble Check by Isaac Strack
		 ====================================================*/
		function noSwipingSlide(el){
			/*This function is specifically designed to check the parent elements for the noSwiping class, up to the wrapper.
			 We need to check parents because while onTouchStart bubbles, _this.isTouched is checked in onTouchStart, which stops the bubbling.
			 So, if a text box, for example, is the initial target, and the parent slide container has the noSwiping class, the _this.isTouched
			 check will never find it, and what was supposed to be noSwiping is able to be swiped.
			 This function will iterate up and check for the noSwiping class in parents, up through the wrapperClass.*/
	
			// First we create a truthy variable, which is that swiping is allowd (noSwiping = false)
			var noSwiping = false;
	
			// Now we iterate up (parentElements) until we reach the node with the wrapperClass.
			do{
	
				// Each time, we check to see if there's a 'swiper-no-swiping' class (noSwipingClass).
				if (el.className.indexOf(params.noSwipingClass)>-1)
				{
					noSwiping = true; // If there is, we set noSwiping = true;
				}
	
				el = el.parentElement;  // now we iterate up (parent node)
	
			} while(!noSwiping && el.parentElement && el.className.indexOf(params.wrapperClass)==-1); // also include el.parentElement truthy, just in case.
	
			// because we didn't check the wrapper itself, we do so now, if noSwiping is false:
			if (!noSwiping && el.className.indexOf(params.wrapperClass)>-1 && el.className.indexOf(params.noSwipingClass)>-1)
				noSwiping = true; // if the wrapper has the noSwipingClass, we set noSwiping = true;
	
			return noSwiping;
		}
	
		function addClassToHtmlString(klass, outerHtml) {
			var par = document.createElement('div');
			var child;
	
			par.innerHTML = outerHtml;
			child = par.firstChild;
			child.className += ' '+ klass;
	
			return child.outerHTML;
		}
	
	
		/*==================================================
		 Swipe Functions
		 ====================================================*/
		_this.swipeNext = function(internal){
			if (!internal && params.loop) _this.fixLoop();
			if (!internal && params.autoplay) _this.stopAutoplay(true);
			_this.callPlugins('onSwipeNext');
			var currentPosition = _this.getWrapperTranslate();
			var newPosition = currentPosition;
			if (params.slidesPerView=='auto') {
				for (var i=0; i<_this.snapGrid.length; i++) {
					if (-currentPosition >= _this.snapGrid[i] && -currentPosition<_this.snapGrid[i+1]) {
						newPosition = -_this.snapGrid[i+1]
						break;
					}
				}
			}
			else {
				var groupSize = slideSize * params.slidesPerGroup;
				newPosition = -(Math.floor(Math.abs(currentPosition)/Math.floor(groupSize))*groupSize + groupSize);
			}
			if (newPosition < - maxWrapperPosition()) {
				newPosition = - maxWrapperPosition()
			};
			if (newPosition == currentPosition) return false;
			swipeToPosition(newPosition, 'next');
			return true
		}
		_this.swipePrev = function(internal){
			if (!internal && params.loop) _this.fixLoop();
			if (!internal && params.autoplay) _this.stopAutoplay(true);
			_this.callPlugins('onSwipePrev');
	
			var currentPosition = Math.ceil(_this.getWrapperTranslate());
			var newPosition;
			if (params.slidesPerView=='auto') {
				newPosition = 0;
				for (var i=1; i<_this.snapGrid.length; i++) {
					if (-currentPosition == _this.snapGrid[i]) {
						newPosition = -_this.snapGrid[i-1]
						break;
					}
					if (-currentPosition > _this.snapGrid[i] && -currentPosition<_this.snapGrid[i+1]) {
						newPosition = -_this.snapGrid[i]
						break;
					}
				}
			}
			else {
				var groupSize = slideSize * params.slidesPerGroup;
				newPosition = -(Math.ceil(-currentPosition/groupSize)-1)*groupSize;
			}
	
			if (newPosition > 0) newPosition = 0;
	
			if (newPosition == currentPosition) return false;
			swipeToPosition(newPosition, 'prev');
			return true;
	
		}
		_this.swipeReset = function(){
			_this.callPlugins('onSwipeReset');
			var currentPosition = _this.getWrapperTranslate();
			var groupSize = slideSize * params.slidesPerGroup;
			var newPosition;
			var maxPosition = -maxWrapperPosition();
			if (params.slidesPerView=='auto') {
				newPosition = 0;
				for (var i=0; i<_this.snapGrid.length; i++) {
					if (-currentPosition===_this.snapGrid[i]) return;
					if (-currentPosition >= _this.snapGrid[i] && -currentPosition<_this.snapGrid[i+1]) {
						if(_this.positions.diff>0) newPosition = -_this.snapGrid[i+1]
						else newPosition = -_this.snapGrid[i]
						break;
					}
				}
				if (-currentPosition >= _this.snapGrid[_this.snapGrid.length-1]) newPosition = -_this.snapGrid[_this.snapGrid.length-1];
				if (currentPosition <= -maxWrapperPosition()) newPosition = -maxWrapperPosition()
			}
			else {
				newPosition = currentPosition<0 ? Math.round(currentPosition/groupSize)*groupSize : 0
			}
			if (params.scrollContainer)  {
				newPosition = currentPosition<0 ? currentPosition : 0;
			}
			if (newPosition < -maxWrapperPosition()) {
				newPosition = -maxWrapperPosition()
			}
			if (params.scrollContainer && (containerSize>slideSize)) {
				newPosition = 0;
			}
	
			if (newPosition == currentPosition) return false;
	
			swipeToPosition(newPosition, 'reset');
			return true;
		}
	
		_this.swipeTo = function(index, speed, runCallbacks) {
			index = parseInt(index, 10);
			_this.callPlugins('onSwipeTo', {index:index, speed:speed});
			if (params.loop) index = index + _this.loopedSlides;
			var currentPosition = _this.getWrapperTranslate();
			if (index > (_this.slides.length-1) || index < 0) return;
			var newPosition
			if (params.slidesPerView=='auto') {
				newPosition = -_this.slidesGrid[ index ];
			}
			else {
				newPosition =  -index*slideSize;
			}
			if (newPosition < - maxWrapperPosition()) {
				newPosition = - maxWrapperPosition();
			};
	
			if (newPosition == currentPosition) return false;
	
			runCallbacks = runCallbacks===false ? false : true;
			swipeToPosition(newPosition, 'to', {index:index, speed:speed, runCallbacks:runCallbacks});
			return true;
		}
	
		function swipeToPosition(newPosition, action, toOptions) {
			var speed = (action=='to' && toOptions.speed >= 0) ? toOptions.speed : params.speed;
			var timeOld = + new Date();
			if (_this.support.transitions || !params.DOMAnimation) {
				_this.setWrapperTranslate(newPosition);
				_this.setWrapperTransition(speed);
			}
			else {
				//Try the DOM animation
				var currentPosition = _this.getWrapperTranslate();
				var animationStep = Math.ceil( (newPosition - currentPosition)/speed*(1000/60) );
				var direction = currentPosition > newPosition ? 'toNext' : 'toPrev';
				var condition = direction=='toNext' ? currentPosition > newPosition : currentPosition < newPosition;
				if (_this._DOMAnimating) return;
	
				anim();
			}
			function anim(){
				var timeNew = + new Date();
				var time = timeNew - timeOld;
				currentPosition += animationStep * time / (1000/60);
				condition = direction=='toNext' ? currentPosition > newPosition : currentPosition < newPosition;
				if (condition) {
					_this.setWrapperTranslate(Math.round(currentPosition));
					_this._DOMAnimating = true
					window.setTimeout(function(){
						anim()
					}, 1000 / 60)
				}
				else {
					if (params.onSlideChangeEnd) _this.fireCallback(params.onSlideChangeEnd, _this);
					_this.setWrapperTranslate(newPosition);
					_this._DOMAnimating = false;
				}
			}
	
			//Update Active Slide Index
			_this.updateActiveSlide(newPosition);
	
			//Callbacks
			if (params.onSlideNext && action=='next') {
				_this.fireCallback(params.onSlideNext, _this, newPosition);
			}
			if (params.onSlidePrev && action=='prev') {
				_this.fireCallback(params.onSlidePrev, _this, newPosition);
			}
			//"Reset" Callback
			if (params.onSlideReset && action=='reset') {
				_this.fireCallback(params.onSlideReset, _this, newPosition);
			}
	
			//"Next", "Prev" and "To" Callbacks
			if (action=='next' || action=='prev' || (action=='to' && toOptions.runCallbacks==true))
				slideChangeCallbacks(action);
		}
		/*==================================================
		 Transition Callbacks
		 ====================================================*/
		//Prevent Multiple Callbacks
		_this._queueStartCallbacks = false;
		_this._queueEndCallbacks = false;
		function slideChangeCallbacks(direction) {
			//Transition Start Callback
			_this.callPlugins('onSlideChangeStart');
			if (params.onSlideChangeStart) {
				if (params.queueStartCallbacks && _this.support.transitions) {
					if (_this._queueStartCallbacks) return;
					_this._queueStartCallbacks = true;
					_this.fireCallback(params.onSlideChangeStart, _this, direction)
					_this.wrapperTransitionEnd(function(){
						_this._queueStartCallbacks = false;
					})
				}
				else _this.fireCallback(params.onSlideChangeStart, _this, direction)
			}
			//Transition End Callback
			if (params.onSlideChangeEnd) {
				if (_this.support.transitions) {
					if (params.queueEndCallbacks) {
						if (_this._queueEndCallbacks) return;
						_this._queueEndCallbacks = true;
						_this.wrapperTransitionEnd(function(swiper){_this.fireCallback(params.onSlideChangeEnd, swiper, direction)})
					}
					else _this.wrapperTransitionEnd(function(swiper){_this.fireCallback(params.onSlideChangeEnd, swiper, direction)})
				}
				else {
					if (!params.DOMAnimation) {
						setTimeout(function(){
							_this.fireCallback(params.onSlideChangeEnd, _this, direction)
						},10)
					}
				}
			}
		}
	
		/*==================================================
		 Update Active Slide Index
		 ====================================================*/
		_this.updateActiveSlide = function(position) {
			if (!_this.initialized) return;
			if (_this.slides.length==0) return;
			_this.previousIndex = _this.activeIndex;
			if (typeof position=='undefined') position = _this.getWrapperTranslate();
			if (position>0) position=0;
	
			if (params.slidesPerView == 'auto') {
				var slidesOffset = 0;
				_this.activeIndex = _this.slidesGrid.indexOf(-position);
				if (_this.activeIndex<0) {
					for (var i=0; i<_this.slidesGrid.length-1; i++) {
						if (-position>_this.slidesGrid[i] && -position<_this.slidesGrid[i+1]) {
							break;
						}
					}
					var leftDistance = Math.abs( _this.slidesGrid[i] + position )
					var rightDistance = Math.abs( _this.slidesGrid[i+1] + position )
					if (leftDistance<=rightDistance) _this.activeIndex = i;
					else _this.activeIndex = i+1;
				}
			}
			else {
				_this.activeIndex = Math[params.visibilityFullFit ? 'ceil' : 'round']( -position/slideSize );
			}
	
			if (_this.activeIndex == _this.slides.length ) _this.activeIndex = _this.slides.length - 1;
			if (_this.activeIndex < 0) _this.activeIndex = 0;
	
			// Check for slide
			if (!_this.slides[_this.activeIndex]) return;
	
			// Calc Visible slides
			_this.calcVisibleSlides(position);
	
			// Mark visible and active slides with additonal classes
			var activeClassRegexp = new RegExp( "\\s*" + params.slideActiveClass );
			var inViewClassRegexp = new RegExp( "\\s*" + params.slideVisibleClass );
	
			for (var i = 0; i < _this.slides.length; i++) {
				_this.slides[ i ].className = _this.slides[ i ].className.replace( activeClassRegexp, '' ).replace( inViewClassRegexp, '' );
				if ( _this.visibleSlides.indexOf( _this.slides[ i ] )>=0 ) {
					_this.slides[ i ].className += ' ' + params.slideVisibleClass;
				}
	
			}
			_this.slides[ _this.activeIndex ].className += ' ' + params.slideActiveClass;
	
			//Update loop index
			if (params.loop) {
				var ls = _this.loopedSlides;
				_this.activeLoopIndex = _this.activeIndex - ls;
				if (_this.activeLoopIndex >= _this.slides.length - ls*2 ) {
					_this.activeLoopIndex = _this.slides.length - ls*2 - _this.activeLoopIndex;
				}
				if (_this.activeLoopIndex<0) {
					_this.activeLoopIndex = _this.slides.length - ls*2 + _this.activeLoopIndex;
				}
				if (_this.activeLoopIndex<0) _this.activeLoopIndex = 0;
			}
			else {
				_this.activeLoopIndex = _this.activeIndex;
			}
			//Update Pagination
			if (params.pagination) {
				_this.updatePagination(position);
			}
		}
		/*==================================================
		 Pagination
		 ====================================================*/
		_this.createPagination = function (firstInit) {
			if (params.paginationClickable && _this.paginationButtons) {
				removePaginationEvents();
			}
			_this.paginationContainer = params.pagination.nodeType ? params.pagination : $$(params.pagination)[0];
			if (params.createPagination) {
				var paginationHTML = "";
				var numOfSlides = _this.slides.length;
				var numOfButtons = numOfSlides;
				if (params.loop) numOfButtons -= _this.loopedSlides*2
				for (var i = 0; i < numOfButtons; i++) {
					paginationHTML += '<'+params.paginationElement+' class="'+params.paginationElementClass+'"></'+params.paginationElement+'>'
				}
				_this.paginationContainer.innerHTML = paginationHTML;
			}
			_this.paginationButtons = $$('.'+params.paginationElementClass, _this.paginationContainer);
			if (!firstInit) _this.updatePagination()
			_this.callPlugins('onCreatePagination');
			if (params.paginationClickable) {
				addPaginationEvents();
			}
		}
		function removePaginationEvents() {
			var pagers = _this.paginationButtons;
			for (var i=0; i<pagers.length; i++) {
				_this.h.removeEventListener(pagers[i], 'click', paginationClick);
			}
		}
		function addPaginationEvents() {
			var pagers = _this.paginationButtons;
			for (var i=0; i<pagers.length; i++) {
				_this.h.addEventListener(pagers[i], 'click', paginationClick);
			}
		}
		function paginationClick(e){
			var index;
			var target = e.target || e.srcElement;
			var pagers = _this.paginationButtons;
			for (var i=0; i<pagers.length; i++) {
				if (target===pagers[i]) index = i;
			}
			_this.swipeTo(index)
		}
		_this.updatePagination = function(position) {
			if (!params.pagination) return;
			if (_this.slides.length<1) return;
			var activePagers = $$('.'+params.paginationActiveClass, _this.paginationContainer);
			if(!activePagers) return;
	
			//Reset all Buttons' class to not active
			var pagers = _this.paginationButtons;
			if (pagers.length==0) return;
			for (var i=0; i < pagers.length; i++) {
				pagers[i].className = params.paginationElementClass
			}
	
			var indexOffset = params.loop ? _this.loopedSlides : 0;
			if (params.paginationAsRange) {
				if (!_this.visibleSlides) _this.calcVisibleSlides(position)
				//Get Visible Indexes
				var visibleIndexes = [];
				for (var i = 0; i < _this.visibleSlides.length; i++) {
					var visIndex = _this.slides.indexOf( _this.visibleSlides[i] ) - indexOffset
	
					if (params.loop && visIndex<0) {
						visIndex = _this.slides.length - _this.loopedSlides*2 + visIndex;
					}
					if (params.loop && visIndex>=_this.slides.length-_this.loopedSlides*2) {
						visIndex = _this.slides.length - _this.loopedSlides*2 - visIndex;
						visIndex = Math.abs(visIndex)
					}
					visibleIndexes.push( visIndex )
				}
	
				for (i=0; i<visibleIndexes.length; i++) {
					if (pagers[ visibleIndexes[i] ]) pagers[ visibleIndexes[i] ].className += ' ' + params.paginationVisibleClass;
				}
	
				if (params.loop) {
					pagers[ _this.activeLoopIndex ].className += ' ' + params.paginationActiveClass;
				}
				else {
					pagers[ _this.activeIndex ].className += ' ' + params.paginationActiveClass;
				}
	
			}
			else {
				if (params.loop) {
					if (pagers[ _this.activeLoopIndex ]) pagers[ _this.activeLoopIndex ].className+=' '+params.paginationActiveClass+' '+params.paginationVisibleClass;
				}
				else {
					pagers[ _this.activeIndex ].className+=' '+params.paginationActiveClass+' '+params.paginationVisibleClass;
				}
	
			}
	
		}
		_this.calcVisibleSlides = function(position){
			var visibleSlides = [];
			var _slideLeft = 0, _slideSize = 0, _slideRight = 0;
			if (isH && _this.wrapperLeft>0) position = position+_this.wrapperLeft;
			if (!isH && _this.wrapperTop>0) position = position+_this.wrapperTop;
	
			for (var i=0; i<_this.slides.length; i++) {
				_slideLeft += _slideSize;
				if (params.slidesPerView == 'auto')
					_slideSize  = isH ? _this.h.getWidth(_this.slides[i],true) : _this.h.getHeight(_this.slides[i],true);
				else _slideSize = slideSize;
	
				_slideRight = _slideLeft + _slideSize;
				var isVisibile = false;
				if (params.visibilityFullFit) {
					if (_slideLeft >= -position && _slideRight <= -position+containerSize) isVisibile = true;
					if (_slideLeft <= -position && _slideRight >= -position+containerSize) isVisibile = true;
				}
				else {
	
					if (_slideRight > -position && _slideRight <= ((-position+containerSize))) isVisibile = true;
					if (_slideLeft >= -position && _slideLeft < ((-position+containerSize))) isVisibile = true;
					if (_slideLeft < -position && _slideRight > ((-position+containerSize))) isVisibile = true;
				}
	
				if (isVisibile) visibleSlides.push(_this.slides[i])
	
			}
			if (visibleSlides.length==0) visibleSlides = [ _this.slides[ _this.activeIndex ] ]
	
			_this.visibleSlides = visibleSlides;
		}
	
		/*==========================================
		 Autoplay
		 ============================================*/
		var autoplayTimeoutId = undefined;
		var autoplayIntervalId = undefined;
		_this.startAutoplay = function () {
			if (_this.support.transitions) {
				if (typeof autoplayTimeoutId !== 'undefined') return false;
				if (!params.autoplay) return;
				_this.callPlugins('onAutoplayStart');
				autoplay();
			}
			else {
				if (typeof autoplayIntervalId !== 'undefined') return false;
				if (!params.autoplay) return;
				_this.callPlugins('onAutoplayStart');
				autoplayIntervalId = setInterval(function(){
					if (params.loop) {
						_this.fixLoop();
						_this.swipeNext(true);
					}
					else if (!_this.swipeNext(true)) {
						if (!params.autoplayStopOnLast) _this.swipeTo(0);
						else {
							clearInterval(autoplayIntervalId);
							autoplayIntervalId = undefined;
						}
					}
				}, params.autoplay)
			}
		}
		_this.stopAutoplay = function (internal) {
			if (_this.support.transitions) {
				if (!autoplayTimeoutId) return;
				if (autoplayTimeoutId) clearTimeout(autoplayTimeoutId);
				autoplayTimeoutId = undefined;
				if (internal && !params.autoplayDisableOnInteraction) {
					_this.wrapperTransitionEnd(function(){
						autoplay();
					})
				}
				_this.callPlugins('onAutoplayStop');
			}
			else {
				if (autoplayIntervalId) clearInterval(autoplayIntervalId);
				autoplayIntervalId = undefined;
				_this.callPlugins('onAutoplayStop');
			}
		}
		function autoplay(){
			autoplayTimeoutId = setTimeout(function(){
				if(params.loop) {
					_this.fixLoop();
					_this.swipeNext(true);
				}
				else if (!_this.swipeNext(true)) {
					if (!params.autoplayStopOnLast) _this.swipeTo(0);
					else {
						clearTimeout(autoplayTimeoutId);
						autoplayTimeoutId = undefined;
					}
				}
				_this.wrapperTransitionEnd(function(){
					if (typeof autoplayTimeoutId !== 'undefined') autoplay();
				})
			},params.autoplay)
		}
		/*==================================================
		 Loop
		 ====================================================*/
		_this.loopCreated = false;
		_this.removeLoopedSlides = function(){
			if (_this.loopCreated) {
				for (var i=0; i<_this.slides.length; i++) {
					if (_this.slides[i].getData('looped')===true) _this.wrapper.removeChild(_this.slides[i]);
				}
			}
		}
	
		_this.createLoop = function() {
			if (_this.slides.length==0) return;
			/* Shopgate adaption to get looped slides exactly as we need */
			if (!params.forceLoopedSlides) {
				if (!params.slidesPerView == 'auto') {
					_this.loopedSlides = params.loopedSlides || 1;
				}
				else {
					_this.loopedSlides = params.slidesPerView + params.loopAdditionalSlides;
				}
	
				if (_this.loopedSlides > _this.slides.length) {
					_this.loopedSlides = _this.slides.length;
				}
			} else {
				_this.loopedSlides = params.loopedSlides || 1;
			}
	
			var slideFirstHTML = '',
				slideLastHTML = '',
				i;
			var slidesSetFullHTML = '';
			/**
			 loopedSlides is too large if loopAdditionalSlides are set.
			 Need to divide the slides by maximum number of slides existing.
	
			 @author        Tomaz Lovrec <tomaz.lovrec@blanc-noir.at>
			 */
			var numSlides = _this.slides.length;
			var fullSlideSets = Math.floor(_this.loopedSlides / numSlides);
			var remainderSlides = _this.loopedSlides % numSlides;
			// assemble full sets of slides
			for (i = 0; i<(fullSlideSets*numSlides);i++) {
				var j = i;
				if (i >= numSlides) {
					var over = Math.floor(i / numSlides);
					j = i - (numSlides * over);
				}
				slidesSetFullHTML+=_this.slides[j].outerHTML;
			}
			// assemble remainder slides
			// assemble remainder appended to existing slides
			for(i = 0;i<remainderSlides;i++) {
				slideLastHTML += addClassToHtmlString(params.slideDuplicateClass, _this.slides[i].outerHTML);
			}
			// assemble slides that get preppended to existing slides
			for(i = numSlides - remainderSlides;i<numSlides;i++) {
				slideFirstHTML += addClassToHtmlString(params.slideDuplicateClass, _this.slides[i].outerHTML);
			}
			// assemble all slides
			var slides = slideFirstHTML + slidesSetFullHTML + wrapper.innerHTML + slidesSetFullHTML + slideLastHTML;
			// set the slides
			wrapper.innerHTML = slides;
	
			_this.loopCreated = true;
			_this.calcSlides();
	
			//Update Looped Slides with special class
			for (i=0; i<_this.slides.length; i++) {
				if (i<_this.loopedSlides || i>=_this.slides.length-_this.loopedSlides) _this.slides[i].setData('looped', true);
			}
			_this.callPlugins('onCreateLoop');
	
		}
	
		_this.fixLoop = function() {
			var newIndex;
			//Fix For Negative Oversliding
			if (_this.activeIndex < _this.loopedSlides) {
				newIndex = _this.slides.length - _this.loopedSlides*3 + _this.activeIndex;
				_this.swipeTo(newIndex, 0, false);
			}
			//Fix For Positive Oversliding
			else if ((params.slidesPerView == "auto" && _this.activeIndex >= _this.loopedSlides*2) || (_this.activeIndex > _this.slides.length - params.slidesPerView*2)) {
				newIndex = -_this.slides.length + _this.activeIndex + _this.loopedSlides;
				_this.swipeTo(newIndex, 0, false);
			}
		}
	
		/*==================================================
		 Slides Loader
		 ====================================================*/
		_this.loadSlides = function(){
			var slidesHTML = '';
			_this.activeLoaderIndex = 0;
			var slides = params.loader.slides;
			var slidesToLoad = params.loader.loadAllSlides ? slides.length : params.slidesPerView*(1+params.loader.surroundGroups);
			for (var i=0; i< slidesToLoad; i++) {
				if (params.loader.slidesHTMLType=='outer') slidesHTML+=slides[i];
				else {
					slidesHTML+='<'+params.slideElement+' class="'+params.slideClass+'" data-swiperindex="'+i+'">'+slides[i]+'</'+params.slideElement+'>';
				}
			}
			_this.wrapper.innerHTML = slidesHTML;
			_this.calcSlides(true);
			//Add permanent transitionEnd callback
			if (!params.loader.loadAllSlides) {
				_this.wrapperTransitionEnd(_this.reloadSlides, true);
			}
		}
	
		_this.reloadSlides = function(){
			var slides = params.loader.slides;
			var newActiveIndex = parseInt(_this.activeSlide().data('swiperindex'),10)
			if (newActiveIndex<0 || newActiveIndex>slides.length-1) return //<-- Exit
			_this.activeLoaderIndex = newActiveIndex;
			var firstIndex = Math.max(0, newActiveIndex - params.slidesPerView*params.loader.surroundGroups)
			var lastIndex = Math.min(newActiveIndex+params.slidesPerView*(1+params.loader.surroundGroups)-1, slides.length-1)
			//Update Transforms
			if (newActiveIndex>0) {
				var newTransform = -slideSize*(newActiveIndex-firstIndex)
				_this.setWrapperTranslate(newTransform);
				_this.setWrapperTransition(0);
			}
			//New Slides
			if (params.loader.logic==='reload') {
				_this.wrapper.innerHTML = '';
				var slidesHTML = '';
				for (var i = firstIndex; i<=lastIndex; i++) {
					slidesHTML += params.loader.slidesHTMLType == 'outer' ? slides[i] : '<'+params.slideElement+' class="'+params.slideClass+'" data-swiperindex="'+i+'">'+slides[i]+'</'+params.slideElement+'>';
				}
				_this.wrapper.innerHTML = slidesHTML;
			}
			else {
				var minExistIndex=1000;
				var maxExistIndex=0;
				for (var i=0; i<_this.slides.length; i++) {
					var index = _this.slides[i].data('swiperindex');
					if (index<firstIndex || index>lastIndex) {
						_this.wrapper.removeChild(_this.slides[i]);
					}
					else {
						minExistIndex = Math.min(index, minExistIndex)
						maxExistIndex = Math.max(index, maxExistIndex)
					}
				}
				for (var i=firstIndex; i<=lastIndex; i++) {
					if (i<minExistIndex) {
						var newSlide = document.createElement(params.slideElement);
						newSlide.className = params.slideClass;
						newSlide.setAttribute('data-swiperindex',i);
						newSlide.innerHTML = slides[i];
						_this.wrapper.insertBefore(newSlide, _this.wrapper.firstChild);
					}
					if (i>maxExistIndex) {
						var newSlide = document.createElement(params.slideElement);
						newSlide.className = params.slideClass;
						newSlide.setAttribute('data-swiperindex',i);
						newSlide.innerHTML = slides[i];
						_this.wrapper.appendChild(newSlide);
					}
				}
			}
			//reInit
			_this.reInit(true);
		}
	
		/*==================================================
		 Make Swiper
		 ====================================================*/
		function makeSwiper(){
			_this.calcSlides();
			if (params.loader.slides.length>0 && _this.slides.length==0) {
				_this.loadSlides();
			}
			if (params.loop) {
				_this.createLoop();
			}
			_this.init();
			initEvents();
			if (params.pagination) {
				_this.createPagination(true);
			}
	
			if (params.loop || params.initialSlide>0) {
				_this.swipeTo( params.initialSlide, 0, false );
			}
			else {
				_this.updateActiveSlide(0);
			}
			if (params.autoplay) {
				_this.startAutoplay();
			}
			/**
			 * Set center slide index.
			 *
			 * @author        Tomaz Lovrec <tomaz.lovrec@gmail.com>
			 */
			_this.centerIndex = _this.activeIndex;
	
			// Callbacks
			if (params.onSwiperCreated) _this.fireCallback(params.onSwiperCreated, _this);
			_this.callPlugins('onSwiperCreated');
		}
	
		makeSwiper();
	}
	
	Swiper.prototype = {
		plugins : {},
	
		/*==================================================
		 Wrapper Operations
		 ====================================================*/
		wrapperTransitionEnd : function(callback, permanent) {
			var a = this,
				el = a.wrapper,
				events = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'],
				i;
	
			function fireCallBack() {
				callback(a);
				if (a.params.queueEndCallbacks) a._queueEndCallbacks = false;
				if (!permanent) {
					for (i=0; i<events.length; i++) {
						a.h.removeEventListener(el, events[i], fireCallBack);
					}
				}
			}
	
			if (callback) {
				for (i=0; i<events.length; i++) {
					a.h.addEventListener(el, events[i], fireCallBack);
				}
			}
		},
	
		getWrapperTranslate : function (axis) {
			var el = this.wrapper,
				matrix, curTransform, curStyle, transformMatrix;
	
			// automatic axis detection
			if (typeof axis == 'undefined') {
				axis = this.params.mode == 'horizontal' ? 'x' : 'y';
			}
	
			if (this.support.transforms && this.params.useCSS3Transforms) {
				curStyle = window.getComputedStyle(el, null);
				if (window.WebKitCSSMatrix) {
					transformMatrix = new WebKitCSSMatrix(curStyle.webkitTransform);
				}
				else {
					transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform  || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
					matrix = transformMatrix.toString().split(',');
				}
	
				if (axis=='x') {
					//Latest Chrome and webkits Fix
					if (window.WebKitCSSMatrix)
						curTransform = transformMatrix.m41;
					//Crazy IE10 Matrix
					else if (matrix.length==16)
						curTransform = parseFloat( matrix[12] );
					//Normal Browsers
					else
						curTransform = parseFloat( matrix[4] );
				}
				if (axis=='y') {
					//Latest Chrome and webkits Fix
					if (window.WebKitCSSMatrix)
						curTransform = transformMatrix.m42;
					//Crazy IE10 Matrix
					else if (matrix.length==16)
						curTransform = parseFloat( matrix[13] );
					//Normal Browsers
					else
						curTransform = parseFloat( matrix[5] );
				}
			}
			else {
				if (axis=='x') curTransform = parseFloat(el.style.left,10) || 0;
				if (axis=='y') curTransform = parseFloat(el.style.top,10) || 0;
			}
			return curTransform || 0;
		},
	
		setWrapperTranslate : function (x, y, z) {
			var es = this.wrapper.style,
				coords = {x: 0, y: 0, z: 0},
				translate;
	
			// passed all coordinates
			if (arguments.length == 3) {
				coords.x = x;
				coords.y = y;
				coords.z = z;
			}
	
			// passed one coordinate and optional axis
			else {
				if (typeof y == 'undefined') {
					y = this.params.mode == 'horizontal' ? 'x' : 'y';
				}
				coords[y] = x;
			}
	
			if (this.support.transforms && this.params.useCSS3Transforms) {
				translate = this.support.transforms3d ? 'translate3d(' + coords.x + 'px, ' + coords.y + 'px, ' + coords.z + 'px)' : 'translate(' + coords.x + 'px, ' + coords.y + 'px)';
				es.webkitTransform = es.MsTransform = es.msTransform = es.MozTransform = es.OTransform = es.transform = translate;
			}
			else {
				es.left = coords.x + 'px';
				es.top  = coords.y + 'px';
			}
			this.callPlugins('onSetWrapperTransform', coords);
			if (this.params.onSetWrapperTransform) this.fireCallback(this.params.onSetWrapperTransform, this, coords);
		},
	
		setWrapperTransition : function (duration) {
			var es = this.wrapper.style;
			es.webkitTransitionDuration = es.MsTransitionDuration = es.msTransitionDuration = es.MozTransitionDuration = es.OTransitionDuration = es.transitionDuration = (duration / 1000) + 's';
			this.callPlugins('onSetWrapperTransition', {duration: duration});
			if (this.params.onSetWrapperTransition) this.fireCallback(this.params.onSetWrapperTransition, this, duration);
	
		},
	
		/*==================================================
		 Helpers
		 ====================================================*/
		h : {
			getWidth: function (el, outer) {
				var width = window.getComputedStyle(el, null).getPropertyValue('width')
				var returnWidth = parseFloat(width);
				//IE Fixes
				if(isNaN(returnWidth) || width.indexOf('%')>0) {
					returnWidth = el.offsetWidth - parseFloat(window.getComputedStyle(el, null).getPropertyValue('padding-left')) - parseFloat(window.getComputedStyle(el, null).getPropertyValue('padding-right'));
				}
				if (outer) returnWidth += parseFloat(window.getComputedStyle(el, null).getPropertyValue('padding-left')) + parseFloat(window.getComputedStyle(el, null).getPropertyValue('padding-right'))
	
				return returnWidth;
			},
			getHeight: function(el, outer) {
				if (outer) return el.offsetHeight;
	
				var height = window.getComputedStyle(el, null).getPropertyValue('height')
				var returnHeight = parseFloat(height);
				//IE Fixes
				if(isNaN(returnHeight) || height.indexOf('%')>0) {
					returnHeight = el.offsetHeight - parseFloat(window.getComputedStyle(el, null).getPropertyValue('padding-top')) - parseFloat(window.getComputedStyle(el, null).getPropertyValue('padding-bottom'));
				}
				if (outer) returnHeight += parseFloat(window.getComputedStyle(el, null).getPropertyValue('padding-top')) + parseFloat(window.getComputedStyle(el, null).getPropertyValue('padding-bottom'))
				return returnHeight;
			},
			getOffset: function(el) {
				var box = el.getBoundingClientRect();
				var body = document.body;
				var clientTop  = el.clientTop  || body.clientTop  || 0;
				var clientLeft = el.clientLeft || body.clientLeft || 0;
				var scrollTop  = window.pageYOffset || el.scrollTop;
				var scrollLeft = window.pageXOffset || el.scrollLeft;
				if (document.documentElement && !window.pageYOffset) {
					//IE7-8
					scrollTop  = document.documentElement.scrollTop;
					scrollLeft = document.documentElement.scrollLeft;
				}
				return {
					top: box.top  + scrollTop  - clientTop,
					left: box.left + scrollLeft - clientLeft
				};
			},
			windowWidth : function() {
				if (window.innerWidth) return window.innerWidth
				else if (document.documentElement && document.documentElement.clientWidth) return document.documentElement.clientWidth;
			},
			windowHeight : function() {
				if (window.innerHeight) return window.innerHeight
				else if (document.documentElement && document.documentElement.clientHeight) return document.documentElement.clientHeight;
			},
			windowScroll : function() {
				var left=0, top=0;
				if (typeof pageYOffset != 'undefined') {
					return {
						left: window.pageXOffset,
						top: window.pageYOffset
					}
				}
				else if (document.documentElement) {
					return {
						left: document.documentElement.scrollLeft,
						top: document.documentElement.scrollTop
					}
				}
			},
	
			addEventListener : function (el, event, listener, useCapture) {
				if (typeof useCapture == 'undefined') {
					useCapture = false;
				}
	
				if (el.addEventListener) {
					el.addEventListener(event, listener, useCapture);
				}
				else if (el.attachEvent) {
					el.attachEvent('on' + event, listener);
				}
			},
	
			removeEventListener : function (el, event, listener, useCapture) {
				if (typeof useCapture == 'undefined') {
					useCapture = false;
				}
	
				if (el.removeEventListener) {
					el.removeEventListener(event, listener, useCapture);
				}
				else if (el.detachEvent) {
					el.detachEvent('on' + event, listener);
				}
			}
		},
		setTransform : function (el, transform) {
			var es = el.style
			es.webkitTransform = es.MsTransform = es.msTransform = es.MozTransform = es.OTransform = es.transform = transform
		},
		setTranslate : function (el, translate) {
			var es = el.style
			var pos = {
				x : translate.x || 0,
				y : translate.y || 0,
				z : translate.z || 0
			};
			var transformString = this.support.transforms3d ? 'translate3d('+(pos.x)+'px,'+(pos.y)+'px,'+(pos.z)+'px)' : 'translate('+(pos.x)+'px,'+(pos.y)+'px)';
			es.webkitTransform = es.MsTransform = es.msTransform = es.MozTransform = es.OTransform = es.transform = transformString;
			if (!this.support.transforms) {
				es.left = pos.x+'px'
				es.top = pos.y+'px'
			}
		},
		setTransition : function (el, duration) {
			var es = el.style
			es.webkitTransitionDuration = es.MsTransitionDuration = es.msTransitionDuration = es.MozTransitionDuration = es.OTransitionDuration = es.transitionDuration = duration+'ms';
		},
		/*==================================================
		 Feature Detection
		 ====================================================*/
		support: {
	
			touch : (window.Modernizr && Modernizr.touch===true) || (function() {
				return !!(("ontouchstart" in window) || window.DocumentTouch && document instanceof DocumentTouch);
			})(),
	
			transforms3d : (window.Modernizr && Modernizr.csstransforms3d===true) || (function() {
				var div = document.createElement('div').style;
				return ("webkitPerspective" in div || "MozPerspective" in div || "OPerspective" in div || "MsPerspective" in div || "perspective" in div);
			})(),
	
			transforms : (window.Modernizr && Modernizr.csstransforms===true) || (function(){
				var div = document.createElement('div').style;
				return ('transform' in div || 'WebkitTransform' in div || 'MozTransform' in div || 'msTransform' in div || 'MsTransform' in div || 'OTransform' in div);
			})(),
	
			transitions : (window.Modernizr && Modernizr.csstransitions===true) || (function(){
				var div = document.createElement('div').style;
				return ('transition' in div || 'WebkitTransition' in div || 'MozTransition' in div || 'msTransition' in div || 'MsTransition' in div || 'OTransition' in div);
			})()
		},
	
		browser : {
	
			ie8 : (function(){
				var rv = -1; // Return value assumes failure.
				if (navigator.appName == 'Microsoft Internet Explorer') {
					var ua = navigator.userAgent;
					var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
					if (re.exec(ua) != null)
						rv = parseFloat(RegExp.$1);
				}
				return rv != -1 && rv < 9;
			})(),
	
			ie10 : window.navigator.msPointerEnabled,
			ie11 : window.navigator.pointerEnabled
		}
	}
	
	/*=========================
	 jQuery & Zepto Plugins
	 ===========================*/
	if (window.jQuery||window.Zepto) {
		(function($){
			$.fn.swiper = function(params) {
				var s = new Swiper($(this)[0], params)
				$(this).data('swiper',s);
				return s;
			}
		})(window.jQuery||window.Zepto)
	}
	
	// component
	if ( true )
	{
		module.exports = Swiper;
	}

/***/ }),

/***/ 424:
/***/ (function(module, exports) {

	/* **********************************************
	 Begin collapse.js
	 ********************************************** */
	
	/* ========================================================================
	 * Bootstrap: collapse.js v3.1.0
	 * http://getbootstrap.com/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2014 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
		'use strict';
	
		// COLLAPSE PUBLIC CLASS DEFINITION
		// ================================
	
		var Collapse = function (element, options) {
			this.$element      = $(element)
			this.options       = $.extend({}, Collapse.DEFAULTS, options)
			this.transitioning = null
	
			if (this.options.parent) this.$parent = $(this.options.parent)
			if (this.options.toggle) this.toggle()
		}
	
		Collapse.DEFAULTS = {
			toggle: true
		}
	
		Collapse.prototype.dimension = function () {
			var hasWidth = this.$element.hasClass('width')
			return hasWidth ? 'width' : 'height'
		}
	
		Collapse.prototype.show = function () {
			if (this.transitioning || this.$element.hasClass('in')) return
	
			var startEvent = $.Event('show.bs.collapse')
			this.$element.trigger(startEvent)
			if (startEvent.isDefaultPrevented()) return
	
			var actives = this.$parent && this.$parent.find('> .panel > .in')
	
			if (actives && actives.length) {
				var hasData = actives.data('bs.collapse')
				if (hasData && hasData.transitioning) return
				actives.collapse('hide')
				hasData || actives.data('bs.collapse', null)
			}
	
			var dimension = this.dimension()
	
			this.$element
				.removeClass('collapse')
				.addClass('collapsing')
				[dimension](0)
	
			this.transitioning = 1
	
			var complete = function () {
				this.$element
					.removeClass('collapsing')
					.addClass('collapse in')
					[dimension]('auto')
				this.transitioning = 0
				this.$element.trigger('shown.bs.collapse')
			}
	
			if (!$.support.transition) return complete.call(this)
	
			var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
			this.$element
				.one($.support.transition.end, $.proxy(complete, this))
				.emulateTransitionEnd(350)
				[dimension](this.$element[0][scrollSize])
		}
	
		Collapse.prototype.hide = function () {
			if (this.transitioning || !this.$element.hasClass('in')) return
	
			var startEvent = $.Event('hide.bs.collapse')
			this.$element.trigger(startEvent)
			if (startEvent.isDefaultPrevented()) return
	
			var dimension = this.dimension()
	
			this.$element
				[dimension](this.$element[dimension]())
				[0].offsetHeight
	
			this.$element
				.addClass('collapsing')
				.removeClass('collapse')
				.removeClass('in')
	
			this.transitioning = 1
	
			var complete = function () {
				this.transitioning = 0
				this.$element
					.trigger('hidden.bs.collapse')
					.removeClass('collapsing')
					.addClass('collapse')
			}
	
			if (!$.support.transition) return complete.call(this)
	
			this.$element
				[dimension](0)
				.one($.support.transition.end, $.proxy(complete, this))
				.emulateTransitionEnd(350)
		}
	
		Collapse.prototype.toggle = function () {
			this[this.$element.hasClass('in') ? 'hide' : 'show']()
		}
	
	
		// COLLAPSE PLUGIN DEFINITION
		// ==========================
	
		var old = $.fn.collapse
	
		$.fn.collapse = function (option) {
			return this.each(function () {
				var $this   = $(this)
				var data    = $this.data('bs.collapse')
				var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
				if (!data && options.toggle && option == 'show') option = !option
				if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
				if (typeof option == 'string') data[option]()
			})
		}
	
		$.fn.collapse.Constructor = Collapse
	
	
		// COLLAPSE NO CONFLICT
		// ====================
	
		$.fn.collapse.noConflict = function () {
			$.fn.collapse = old
			return this
		}
	
	
		// COLLAPSE DATA-API
		// =================
	
		$(document).on('click.bs.collapse.data-api', '[data-toggle=collapse]', function (e) {
			var $this   = $(this), href
			var target  = $this.attr('data-target')
				|| e.preventDefault()
				|| (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') //strip for ie7
			var $target = $(target)
			var data    = $target.data('bs.collapse')
			var option  = data ? 'toggle' : $this.data()
			var parent  = $this.attr('data-parent')
			var $parent = parent && $(parent)
	
			if (!data || !data.transitioning) {
				if ($parent) $parent.find('[data-toggle=collapse][data-parent="' + parent + '"]').not($this).addClass('collapsed')
				$this[$target.hasClass('in') ? 'addClass' : 'removeClass']('collapsed')
				$('[data-target='+target+']').toggleClass('toggled');
			}
	
			$target.collapse(option)
		})
	
	}(jQuery);


/***/ }),

/***/ 425:
/***/ (function(module, exports) {

	/* **********************************************
	 Begin dropdown.js
	 ********************************************** */
	
	/* ========================================================================
	 * Bootstrap: dropdown.js v3.1.0
	 * http://getbootstrap.com/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2014 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
		'use strict';
	
		// DROPDOWN CLASS DEFINITION
		// =========================
	
		var backdrop = '.dropdown-backdrop'
		var toggle   = '[data-toggle=dropdown]'
		var Dropdown = function (element) {
			$(element).on('click.bs.dropdown', this.toggle)
		}
	
		Dropdown.prototype.toggle = function (e) {
			var $this = $(this)
	
			if ($this.is('.disabled, :disabled')) return
	
			var $parent  = getParent($this)
			var isActive = $parent.hasClass('open')
	
			clearMenus()
	
			if (!isActive) {
				if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
					// if mobile we use a backdrop because click events don't delegate
					$('<div class="dropdown-backdrop"/>').insertAfter($(this)).on('click', clearMenus)
				}
	
				var relatedTarget = { relatedTarget: this }
				$parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
				if (e.isDefaultPrevented()) return
	
				$parent
					.toggleClass('open')
					.trigger('shown.bs.dropdown', relatedTarget)
	
				$this.focus()
			}
	
			return false
		}
	
		Dropdown.prototype.keydown = function (e) {
			if (!/(38|40|27)/.test(e.keyCode)) return
	
			var $this = $(this)
	
			e.preventDefault()
			e.stopPropagation()
	
			if ($this.is('.disabled, :disabled')) return
	
			var $parent  = getParent($this)
			var isActive = $parent.hasClass('open')
	
			if (!isActive || (isActive && e.keyCode == 27)) {
				if (e.which == 27) $parent.find(toggle).focus()
				return $this.click()
			}
	
			var desc = ' li:not(.divider):visible a'
			var $items = $parent.find('[role=menu]' + desc + ', [role=listbox]' + desc)
	
			if (!$items.length) return
	
			var index = $items.index($items.filter(':focus'))
	
			if (e.keyCode == 38 && index > 0)                 index--                        // up
			if (e.keyCode == 40 && index < $items.length - 1) index++                        // down
			if (!~index)                                      index = 0
	
			$items.eq(index).focus()
		}
	
		function clearMenus(e) {
			$(backdrop).remove()
			$(toggle).each(function () {
				var $parent = getParent($(this))
				var relatedTarget = { relatedTarget: this }
				if (!$parent.hasClass('open')) return
				$parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
				if (e.isDefaultPrevented()) return
				$parent.removeClass('open').trigger('hidden.bs.dropdown', relatedTarget)
			})
		}
	
		function getParent($this) {
			var selector = $this.attr('data-target')
	
			if (!selector) {
				selector = $this.attr('href')
				selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') //strip for ie7
			}
	
			var $parent = selector && $(selector)
	
			return $parent && $parent.length ? $parent : $this.parent()
		}
	
	
		// DROPDOWN PLUGIN DEFINITION
		// ==========================
	
		var old = $.fn.dropdown
	
		$.fn.dropdown = function (option) {
			return this.each(function () {
				var $this = $(this)
				var data  = $this.data('bs.dropdown')
	
				if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
				if (typeof option == 'string') data[option].call($this)
			})
		}
	
		$.fn.dropdown.Constructor = Dropdown
	
	
		// DROPDOWN NO CONFLICT
		// ====================
	
		$.fn.dropdown.noConflict = function () {
			$.fn.dropdown = old
			return this
		}
	
	
		// APPLY TO STANDARD DROPDOWN ELEMENTS
		// ===================================
	
		$(document)
			.on('click.bs.dropdown.data-api', clearMenus)
			.on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
			.on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
			.on('keydown.bs.dropdown.data-api', toggle + ', [role=menu], [role=listbox]', Dropdown.prototype.keydown)
	
	}(jQuery);


/***/ }),

/***/ 426:
/***/ (function(module, exports) {

	/* **********************************************
	 Begin modal.js
	 ********************************************** */
	
	/* ========================================================================
	 * Bootstrap: modal.js v3.1.0
	 * http://getbootstrap.com/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2014 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
		'use strict';
	
		// MODAL CLASS DEFINITION
		// ======================
	
		var Modal = function (element, options) {
			this.options   = options
			this.$element  = $(element)
			this.$backdrop =
				this.isShown   = null
	
			if (this.options.remote) {
				this.$element
					.find('.modal-content')
					.load(this.options.remote, $.proxy(function () {
						this.$element.trigger('loaded.bs.modal')
					}, this))
			}
		}
	
		Modal.DEFAULTS = {
			backdrop: true,
			keyboard: true,
			show: true
		}
	
		Modal.prototype.toggle = function (_relatedTarget) {
			return this[!this.isShown ? 'show' : 'hide'](_relatedTarget)
		}
	
		Modal.prototype.show = function (_relatedTarget) {
			var that = this
			var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
	
			this.$element.trigger(e)
	
			if (this.isShown || e.isDefaultPrevented()) return
	
			this.isShown = true
	
			this.escape()
	
			this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))
	
			this.backdrop(function () {
				var transition = $.support.transition && that.$element.hasClass('fade')
	
				if (!that.$element.parent().length) {
					that.$element.appendTo(document.body) // don't move modals dom position
				}
	
				that.$element
					.show()
					.scrollTop(0)
	
				if (transition) {
					that.$element[0].offsetWidth // force reflow
				}
	
				that.$element
					.addClass('in')
					.attr('aria-hidden', false)
	
				that.enforceFocus()
	
				var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })
	
				transition ?
					that.$element.find('.modal-dialog') // wait for modal to slide in
						.one($.support.transition.end, function () {
							that.$element.focus().trigger(e)
						})
						.emulateTransitionEnd(300) :
					that.$element.focus().trigger(e)
			})
		}
	
		Modal.prototype.hide = function (e) {
			if (e) e.preventDefault()
	
			e = $.Event('hide.bs.modal')
	
			this.$element.trigger(e)
	
			if (!this.isShown || e.isDefaultPrevented()) return
	
			this.isShown = false
	
			this.escape()
	
			$(document).off('focusin.bs.modal')
	
			this.$element
				.removeClass('in')
				.attr('aria-hidden', true)
				.off('click.dismiss.bs.modal')
	
			$.support.transition && this.$element.hasClass('fade') ?
				this.$element
					.one($.support.transition.end, $.proxy(this.hideModal, this))
					.emulateTransitionEnd(300) :
				this.hideModal()
		}
	
		Modal.prototype.enforceFocus = function () {
			$(document)
				.off('focusin.bs.modal') // guard against infinite focus loop
				.on('focusin.bs.modal', $.proxy(function (e) {
					if (this.$element[0] !== e.target && !this.$element.has(e.target).length) {
						this.$element.focus()
					}
				}, this))
		}
	
		Modal.prototype.escape = function () {
			if (this.isShown && this.options.keyboard) {
				this.$element.on('keyup.dismiss.bs.modal', $.proxy(function (e) {
					e.which == 27 && this.hide()
				}, this))
			} else if (!this.isShown) {
				this.$element.off('keyup.dismiss.bs.modal')
			}
		}
	
		Modal.prototype.hideModal = function () {
			var that = this
			this.$element.hide()
			this.backdrop(function () {
				that.removeBackdrop()
				that.$element.trigger('hidden.bs.modal')
			})
		}
	
		Modal.prototype.removeBackdrop = function () {
			this.$backdrop && this.$backdrop.remove()
			this.$backdrop = null
		}
	
		Modal.prototype.backdrop = function (callback) {
			var animate = this.$element.hasClass('fade') ? 'fade' : ''
	
			if (this.isShown && this.options.backdrop) {
				var doAnimate = $.support.transition && animate
	
				this.$backdrop = $('<div class="modal-backdrop ' + animate + '" />')
					.appendTo(document.body)
	
				this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
					if (e.target !== e.currentTarget) return
					this.options.backdrop == 'static'
						? this.$element[0].focus.call(this.$element[0])
						: this.hide.call(this)
				}, this))
	
				if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
	
				this.$backdrop.addClass('in')
	
				if (!callback) return
	
				doAnimate ?
					this.$backdrop
						.one($.support.transition.end, callback)
						.emulateTransitionEnd(150) :
					callback()
	
			} else if (!this.isShown && this.$backdrop) {
				this.$backdrop.removeClass('in')
	
				$.support.transition && this.$element.hasClass('fade') ?
					this.$backdrop
						.one($.support.transition.end, callback)
						.emulateTransitionEnd(150) :
					callback()
	
			} else if (callback) {
				callback()
			}
		}
	
	
		// MODAL PLUGIN DEFINITION
		// =======================
	
		var old = $.fn.modal
	
		$.fn.modal = function (option, _relatedTarget) {
			return this.each(function () {
				var $this   = $(this)
				var data    = $this.data('bs.modal')
				var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
				if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
				if (typeof option == 'string') data[option](_relatedTarget)
				else if (options.show) data.show(_relatedTarget)
			})
		}
	
		$.fn.modal.Constructor = Modal
	
	
		// MODAL NO CONFLICT
		// =================
	
		$.fn.modal.noConflict = function () {
			$.fn.modal = old
			return this
		}
	
	
		// MODAL DATA-API
		// ==============
	
		$(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
			var $this   = $(this)
			var href    = $this.attr('href')
			var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) //strip for ie7
			var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
			if ($this.is('a')) e.preventDefault()
	
			$target
				.modal(option, this)
				.one('hide', function () {
					$this.is(':visible') && $this.focus()
				})
		})
	
		$(document)
			.on('show.bs.modal', '.modal', function () { $(document.body).addClass('modal-open') })
			.on('hidden.bs.modal', '.modal', function () { $(document.body).removeClass('modal-open') })
	
	}(jQuery);


/***/ }),

/***/ 427:
/***/ (function(module, exports) {

	/* **********************************************
	 Begin transition.js
	 ********************************************** */
	
	/* ========================================================================
	 * Bootstrap: transition.js v3.1.0
	 * http://getbootstrap.com/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2014 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
		'use strict';
	
		// CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
		// ============================================================
	
		function transitionEnd() {
			var el = document.createElement('bootstrap')
	
			var transEndEventNames = {
				'WebkitTransition' : 'webkitTransitionEnd',
				'MozTransition'    : 'transitionend',
				'OTransition'      : 'oTransitionEnd otransitionend',
				'transition'       : 'transitionend'
			}
	
			for (var name in transEndEventNames) {
				if (el.style[name] !== undefined) {
					return { end: transEndEventNames[name] }
				}
			}
	
			return false // explicit for ie8 (  ._.)
		}
	
		// http://blog.alexmaccaw.com/css-transitions
		$.fn.emulateTransitionEnd = function (duration) {
			var called = false, $el = this
			$(this).one($.support.transition.end, function () { called = true })
			var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
			setTimeout(callback, duration)
			return this
		}
	
		$(function () {
			$.support.transition = transitionEnd()
		})
	
	}(jQuery);


/***/ }),

/***/ 428:
/***/ (function(module, exports) {

	/* **********************************************
	 Begin bootstrap-rating-input.js
	 ********************************************** */
	
	(function ($) {
	
		$.fn.rating = function () {
	
			var element;
	
			// A private function to highlight a star corresponding to a given value
			function _paintValue(ratingInput, value) {
				var selectedStar = $(ratingInput).find('[data-value=' + value + ']');
				selectedStar.removeClass('glyphicon-star-empty').addClass('glyphicon-star');
				selectedStar.prevAll('[data-value]').removeClass('glyphicon-star-empty').addClass('glyphicon-star');
				selectedStar.nextAll('[data-value]').removeClass('glyphicon-star').addClass('glyphicon-star-empty');
			}
	
			// A private function to remove the selected rating
			function _clearValue(ratingInput) {
				var self = $(ratingInput);
				self.find('[data-value]').removeClass('glyphicon-star').addClass('glyphicon-star-empty');
				self.find('.rating-clear').hide();
				var input = self.find('input');
				input.val(input.data('empty-value')).trigger('change');
			}
	
			// Iterate and transform all selected inputs
			for (element = this.length - 1; element >= 0; element--) {
	
				var el, i,
					originalInput = $(this[element]),
					max = originalInput.data('max') || 4,
					min = originalInput.data('min') || 0,
					clearable = originalInput.data('clearable') || null,
					stars = '';
	
				// HTML element construction
				for (i = min; i <= max; i++) {
					// Create <max> empty stars
					stars += ['<span class="glyphicon glyphicon-star-empty" data-value="', i, '"></span>'].join('');
				}
				// Add a clear link if clearable option is set
				if (clearable) {
					stars += [
						' <a class="rating-clear" style="display:none;" href="javascript:void">',
						'<span class="glyphicon glyphicon-remove"></span> ',
						clearable,
						'</a>'].join('');
				}
	
				// Clone the original input to preserve any additional data bindings using attributes.
				var newInput = originalInput.clone()
					.attr('type', 'hidden')
					.data('max', max)
					.data('min', min);
	
				// Rating widget is wrapped inside a div
				el = [
					'<div class="rating-input">',
					stars,
					'</div>'].join('');
	
				// Replace original inputs HTML with the new one
				originalInput.replaceWith($(el).append(newInput));
	
			}
	
			// Give live to the newly generated widgets
			$('.rating-input')
				// Highlight stars on hovering
				.on('mouseenter', '[data-value]', function () {
					var self = $(this);
					_paintValue(self.closest('.rating-input'), self.data('value'));
				})
				// View current value while mouse is out
				.on('mouseleave', '[data-value]', function () {
					var self = $(this),
						input = self.siblings('input'),
						val = input.val(),
						min = input.data('min'),
						max = input.data('max');
					if (val >= min && val <= max) {
						_paintValue(self.closest('.rating-input'), val);
					} else {
						_clearValue(self.closest('.rating-input'));
					}
				})
				// Set the selected value to the hidden field
				.on('click', '[data-value]', function (e) {
					var self = $(this);
					var val = self.data('value');
					self.siblings('input').val(val).trigger('change');
					self.siblings('.rating-clear').show();
					e.preventDefault();
					return false;
				})
				// Remove value on clear
				.on('click', '.rating-clear', function (e) {
					_clearValue($(this).closest('.rating-input'));
					e.preventDefault();
					return false;
				})
				// Initialize view with default value
				.each(function () {
					var input = $(this).find('input'),
						val = input.val(),
						min = input.data('min'),
						max = input.data('max');
					if (val !== "" && +val >= min && +val <= max) {
						_paintValue(this, val);
						$(this).find('.rating-clear').show();
					}
					else {
						_clearValue(this);
					}
				});
	
		};
	
		// Auto apply conversion of number fields with class 'rating' into rating-fields
		$(function () {
			if ($('input.rating[type=number]').length > 0) {
				$('input.rating[type=number]').rating();
			}
		});
	
	}(jQuery));


/***/ }),

/***/ 429:
/***/ (function(module, exports) {

	/**
	 * jQuery Unveil
	 * A very lightweight jQuery plugin to lazy load images
	 * http://luis-almeida.github.com/unveil
	 *
	 * Licensed under the MIT license.
	 * Copyright 2013 Luís Almeida
	 * https://github.com/luis-almeida
	 */
	
	;(function($) {
	
		$.fn.unveil = function(threshold, callback) {
	
			var $w = $(window),
				th = threshold || 0,
				retina = window.devicePixelRatio > 1,
				attrib = retina? "data-src-retina" : "data-src",
				images = this,
				loaded;
	
			this.one("unveil", function() {
				var source = this.getAttribute(attrib);
				source = source || this.getAttribute("data-src");
				if (source) {
					this.setAttribute("src", source);
					if (typeof callback === "function") callback.call(this);
				}
			});
	
			function unveil() {
				var inview = images.filter(function() {
					var $e = $(this);
					if ($e.is(":hidden")) return;
	
					var wt = $w.scrollTop(),
						wb = wt + $w.height(),
						et = $e.offset().top,
						eb = et + $e.height();
	
					return eb >= wt - th && et <= wb + th;
				});
	
				loaded = inview.trigger("unveil");
				images = images.not(loaded);
			}
	
			$w.on("scroll.unveil resize.unveil lookup.unveil load.unveil", unveil);
	
			unveil();
	
			return this;
	
		};
	
	})(window.jQuery || window.Zepto);


/***/ }),

/***/ 430:
/***/ (function(module, exports) {

	/* **********************************************
	 Begin bootstrap-select.js
	 ********************************************** */
	
	/*!
	 * bootstrap-select v1.4.3
	 * http://silviomoreto.github.io/bootstrap-select/
	 *
	 * Copyright 2013 bootstrap-select
	 * Licensed under the MIT license
	 */
	
	!function($) {
	
		'use strict';
	
		$.expr[':'].icontains = function(obj, index, meta) {
			return $(obj).text().toUpperCase().indexOf(meta[3].toUpperCase()) >= 0;
		};
	
		var Selectpicker = function(element, options, e) {
			if (e) {
				e.stopPropagation();
				e.preventDefault();
			}
			this.$element = $(element);
			this.$newElement = null;
			this.$button = null;
			this.$menu = null;
			this.$lis = null;
	
			//Merge defaults, options and data-attributes to make our options
			this.options = $.extend({}, $.fn.selectpicker.defaults, this.$element.data(), typeof options == 'object' && options);
	
			//If we have no title yet, ^ the attribute 'title' (this is missed by jq as its not a data-attribute
			if (this.options.title === null) {
				this.options.title = this.$element.attr('title');
			}
	
			//Expose public methods
			this.val = Selectpicker.prototype.val;
			this.render = Selectpicker.prototype.render;
			this.refresh = Selectpicker.prototype.refresh;
			this.setStyle = Selectpicker.prototype.setStyle;
			this.selectAll = Selectpicker.prototype.selectAll;
			this.deselectAll = Selectpicker.prototype.deselectAll;
			this.init();
		};
	
		Selectpicker.prototype = {
	
			constructor: Selectpicker,
	
			init: function() {
				var that = this,
					id = this.$element.attr('id');
	
				this.$element.hide();
				this.multiple = this.$element.prop('multiple');
				this.autofocus = this.$element.prop('autofocus');
				this.$newElement = this.createView();
				this.$element.after(this.$newElement);
				this.$menu = this.$newElement.find('> .dropdown-menu');
				this.$button = this.$newElement.find('> button');
				this.$searchbox = this.$newElement.find('input');
	
				if (id !== undefined) {
					this.$button.attr('data-id', id);
					$('label[for="' + id + '"]').click(function(e) {
						e.preventDefault();
						that.$button.focus();
					});
				}
	
				this.checkDisabled();
				this.clickListener();
				if (this.options.liveSearch) this.liveSearchListener();
				this.render();
				this.liHeight();
				this.setStyle();
				this.setWidth();
				if (this.options.container) this.selectPosition();
				this.$menu.data('this', this);
				this.$newElement.data('this', this);
			},
	
			createDropdown: function() {
				//If we are multiple, then add the show-tick class by default
				var multiple = this.multiple ? ' show-tick' : '';
				var autofocus = this.autofocus ? ' autofocus' : '';
				var header = this.options.header ? '<div class="popover-title"><button type="button" class="close" aria-hidden="true">&times;</button>' + this.options.header + '</div>' : '';
				var searchbox = this.options.liveSearch ? '<div class="bootstrap-select-searchbox"><input type="text" class="input-block-level form-control" /></div>' : '';
				var drop =
					'<div class="btn-group bootstrap-select' + multiple + '">' +
						'<button type="button" class="btn dropdown-toggle selectpicker" data-toggle="dropdown"'+ autofocus +'>' +
						'<span class="filter-option pull-left"></span>&nbsp;' +
						'</button>' +
						'<div class="dropdown-menu open">' +
						header +
						searchbox +
						'<ul class="dropdown-menu inner selectpicker" role="menu">' +
						'</ul>' +
						'</div>' +
						'</div>';
	
				return $(drop);
			},
	
			createView: function() {
				var $drop = this.createDropdown();
				var $li = this.createLi();
				$drop.find('ul').append($li);
				return $drop;
			},
	
			reloadLi: function() {
				//Remove all children.
				this.destroyLi();
				//Re build
				var $li = this.createLi();
				this.$menu.find('ul').append( $li );
			},
	
			destroyLi: function() {
				this.$menu.find('li').remove();
			},
	
			createLi: function() {
				var that = this,
					_liA = [],
					_liHtml = '';
	
				this.$element.find('option').each(function() {
					var $this = $(this);
	
					//Get the class and text for the option
					var optionClass = $this.attr('class') || '';
					var inline = $this.attr('style') || '';
					var text =  $this.data('content') ? $this.data('content') : $this.html();
					var subtext = $this.data('subtext') !== undefined ? '<small class="muted text-muted">' + $this.data('subtext') + '</small>' : '';
					var icon = $this.data('icon') !== undefined ? '<i class="' + that.options.iconBase + ' ' + $this.data('icon') + '"></i> ' : '';
					if (icon !== '' && ($this.is(':disabled') || $this.parent().is(':disabled'))) {
						icon = '<span>'+icon+'</span>';
					}
	
					if (!$this.data('content')) {
						//Prepend any icon and append any subtext to the main text.
						text = icon + '<span class="text">' + text + subtext + '</span>';
					}
	
					if (that.options.hideDisabled && ($this.is(':disabled') || $this.parent().is(':disabled'))) {
						_liA.push('<a style="min-height: 0; padding: 0"></a>');
					} else if ($this.parent().is('optgroup') && $this.data('divider') !== true) {
						if ($this.index() === 0) {
							//Get the opt group label
							var label = $this.parent().attr('label');
							var labelSubtext = $this.parent().data('subtext') !== undefined ? '<small class="muted text-muted">'+$this.parent().data('subtext')+'</small>' : '';
							var labelIcon = $this.parent().data('icon') ? '<i class="'+$this.parent().data('icon')+'"></i> ' : '';
							label = labelIcon + '<span class="text">' + label + labelSubtext + '</span>';
	
							if ($this[0].index !== 0) {
								_liA.push(
									'<div class="div-contain"><div class="divider"></div></div>'+
										'<dt>'+label+'</dt>'+
										that.createA(text, 'opt ' + optionClass, inline )
								);
							} else {
								_liA.push(
									'<dt>'+label+'</dt>'+
										that.createA(text, 'opt ' + optionClass, inline ));
							}
						} else {
							_liA.push(that.createA(text, 'opt ' + optionClass, inline ));
						}
					} else if ($this.data('divider') === true) {
						_liA.push('<div class="div-contain"><div class="divider"></div></div>');
					} else if ($(this).data('hidden') === true) {
						_liA.push('');
					} else {
						_liA.push(that.createA(text, optionClass, inline ));
					}
				});
	
				$.each(_liA, function(i, item) {
					_liHtml += '<li rel=' + i + '>' + item + '</li>';
				});
	
				//If we are not multiple, and we dont have a selected item, and we dont have a title, select the first element so something is set in the button
				if (!this.multiple && this.$element.find('option:selected').length===0 && !this.options.title) {
					this.$element.find('option').eq(0).prop('selected', true).attr('selected', 'selected');
				}
	
				return $(_liHtml);
			},
	
			createA: function(text, classes, inline) {
				return '<a tabindex="0" class="'+classes+'" style="'+inline+'">' +
					text +
					'<i class="' + this.options.iconBase + ' ' + this.options.tickIcon + ' icon-ok check-mark"></i>' +
					'</a>';
			},
	
			render: function(updateLi) {
				var that = this;
	
				//Update the LI to match the SELECT
				if (updateLi !== false) {
					this.$element.find('option').each(function(index) {
						that.setDisabled(index, $(this).is(':disabled') || $(this).parent().is(':disabled') );
						that.setSelected(index, $(this).is(':selected') );
					});
				}
	
				this.tabIndex();
	
				var selectedItems = this.$element.find('option:selected').map(function() {
					var $this = $(this);
					var icon = $this.data('icon') && that.options.showIcon ? '<i class="' + that.options.iconBase + ' ' + $this.data('icon') + '"></i> ' : '';
					var subtext;
					if (that.options.showSubtext && $this.attr('data-subtext') && !that.multiple) {
						subtext = ' <small class="muted text-muted">'+$this.data('subtext') +'</small>';
					} else {
						subtext = '';
					}
					if ($this.data('content') && that.options.showContent) {
						return $this.data('content');
					} else if ($this.attr('title') !== undefined) {
						return $this.attr('title');
					} else {
						return icon + subtext + $this.html();
					}
				}).toArray();
	
				//Fixes issue in IE10 occurring when no default option is selected and at least one option is disabled
				//Convert all the values into a comma delimited string
				var title = !this.multiple ? selectedItems[0] : selectedItems.join(this.options.multipleSeparator);
	
				//If this is multi select, and the selectText type is count, the show 1 of 2 selected etc..
				if (this.multiple && this.options.selectedTextFormat.indexOf('count') > -1) {
					var max = this.options.selectedTextFormat.split('>');
					var notDisabled = this.options.hideDisabled ? ':not([disabled])' : '';
					if ( (max.length>1 && selectedItems.length > max[1]) || (max.length==1 && selectedItems.length>=2)) {
						title = this.options.countSelectedText.replace('{0}', selectedItems.length).replace('{1}', this.$element.find('option:not([data-divider="true"]):not([data-hidden="true"])'+notDisabled).length);
					}
				}
	
				//If we dont have a title, then use the default, or if nothing is set at all, use the not selected text
				if (!title) {
					title = this.options.title !== undefined ? this.options.title : this.options.noneSelectedText;
				}
	
				//strip all html-tags and trim the result (from https://github.com/silviomoreto/bootstrap-select/commit/9650583fb24cce45ba443334f031e1215df3605f)
				this.$button.attr('title', $.trim(title.replace(/<[^>]*>?/g, '')));
				this.$button.attr('aria-label', $.trim(title.replace(/<[^>]*>?/g, '')));
				this.$newElement.find('.filter-option').html(title);
			},
	
			setStyle: function(style, status) {
				if (this.$element.attr('class')) {
					this.$newElement.addClass(this.$element.attr('class').replace(/selectpicker|mobile-device/gi, ''));
				}
	
				var buttonClass = style ? style : this.options.style;
	
				if (status == 'add') {
					this.$button.addClass(buttonClass);
				} else if (status == 'remove') {
					this.$button.removeClass(buttonClass);
				} else {
					this.$button.removeClass(this.options.style);
					this.$button.addClass(buttonClass);
				}
			},
	
			liHeight: function() {
				var $selectClone = this.$menu.parent().clone().find('> .dropdown-toggle').prop('autofocus', false).end().appendTo('body'),
					$menuClone = $selectClone.addClass('open').find('> .dropdown-menu'),
					liHeight = $menuClone.find('li > a').outerHeight(),
					headerHeight = this.options.header ? $menuClone.find('.popover-title').outerHeight() : 0,
					searchHeight = this.options.liveSearch ? $menuClone.find('.bootstrap-select-searchbox').outerHeight() : 0;
	
				$selectClone.remove();
	
				this.$newElement
					.data('liHeight', liHeight)
					.data('headerHeight', headerHeight)
					.data('searchHeight', searchHeight);
			},
	
			setSize: function() {
				var that = this,
					menu = this.$menu,
					menuInner = menu.find('.inner'),
					selectHeight = this.$newElement.outerHeight(),
					liHeight = this.$newElement.data('liHeight'),
					headerHeight = this.$newElement.data('headerHeight'),
					searchHeight = this.$newElement.data('searchHeight'),
					divHeight = menu.find('li .divider').outerHeight(true),
					menuPadding = parseInt(menu.css('padding-top')) +
						parseInt(menu.css('padding-bottom')) +
						parseInt(menu.css('border-top-width')) +
						parseInt(menu.css('border-bottom-width')),
					notDisabled = this.options.hideDisabled ? ':not(.disabled)' : '',
					$window = $(window),
					menuExtras = menuPadding + parseInt(menu.css('margin-top')) + parseInt(menu.css('margin-bottom')) + 2,
					menuHeight,
					selectOffsetTop,
					selectOffsetBot,
					posVert = function() {
						selectOffsetTop = that.$newElement.offset().top - $window.scrollTop();
						selectOffsetBot = $window.height() - selectOffsetTop - selectHeight;
					};
				posVert();
				if (this.options.header) menu.css('padding-top', 0);
	
				if (this.options.size == 'auto') {
					var getSize = function() {
						var minHeight;
						posVert();
						menuHeight = selectOffsetBot - menuExtras;
						if (that.options.dropupAuto) {
							that.$newElement.toggleClass('dropup', (selectOffsetTop > selectOffsetBot) && ((menuHeight - menuExtras) < menu.height()));
						}
						if (that.$newElement.hasClass('dropup')) {
							menuHeight = selectOffsetTop - menuExtras;
						}
						if ((menu.find('li').length + menu.find('dt').length) > 3) {
							minHeight = liHeight*3 + menuExtras - 2;
						} else {
							minHeight = 0;
						}
						menu.css({'max-height' : menuHeight + 'px', 'overflow' : 'hidden', 'min-height' : minHeight + 'px'});
						menuInner.css({'max-height' : menuHeight - headerHeight - searchHeight- menuPadding + 'px', 'overflow-y' : 'auto', 'min-height' : minHeight - menuPadding + 'px'});
					};
					getSize();
					$(window).resize(getSize);
					$(window).scroll(getSize);
				} else if (this.options.size && this.options.size != 'auto' && menu.find('li'+notDisabled).length > this.options.size) {
					var optIndex = menu.find('li'+notDisabled+' > *').filter(':not(.div-contain)').slice(0,this.options.size).last().parent().index();
					var divLength = menu.find('li').slice(0,optIndex + 1).find('.div-contain').length;
					menuHeight = liHeight*this.options.size + divLength*divHeight + menuPadding;
					if (that.options.dropupAuto) {
						this.$newElement.toggleClass('dropup', (selectOffsetTop > selectOffsetBot) && (menuHeight < menu.height()));
					}
					menu.css({'max-height' : menuHeight + headerHeight + searchHeight + 'px', 'overflow' : 'hidden'});
					menuInner.css({'max-height' : menuHeight - menuPadding + 'px', 'overflow-y' : 'auto'});
				}
			},
	
			setWidth: function() {
				if (this.options.width == 'auto') {
					this.$menu.css('min-width', '0');
	
					// Get correct width if element hidden
					var selectClone = this.$newElement.clone().appendTo('body');
					var ulWidth = selectClone.find('> .dropdown-menu').css('width');
					selectClone.remove();
	
					this.$newElement.css('width', ulWidth);
				} else if (this.options.width == 'fit') {
					// Remove inline min-width so width can be changed from 'auto'
					this.$menu.css('min-width', '');
					this.$newElement.css('width', '').addClass('fit-width');
				} else if (this.options.width) {
					// Remove inline min-width so width can be changed from 'auto'
					this.$menu.css('min-width', '');
					this.$newElement.css('width', this.options.width);
				} else {
					// Remove inline min-width/width so width can be changed
					this.$menu.css('min-width', '');
					this.$newElement.css('width', '');
				}
				// Remove fit-width class if width is changed programmatically
				if (this.$newElement.hasClass('fit-width') && this.options.width !== 'fit') {
					this.$newElement.removeClass('fit-width');
				}
			},
	
			selectPosition: function() {
				var that = this,
					drop = '<div />',
					$drop = $(drop),
					pos,
					actualHeight,
					getPlacement = function($element) {
						$drop.addClass($element.attr('class')).toggleClass('dropup', $element.hasClass('dropup'));
						pos = $element.offset();
						actualHeight = $element.hasClass('dropup') ? 0 : $element[0].offsetHeight;
						$drop.css({'top' : pos.top + actualHeight, 'left' : pos.left, 'width' : $element[0].offsetWidth, 'position' : 'absolute'});
					};
				this.$newElement.on('click', function() {
					getPlacement($(this));
					$drop.appendTo(that.options.container);
					$drop.toggleClass('open', !$(this).hasClass('open'));
					$drop.append(that.$menu);
				});
				$(window).resize(function() {
					getPlacement(that.$newElement);
				});
				$(window).on('scroll', function() {
					getPlacement(that.$newElement);
				});
				$('html').on('click', function(e) {
					if ($(e.target).closest(that.$newElement).length < 1) {
						$drop.removeClass('open');
					}
				});
			},
	
			mobile: function() {
				this.$element.addClass('mobile-device').appendTo(this.$newElement);
				if (this.options.container) this.$menu.hide();
			},
	
			refresh: function() {
				this.$lis = null;
				this.reloadLi();
				this.render();
				this.setWidth();
				this.setStyle();
				this.checkDisabled();
				this.liHeight();
			},
	
			update: function() {
				this.reloadLi();
				this.setWidth();
				this.setStyle();
				this.checkDisabled();
				this.liHeight();
			},
	
			setSelected: function(index, selected) {
				if (this.$lis == null) this.$lis = this.$menu.find('li');
				$(this.$lis[index]).toggleClass('selected', selected);
			},
	
			setDisabled: function(index, disabled) {
				if (this.$lis == null) this.$lis = this.$menu.find('li');
				if (disabled) {
					$(this.$lis[index]).addClass('disabled').find('a').attr('href', '#').attr('tabindex', -1).attr('aria-hidden', 'true');
				} else {
					$(this.$lis[index]).removeClass('disabled').find('a').removeAttr('href').attr('tabindex', 0).removeAttr('aria-hidden');
				}
			},
	
			isDisabled: function() {
				return this.$element.is(':disabled');
			},
	
			checkDisabled: function() {
				var that = this;
	
				if (this.isDisabled()) {
					this.$button.addClass('disabled').attr('tabindex', -1);
				} else {
					if (this.$button.hasClass('disabled')) {
						this.$button.removeClass('disabled');
					}
	
					if (this.$button.attr('tabindex') == -1) {
						if (!this.$element.data('tabindex')) this.$button.removeAttr('tabindex');
					}
				}
	
				this.$button.click(function() {
					return !that.isDisabled();
				});
			},
	
			tabIndex: function() {
				if (this.$element.is('[tabindex]')) {
					this.$element.data('tabindex', this.$element.attr('tabindex'));
					this.$button.attr('tabindex', this.$element.data('tabindex'));
				}
			},
	
			clickListener: function() {
				var that = this;
	
				$('body').on('touchstart.dropdown', '.dropdown-menu', function(e) {
					e.stopPropagation();
				});
	
				this.$newElement.on('click', function() {
					that.setSize();
					if (!that.options.liveSearch && !that.multiple) {
						setTimeout(function() {
							that.$menu.find('.selected a').focus();
						}, 10);
					}
				});
	
				this.$menu.on('click', 'li a', function(e) {
					var clickedIndex = $(this).parent().index(),
						prevValue = that.$element.val(),
						prevIndex = that.$element.prop('selectedIndex');
	
					//Dont close on multi choice menu
					if (that.multiple) {
						e.stopPropagation();
					}
	
					e.preventDefault();
	
					//Dont run if we have been disabled
					if (!that.isDisabled() && !$(this).parent().hasClass('disabled')) {
						var $options = that.$element.find('option'),
							$option = $options.eq(clickedIndex),
							state = $option.prop('selected');
	
						//Deselect all others if not multi select box
						if (!that.multiple) {
							$options.prop('selected', false);
							$option.prop('selected', true);
							that.$menu.find('.selected').removeClass('selected');
							that.setSelected(clickedIndex, true);
						}
						//Else toggle the one we have chosen if we are multi select.
						else {
							$option.prop('selected', !state);
							that.setSelected(clickedIndex, !state);
						}
	
						if (!that.multiple) {
							that.$button.focus();
						} else if (that.options.liveSearch) {
							that.$searchbox.focus();
						}
	
						// Trigger select 'change'
						if ((prevValue != that.$element.val() && that.multiple) || (prevIndex != that.$element.prop('selectedIndex') && !that.multiple)) {
							that.$element.change();
						}
					}
				});
	
				this.$menu.on('click', 'li.disabled a, li dt, li .div-contain, .popover-title, .popover-title :not(.close)', function(e) {
					if (e.currentTarget == this) { // fix for not closing dropdown when clicking on anchor text >>> https://github.com/twbs/bootstrap/issues/4497 & https://github.com/silviomoreto/bootstrap-select/commit/8f3e32c75e6760473d61e5694ef96ced39975c06
						e.preventDefault();
						e.stopPropagation();
						if (!that.options.liveSearch) {
							that.$button.focus();
						} else {
							that.$searchbox.focus();
						}
					}
				});
	
				this.$menu.on('click', '.popover-title .close', function() {
					that.$button.focus();
				});
	
				this.$searchbox.on('click', function(e) {
					e.stopPropagation();
				});
	
				this.$element.change(function() {
					that.render(false);
				});
			},
	
			liveSearchListener: function() {
				var that = this,
					no_results = $('<li class="no-results"></li>');
	
				this.$newElement.on('click.dropdown.data-api', function() {
					that.$menu.find('.active').removeClass('active');
					if (!!that.$searchbox.val()) {
						that.$searchbox.val('');
						that.$menu.find('li').show();
						if (!!no_results.parent().length) no_results.remove();
					}
					if (!that.multiple) that.$menu.find('.selected').addClass('active');
					setTimeout(function() {
						that.$searchbox.focus();
					}, 10);
				});
	
				this.$searchbox.on('input propertychange', function() {
					if (that.$searchbox.val()) {
						that.$menu.find('li').show().not(':icontains(' + that.$searchbox.val() + ')').hide();
	
						if (!that.$menu.find('li').filter(':visible:not(.no-results)').length) {
							if (!!no_results.parent().length) no_results.remove();
							no_results.html(that.options.noneResultsText + ' "'+ that.$searchbox.val() + '"').show();
							that.$menu.find('li').last().after(no_results);
						} else if (!!no_results.parent().length) {
							no_results.remove();
						}
	
					} else {
						that.$menu.find('li').show();
						if (!!no_results.parent().length) no_results.remove();
					}
	
					that.$menu.find('li.active').removeClass('active');
					that.$menu.find('li').filter(':visible:not(.divider)').eq(0).addClass('active').find('a').focus();
					$(this).focus();
				});
	
				this.$menu.on('mouseenter', 'a', function(e) {
					that.$menu.find('.active').removeClass('active');
					$(e.currentTarget).parent().not('.disabled').addClass('active');
				});
	
				this.$menu.on('mouseleave', 'a', function() {
					that.$menu.find('.active').removeClass('active');
				});
			},
	
			val: function(value) {
	
				if (value !== undefined) {
					this.$element.val( value );
	
					this.$element.change();
					return this.$element;
				} else {
					return this.$element.val();
				}
			},
	
			selectAll: function() {
				this.$element.find('option').prop('selected', true).attr('selected', 'selected');
				this.render();
			},
	
			deselectAll: function() {
				this.$element.find('option').prop('selected', false).removeAttr('selected');
				this.render();
			},
	
			keydown: function(e) {
				var $this,
					$items,
					$parent,
					index,
					next,
					first,
					last,
					prev,
					nextPrev,
					that,
					prevIndex,
					isActive,
					keyCodeMap = {
						32:' ', 48:'0', 49:'1', 50:'2', 51:'3', 52:'4', 53:'5', 54:'6', 55:'7', 56:'8', 57:'9', 59:';',
						65:'a', 66:'b', 67:'c', 68:'d', 69:'e', 70:'f', 71:'g', 72:'h', 73:'i', 74:'j', 75:'k', 76:'l',
						77:'m', 78:'n', 79:'o', 80:'p', 81:'q', 82:'r', 83:'s', 84:'t', 85:'u', 86:'v', 87:'w', 88:'x',
						89:'y', 90:'z', 96:'0', 97:'1', 98:'2', 99:'3', 100:'4', 101:'5', 102:'6', 103:'7', 104:'8', 105:'9'
					};
	
				$this = $(this);
	
				$parent = $this.parent();
	
				if ($this.is('input')) $parent = $this.parent().parent();
	
				that = $parent.data('this');
	
				if (that.options.liveSearch) $parent = $this.parent().parent();
	
				if (that.options.container) $parent = that.$menu;
	
				$items = $('[role=menu] li:not(.divider) a', $parent);
	
				isActive = that.$menu.parent().hasClass('open');
	
				if (!isActive && /([0-9]|[A-z])/.test(String.fromCharCode(e.keyCode))) {
					that.setSize();
					that.$menu.parent().addClass('open');
					isActive = that.$menu.parent().hasClass('open');
					that.$searchbox.focus();
				}
	
				if (that.options.liveSearch) {
					if (/(^9$|27)/.test(e.keyCode) && isActive && that.$menu.find('.active').length === 0) {
						e.preventDefault();
						that.$menu.parent().removeClass('open');
						that.$button.focus();
					}
					$items = $('[role=menu] li:not(.divider):visible', $parent);
					if (!$this.val() && !/(38|40)/.test(e.keyCode)) {
						if ($items.filter('.active').length === 0) {
							$items = that.$newElement.find('li').filter(':icontains(' + keyCodeMap[e.keyCode] + ')');
						}
					}
				}
	
				if (!$items.length) return;
	
				if (/(38|40)/.test(e.keyCode)) {
	
					index = $items.index($items.filter(':focus'));
					first = $items.parent(':not(.disabled):visible').first().index();
					last = $items.parent(':not(.disabled):visible').last().index();
					next = $items.eq(index).parent().nextAll(':not(.disabled):visible').eq(0).index();
					prev = $items.eq(index).parent().prevAll(':not(.disabled):visible').eq(0).index();
					nextPrev = $items.eq(next).parent().prevAll(':not(.disabled):visible').eq(0).index();
	
					if (that.options.liveSearch) {
						$items.each(function(i) {
							if ($(this).is(':not(.disabled)')) {
								$(this).data('index', i);
							}
						});
						index = $items.index($items.filter('.active'));
						first = $items.filter(':not(.disabled):visible').first().data('index');
						last = $items.filter(':not(.disabled):visible').last().data('index');
						next = $items.eq(index).nextAll(':not(.disabled):visible').eq(0).data('index');
						prev = $items.eq(index).prevAll(':not(.disabled):visible').eq(0).data('index');
						nextPrev = $items.eq(next).prevAll(':not(.disabled):visible').eq(0).data('index');
					}
	
					prevIndex = $this.data('prevIndex');
	
					if (e.keyCode == 38) {
						if (that.options.liveSearch) index -= 1;
						if (index != nextPrev && index > prev) index = prev;
						if (index < first) index = first;
						if (index == prevIndex) index = last;
					}
	
					if (e.keyCode == 40) {
						if (that.options.liveSearch) index += 1;
						if (index == -1) index = 0;
						if (index != nextPrev && index < next) index = next;
						if (index > last) index = last;
						if (index == prevIndex) index = first;
					}
	
					$this.data('prevIndex', index);
	
					if (!that.options.liveSearch) {
						$items.eq(index).focus();
					} else {
						e.preventDefault();
						if (!$this.is('.dropdown-toggle')) {
							$items.removeClass('active');
							$items.eq(index).addClass('active').find('a').focus();
							$this.focus();
						}
					}
	
				} else if (!$this.is('input')) {
	
					var keyIndex = [],
						count,
						prevKey;
	
					$items.each(function() {
						if ($(this).parent().is(':not(.disabled)')) {
							if ($.trim($(this).text().toLowerCase()).substring(0,1) == keyCodeMap[e.keyCode]) {
								keyIndex.push($(this).parent().index());
							}
						}
					});
	
					count = $(document).data('keycount');
					count++;
					$(document).data('keycount',count);
	
					prevKey = $.trim($(':focus').text().toLowerCase()).substring(0,1);
	
					if (prevKey != keyCodeMap[e.keyCode]) {
						count = 1;
						$(document).data('keycount', count);
					} else if (count >= keyIndex.length) {
						$(document).data('keycount', 0);
						if (count > keyIndex.length) count = 1;
					}
	
					$items.eq(keyIndex[count - 1]).focus();
				}
	
				// Select focused option if "Enter", "Spacebar", "Tab" are pressed inside the menu.
				if (/(13|32|^9$)/.test(e.keyCode) && isActive) {
					if (!/(32)/.test(e.keyCode)) e.preventDefault();
					if (!that.options.liveSearch) {
						$(':focus').click();
					} else if (!/(32)/.test(e.keyCode)) {
						that.$menu.find('.active a').click();
						$this.focus();
					}
					$(document).data('keycount',0);
				}
	
				if ((/(^9$|27)/.test(e.keyCode) && isActive && (that.multiple || that.options.liveSearch)) || (/(27)/.test(e.keyCode) && !isActive)) {
					that.$menu.parent().removeClass('open');
					that.$button.focus();
				}
	
			},
	
			hide: function() {
				this.$newElement.hide();
			},
	
			show: function() {
				this.$newElement.show();
			},
	
			destroy: function() {
				this.$newElement.remove();
				this.$element.remove();
			}
		};
	
		$.fn.selectpicker = function(option, event) {
			//get the args of the outer function..
			var args = arguments;
			var value;
			var chain = this.each(function() {
				if ($(this).is('select')) {
					var $this = $(this),
						data = $this.data('selectpicker'),
						options = typeof option == 'object' && option;
	
					if (!data) {
						$this.data('selectpicker', (data = new Selectpicker(this, options, event)));
					} else if (options) {
						for(var i in options) {
							data.options[i] = options[i];
						}
					}
	
					if (typeof option == 'string') {
						//Copy the value of option, as once we shift the arguments
						//it also shifts the value of option.
						var property = option;
						if (data[property] instanceof Function) {
							[].shift.apply(args);
							value = data[property].apply(data, args);
						} else {
							value = data.options[property];
						}
					}
				}
			});
	
			if (value !== undefined) {
				return value;
			} else {
				return chain;
			}
		};
	
		$.fn.selectpicker.defaults = {
			style: 'btn-default',
			size: 12,
			title: null,
			selectedTextFormat : 'values',
			noneSelectedText : 'Nothing selected',
			noneResultsText : 'No results match',
			countSelectedText: '{0} of {1} selected',
			width: false,
			container: false,
			hideDisabled: false,
			showSubtext: false,
			showIcon: true,
			showContent: true,
			dropupAuto: false,
			header: false,
			liveSearch: false,
			multipleSeparator: ', ',
			iconBase: 'sg',
			tickIcon: 'sg-check'
		};
	
		$(document)
			.data('keycount', 0)
			.on('keydown', '.bootstrap-select [data-toggle=dropdown], .bootstrap-select [role=menu], .bootstrap-select-searchbox input', Selectpicker.prototype.keydown)
			.on('focusin.modal', '.bootstrap-select [data-toggle=dropdown], .bootstrap-select [role=menu], .bootstrap-select-searchbox input', function (e) { e.stopPropagation(); });
	
	}(window.jQuery);


/***/ }),

/***/ 431:
/***/ (function(module, exports) {

	/* **********************************************
	 Begin bootstrapValidator.js
	 ********************************************** */
	
	/**
	 * BootstrapValidator (http://github.com/nghuuphuoc/bootstrapvalidator)
	 *
	 * A jQuery plugin to validate form fields. Use with Bootstrap 3
	 *
	 * @version     v0.3.1-dev
	 * @author      https://twitter.com/nghuuphuoc
	 * @copyright   (c) 2013 - 2014 Nguyen Huu Phuoc
	 * @license     MIT
	 */
	
	(function($) {
		var BootstrapValidator = function(form, options) {
			this.$form   = $(form);
			this.options = $.extend({}, BootstrapValidator.DEFAULT_OPTIONS, options);
	
			this.dfds    = {};      // Array of deferred
			this.results = {};      // Validating results
	
			this.invalidField  = null;  // First invalid field
			this.$submitButton = null;  // The submit button which is clicked to submit form
	
			this._init();
	
			this.STATUS_NOT_VALIDATED = 'NOT_VALIDATED';
			this.STATUS_VALIDATING    = 'VALIDATING';
			this.STATUS_INVALID       = 'INVALID';
			this.STATUS_VALID         = 'VALID';
		};
	
		// The default options
		BootstrapValidator.DEFAULT_OPTIONS = {
			// The form CSS class
			elementClass: 'bootstrap-validator-form',
	
			// Default invalid message
			message: 'This value is not valid',
	
			// The number of grid columns
			// Change it if you use custom grid with different number of columns
			columns: 12,
	
			// Shows ok/error/loading icons based on the field validity.
			// This feature requires Bootstrap v3.1.0 or later (http://getbootstrap.com/css/#forms-control-validation).
			// Since Bootstrap doesn't provide any methods to know its version, this option cannot be on/off automatically.
			// In other word, to use this feature you have to upgrade your Bootstrap to v3.1.0 or later.
			//
			// Examples:
			// - Use Glyphicons icons:
			//  feedbackIcons: {
			//      valid: 'glyphicon glyphicon-ok',
			//      invalid: 'glyphicon glyphicon-remove',
			//      validating: 'glyphicon glyphicon-refresh'
			//  }
			// - Use FontAwesome icons:
			//  feedbackIcons: {
			//      valid: 'fa fa-check',
			//      invalid: 'fa fa-times',
			//      validating: 'fa fa-refresh'
			//  }
			feedbackIcons: null,
	
			// The submit buttons selector
			// These buttons will be disabled to prevent the valid form from multiple submissions
			submitButtons: 'button[type="submit"]',
	
			// The custom submit handler
			// It will prevent the form from the default submission
			//
			//  submitHandler: function(validator, form) {
			//      - validator is the BootstrapValidator instance
			//      - form is the jQuery object present the current form
			//  }
			submitHandler: null,
	
			// Live validating option
			// Can be one of 3 values:
			// - enabled: The plugin validates fields as soon as they are changed
			// - disabled: Disable the live validating. The error messages are only shown after the form is submitted
			// - submitted: The live validating is enabled after the form is submitted
			live: 'enabled',
	
			// Map the field name with validator rules
			fields: null
		};
	
		BootstrapValidator.prototype = {
			constructor: BootstrapValidator,
	
			/**
			 * Init form
			 */
			_init: function() {
				if (this.options.fields == null) {
					return;
				}
	
				var that = this;
				this.$form
					// Disable client side validation in HTML 5
					.attr('novalidate', 'novalidate')
					.addClass(this.options.elementClass)
					// Disable the default submission first
					.on('submit.bootstrapValidator', function(e) {
						e.preventDefault();
						that.validate();
					})
					.find(this.options.submitButtons)
					.on('click', function() {
						that.$submitButton = $(this);
					});
	
				for (var field in this.options.fields) {
					this._initField(field);
				}
	
				this._setLiveValidating();
			},
	
			/**
			 * Init field
			 *
			 * @param {String} field The field name
			 */
			_initField: function(field) {
				if (this.options.fields[field] == null || this.options.fields[field].validators == null) {
					return;
				}
	
				this.dfds[field]    = {};
				this.results[field] = {};
	
				var fields = this.getFieldElements(field);
	
				// We don't need to validate ...
				if (fields == null                                      // ... non-existing fields
					|| (fields.length == 1 && fields.is(':disabled')))  // ... disabled field
				{
					delete this.options.fields[field];
					delete this.dfds[field];
					return;
				}
	
				// Create a help block element for showing the error
				var $field  = $(fields[0]),
					$parent = $field.parents('.form-group'),
				// Calculate the number of columns of the label/field element
				// Then set offset to the help block element
					label, cssClasses, offset, size;
	
				if (label = $parent.find('label').get(0)) {
					// The default Bootstrap form don't require class for label (http://getbootstrap.com/css/#forms)
					if (cssClasses = $(label).attr('class')) {
						cssClasses = cssClasses.split(' ');
						for (var i = 0; i < cssClasses.length; i++) {
							if (/^col-(xs|sm|md|lg)-\d+$/.test(cssClasses[i])) {
								offset = cssClasses[i].substr(7);
								size   = cssClasses[i].substr(4, 2);
								break;
							}
						}
					}
				} else if (cssClasses = $parent.children().eq(0).attr('class')) {
					cssClasses = cssClasses.split(' ');
					for (var i = 0; i < cssClasses.length; i++) {
						if (/^col-(xs|sm|md|lg)-offset-\d+$/.test(cssClasses[i])) {
							offset = cssClasses[i].substr(14);
							size   = cssClasses[i].substr(4, 2);
							break;
						}
					}
				}
	
				if (size && offset) {
					for (var validatorName in this.options.fields[field].validators) {
						if (!$.fn.bootstrapValidator.validators[validatorName]) {
							delete this.options.fields[field].validators[validatorName];
							continue;
						}
	
						this.results[field][validatorName] = this.STATUS_NOT_VALIDATED;
						$('<small/>')
							.css('display', 'none')
							.attr('data-bs-validator', validatorName)
							.addClass('help-block')
							.addClass(['col-', size, '-offset-', offset].join(''))
							.addClass(['col-', size, '-', this.options.columns - offset].join(''))
							.appendTo($parent);
					}
				}
	
				// Prepare the feedback icons
				// Available from Bootstrap 3.1 (http://getbootstrap.com/css/#forms-control-validation)
				if (this.options.feedbackIcons) {
					$parent.addClass('has-feedback');
					$('<i/>').css('display', 'none').addClass('form-control-feedback').insertAfter($(fields[fields.length - 1]));
				}
	
				if (this.options.fields[field]['enabled'] == null) {
					this.options.fields[field]['enabled'] = true;
				}
	
				// Whenever the user change the field value, mark it as not validated yet
				var that  = this,
					type  = fields.attr('type'),
					event = ('radio' == type || 'checkbox' == type || 'SELECT' == fields[0].tagName) ? 'change' : 'keyup';
				fields.on(event, function() {
					for (var v in that.options.fields[field].validators) {
						that.results[field][v] = that.STATUS_NOT_VALIDATED;
					}
				});
			},
	
			/**
			 * Enable live validating
			 */
			_setLiveValidating: function() {
				if ('enabled' == this.options.live) {
					var that = this;
					for (var field in this.options.fields) {
						(function(f) {
							var fields = that.getFieldElements(f);
							if (fields) {
								var type  = fields.attr('type'),
									event = ('radio' == type || 'checkbox' == type || 'SELECT' == fields[0].tagName) ? 'change' : 'keyup';
	
								fields.on(event, function() {
									that.validateField(f);
								});
							}
						})(field);
					}
				}
			},
	
			/**
			 * Disable/Enable submit buttons
			 *
			 * @param {Boolean} disabled
			 */
			_disableSubmitButtons: function(disabled) {
				if (!disabled) {
					this.$form.find(this.options.submitButtons).removeAttr('disabled');
				} else if (this.options.live != 'disabled') {
					// Don't disable if the live validating mode is disabled
					this.$form.find(this.options.submitButtons).attr('disabled', 'disabled');
				}
			},
	
			/**
			 * Called when all validations are completed
			 */
			_submit: function() {
				if (!this.isValid()) {
					if ('submitted' == this.options.live) {
						this.options.live = 'enabled';
						this._setLiveValidating();
					}
	
					// Focus to the first invalid field
					if (this.invalidField) {
						this.getFieldElements(this.invalidField).focus();
					}
					return;
				}
	
				this._disableSubmitButtons(true);
	
				// Call the custom submission if enabled
				if (this.options.submitHandler && 'function' == typeof this.options.submitHandler) {
					this.options.submitHandler.call(this, this, this.$form, this.$submitButton);
				} else {
					// Submit form
					this.$form.off('submit.bootstrapValidator').submit();
				}
			},
	
			// --- Public methods ---
	
			/**
			 * Retrieve the field elements by given name
			 *
			 * @param {String} field The field name
			 * @returns {null|jQuery[]}
			 */
			getFieldElements: function(field) {
				var fields = this.$form.find('[name="' + field + '"]');
				return (fields.length == 0) ? null : fields;
			},
	
			/**
			 * Validate the form
			 *
			 * @return {BootstrapValidator}
			 */
			validate: function() {
				if (!this.options.fields) {
					return this;
				}
				this._disableSubmitButtons(true);
	
				for (var field in this.options.fields) {
					this.validateField(field);
				}
	
				this._submit();
				return this;
			},
	
			/**
			 * Validate given field
			 *
			 * @param {String} field The field name
			 */
			validateField: function(field) {
				if (!this.options.fields[field]['enabled']) {
					return;
				}
	
				var that       = this,
					$field     = $(this.getFieldElements(field)[0]),
					validators = this.options.fields[field].validators,
					validatorName,
					validateResult;
	
				for (validatorName in validators) {
					if (this.dfds[field][validatorName]) {
						this.dfds[field][validatorName].reject();
					}
	
					// Don't validate field if it is already done
					if (this.results[field][validatorName] == this.STATUS_VALID || this.results[field][validatorName] == this.STATUS_INVALID) {
						continue;
					}
	
					this.results[field][validatorName] = this.STATUS_VALIDATING;
					validateResult = $.fn.bootstrapValidator.validators[validatorName].validate(this, $field, validators[validatorName]);
	
					if ('object' == typeof validateResult) {
						this.updateStatus($field, validatorName, this.STATUS_VALIDATING);
						this.dfds[field][validatorName] = validateResult;
	
						validateResult.done(function(isValid, v) {
							// v is validator name
							delete that.dfds[field][v];
							isValid ? that.updateStatus($field, v, that.STATUS_VALID)
								: that.updateStatus($field, v, that.STATUS_INVALID);
						});
					} else if ('boolean' == typeof validateResult) {
						validateResult ? this.updateStatus($field, validatorName, this.STATUS_VALID)
							: this.updateStatus($field, validatorName, this.STATUS_INVALID);
					}
				}
			},
	
			/**
			 * Check the form validity
			 *
			 * @returns {Boolean}
			 */
			isValid: function() {
				var field, validatorName;
				for (field in this.results) {
					if (!this.options.fields[field]['enabled']) {
						continue;
					}
	
					for (validatorName in this.results[field]) {
						if (this.results[field][validatorName] == this.STATUS_NOT_VALIDATED || this.results[field][validatorName] == this.STATUS_VALIDATING) {
							return false;
						}
	
						if (this.results[field][validatorName] == this.STATUS_INVALID) {
							this.invalidField = field;
							return false;
						}
					}
				}
	
				return true;
			},
	
			/**
			 * Update field status
			 *
			 * @param {jQuery} $field The field element
			 * @param {String} validatorName
			 * @param {String} status The status
			 * Can be STATUS_VALIDATING, STATUS_INVALID, STATUS_VALID
			 * @return {BootstrapValidator}
			 */
			updateStatus: function($field, validatorName, status) {
				var that      = this,
					field     = $field.attr('name'),
					validator = this.options.fields[field].validators[validatorName],
					message   = validator.message || this.options.message,
					$parent   = $field.parents('.form-group'),
					$errors   = $parent.find('.help-block[data-bs-validator]');
	
				switch (status) {
					case this.STATUS_VALIDATING:
						this.results[field][validatorName] = this.STATUS_VALIDATING;
						this._disableSubmitButtons(true);
	
						$parent.removeClass('has-success').removeClass('has-error');
						// TODO: Show validating message
						$errors.filter('.help-block[data-bs-validator="' + validatorName + '"]').html(message).hide();
	
						if (this.options.feedbackIcons) {
							// Show validating icon
							$parent.find('.form-control-feedback').removeClass(this.options.feedbackIcons.valid).removeClass(this.options.feedbackIcons.invalid).addClass(this.options.feedbackIcons.validating).show();
						}
						break;
	
					case this.STATUS_INVALID:
						this.results[field][validatorName] = this.STATUS_INVALID;
						this._disableSubmitButtons(true);
	
						// Add has-error class to parent element
						$parent.removeClass('has-success').addClass('has-error');
	
						$errors.filter('[data-bs-validator="' + validatorName + '"]').html(message).show();
	
						if (this.options.feedbackIcons) {
							// Show invalid icon
							$parent.find('.form-control-feedback').removeClass(this.options.feedbackIcons.valid).removeClass(this.options.feedbackIcons.validating).addClass(this.options.feedbackIcons.invalid).show();
						}
						break;
	
					case this.STATUS_VALID:
						this.results[field][validatorName] = this.STATUS_VALID;
	
						// Hide error element
						$errors.filter('[data-bs-validator="' + validatorName + '"]').hide();
	
						// If the field is valid
						if ($errors.filter(function() {
							var display = $(this).css('display'), v = $(this).attr('data-bs-validator');
							return ('block' == display) || (that.results[field][v] != that.STATUS_VALID);
						}).length == 0
							) {
							this._disableSubmitButtons(false);
	
							$parent.removeClass('has-error').addClass('has-success');
							// Show valid icon
							if (this.options.feedbackIcons) {
								$parent.find('.form-control-feedback').removeClass(this.options.feedbackIcons.invalid).removeClass(this.options.feedbackIcons.validating).addClass(this.options.feedbackIcons.valid).show();
							}
						}
						break;
	
					default:
						break;
				}
	
				return this;
			},
	
			// Useful APIs which aren't used internally
	
			/**
			 * Reset the form
			 *
			 * @param {Boolean} resetFormData Reset current form data
			 * @return {BootstrapValidator}
			 */
			resetForm: function(resetFormData) {
				for (var field in this.options.fields) {
					this.dfds[field]    = {};
					this.results[field] = {};
	
					// Mark all fields as not validated yet
					for (var v in this.options.fields[field].validators) {
						this.results[field][v] = this.STATUS_NOT_VALIDATED;
					}
				}
	
				this.invalidField  = null;
				this.$submitButton = null;
	
				// Hide all error elements
				this.$form
					.find('.has-error').removeClass('has-error').end()
					.find('.has-success').removeClass('has-success').end()
					.find('.help-block[data-bs-validator]').hide();
	
				// Enable submit buttons
				this._disableSubmitButtons(false);
	
				// Hide all feedback icons
				if (this.options.feedbackIcons) {
					this.$form.find('.form-control-feedback').removeClass(this.options.feedbackIcons.valid).removeClass(this.options.feedbackIcons.invalid).removeClass(this.options.feedbackIcons.validating).hide();
				}
	
				if (resetFormData) {
					this.$form.get(0).reset();
				}
	
				return this;
			},
	
			/**
			 * Enable/Disable all validators to given field
			 *
			 * @param {String} field The field name
			 * @param {Boolean} enabled Enable/Disable field validators
			 * @return {BootstrapValidator}
			 */
			enableFieldValidators: function(field, enabled) {
				this.options.fields[field]['enabled'] = enabled;
				if (!enabled) {
					// this.results[field] = {};
					for (var v in this.options.fields[field].validators) {
						this.results[field][v] = this.STATUS_NOT_VALIDATED;
					}
	
					var $field  = this.getFieldElements(field),
						$parent = $field.parents('.form-group');
	
					$parent.removeClass('has-success has-error').find('.help-block[data-bs-validator]').hide();
					if (this.options.feedbackIcons) {
						$parent.find('.form-control-feedback').removeClass(this.options.feedbackIcons.invalid).removeClass(this.options.feedbackIcons.validating).removeClass(this.options.feedbackIcons.valid).hide();
					}
	
					this._disableSubmitButtons(false);
				}
	
				return this;
			}
		};
	
		// Plugin definition
		$.fn.bootstrapValidator = function(options) {
			return this.each(function() {
				var $this = $(this), data = $this.data('bootstrapValidator');
				if (!data) {
					$this.data('bootstrapValidator', (data = new BootstrapValidator(this, options)));
				}
				if ('string' == typeof options) {
					data[options]();
				}
			});
		};
	
		// Available validators
		$.fn.bootstrapValidator.validators = {};
	
		$.fn.bootstrapValidator.Constructor = BootstrapValidator;
	}(window.jQuery));
	;(function($) {
		$.fn.bootstrapValidator.validators.between = {
			/**
			 * Return true if the input value is between (strictly or not) two given numbers
			 *
			 * @param {BootstrapValidator} validator The validator plugin instance
			 * @param {jQuery} $field Field element
			 * @param {Object} options Can consist of the following keys:
			 * - min
			 * - max
			 * - inclusive [optional]: Can be true or false. Default is true
			 * - message: The invalid message
			 * @returns {Boolean}
			 */
			validate: function(validator, $field, options) {
				var value = $field.val();
				if (value == '') {
					return true;
				}
	
				value = parseFloat(value);
				return (options.inclusive === true)
					? (value > options.min && value < options.max)
					: (value >= options.min && value <= options.max);
			}
		};
	}(window.jQuery));
	;(function($) {
		$.fn.bootstrapValidator.validators.callback = {
			/**
			 * Return result from the callback method
			 *
			 * @param {BootstrapValidator} validator The validator plugin instance
			 * @param {jQuery} $field Field element
			 * @param {Object} options Can consist of the following keys:
			 * - callback: The callback method that passes 2 parameters:
			 *      callback: function(fieldValue, validator) {
	         *          // fieldValue is the value of field
	         *          // validator is instance of BootstrapValidator
	         *      }
			 * - message: The invalid message
			 * @returns {Boolean|Deferred}
			 */
			validate: function(validator, $field, options) {
				var value = $field.val();
				if (options.callback && 'function' == typeof options.callback) {
					var dfd = new $.Deferred();
					dfd.resolve(options.callback.call(this, value, validator), 'callback');
					return dfd;
					return options.callback.call(this, value, validator);
				}
				return true;
			}
		};
	}(window.jQuery));
	;(function($) {
		$.fn.bootstrapValidator.validators.choice = {
			/**
			 * Check if the number of checked boxes are less or more than a given number
			 *
			 * @param {BootstrapValidator} validator The validator plugin instance
			 * @param {jQuery} $field Field element
			 * @param {Object} options Consists of following keys:
			 * - min
			 * - max
			 * At least one of two keys is required
			 * @returns {Boolean}
			 */
			validate: function(validator, $field, options) {
				var numChoices = validator
					.getFieldElements($field.attr('name'))
					.filter(':checked')
					.length;
				if ((options.min && numChoices < options.min) || (options.max && numChoices > options.max)) {
					return false;
				}
	
				return true;
			}
		};
	}(window.jQuery));
	;(function($) {
		$.fn.bootstrapValidator.validators.creditCard = {
			/**
			 * Return true if the input value is valid credit card number
			 * Based on https://gist.github.com/DiegoSalazar/4075533
			 *
			 * @param {BootstrapValidator} validator The validator plugin instance
			 * @param {jQuery} $field Field element
			 * @param {Object} options Can consist of the following key:
			 * - message: The invalid message
			 * @returns {Boolean}
			 */
			validate: function(validator, $field, options) {
				var value = $field.val();
				if (value == '') {
					return true;
				}
	
				// Accept only digits, dashes or spaces
				if (/[^0-9-\s]+/.test(value)) {
					return false;
				}
	
				// The Luhn Algorithm
				// http://en.wikipedia.org/wiki/Luhn
				value = value.replace(/\D/g, '');
				var check = 0, digit = 0, even = false, length = value.length;
	
				for (var n = length - 1; n >= 0; n--) {
					digit = parseInt(value.charAt(n), 10);
	
					if (even) {
						if ((digit *= 2) > 9) {
							digit -= 9;
						}
					}
	
					check += digit;
					even = !even;
				}
	
				return (check % 10) == 0;
			}
		};
	}(window.jQuery));
	;(function($) {
		$.fn.bootstrapValidator.validators.date = {
			/**
			 * Return true if the input value is valid date
			 *
			 * @param {BootstrapValidator} validator The validator plugin instance
			 * @param {jQuery} $field Field element
			 * @param {Object} options Can consist of the following keys:
			 * - format: The date format.
			 * It is a combination of YYYY, MM, DD, and separators (which can be / or -)
			 * Default is MM/DD/YYYY
			 * - message: The invalid message
			 * @returns {Boolean}
			 */
			validate: function(validator, $field, options) {
				var value = $field.val();
				if (value == '') {
					return true;
				}
				options.format = options.format || 'MM/DD/YYYY';
	
				var separator = (options.format.indexOf('/') == -1) ? '-' : '/',
					parts     = value.split(separator);
				if (parts.length != 3) {
					return false;
				}
	
				var d, m, y;
				switch (options.format.toUpperCase().replace(/-/g, '/')) {
					case 'YYYY/MM/DD':
						d = parts[2];
						m = parts[1];
						y = parts[0];
						break;
					case 'YYYY/DD/MM':
						d = parts[1];
						m = parts[2];
						y = parts[0];
						break;
					case 'DD/MM/YYYY':
						d = parts[0];
						m = parts[1];
						y = parts[2];
						break;
					case 'MM/DD/YYYY':
						d = parts[1];
						m = parts[0];
						y = parts[2];
						break;
					default:
						return false;
				}
	
				d = parseInt(d, 10);
				m = parseInt(m, 10);
				y = parseInt(y, 10);
	
				if (y < 1000 || y > 9999 || m == 0 || m > 12) {
					return false;
				}
	
				var numDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
				// Update the number of days in Feb of leap year
				if (y % 400 == 0 || (y % 100 != 0 && y % 4 == 0)) {
					numDays[1] = 29;
				}
	
				// Check the day
				return (d > 0 && d <= numDays[m - 1]);
			}
		};
	}(window.jQuery));
	
	;(function($) {
		$.fn.bootstrapValidator.validators.different = {
			/**
			 * Return true if the input value is different with given field's value
			 *
			 * @param {BootstrapValidator} validator The validator plugin instance
			 * @param {jQuery} $field Field element
			 * @param {Object} options Consists of the following key:
			 * - field: The name of field that will be used to compare with current one
			 * @returns {Boolean}
			 */
			validate: function(validator, $field, options) {
				var value = $field.val();
				if (value == '') {
					return true;
				}
	
				var compareWith = validator.getFieldElements(options.field);
				if (compareWith == null) {
					return true;
				}
	
				if (value != compareWith.val()) {
					validator.updateStatus(compareWith, 'different', validator.STATUS_VALID);
					return true;
				} else {
					return false;
				}
			}
		};
	}(window.jQuery));
	;(function($) {
		$.fn.bootstrapValidator.validators.digits = {
			/**
			 * Return true if the input value contains digits only
			 *
			 * @param {BootstrapValidator} validator Validate plugin instance
			 * @param {jQuery} $field Field element
			 * @param {Object} options
			 * @returns {Boolean}
			 */
			validate: function(validator, $field, options) {
				var value = $field.val();
				if (value == '') {
					return true;
				}
	
				return /^\d+$/.test(value);
			}
		}
	}(window.jQuery));
	;(function($) {
		$.fn.bootstrapValidator.validators.emailAddress = {
			/**
			 * Return true if and only if the input value is a valid email address
			 *
			 * @param {BootstrapValidator} validator Validate plugin instance
			 * @param {jQuery} $field Field element
			 * @param {Object} options
			 * @returns {Boolean}
			 */
			validate: function(validator, $field, options) {
				var value = $field.val();
				if (value == '') {
					return true;
				}
	
				// Email address regular expression
				// http://stackoverflow.com/questions/46155/validate-email-address-in-javascript
				var emailRegExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				return emailRegExp.test(value);
			}
		}
	}(window.jQuery));
	;(function($) {
		$.fn.bootstrapValidator.validators.greaterThan = {
			/**
			 * Return true if the input value is greater than or equals to given number
			 *
			 * @param {BootstrapValidator} validator Validate plugin instance
			 * @param {jQuery} $field Field element
			 * @param {Object} options Can consist of the following keys:
			 * - value: The number used to compare to
			 * - inclusive [optional]: Can be true or false. Default is true
			 * - message: The invalid message
			 * @returns {Boolean}
			 */
			validate: function(validator, $field, options) {
				var value = $field.val();
				if (value == '') {
					return true;
				}
				value = parseFloat(value);
				return (options.inclusive === true) ? (value > options.value) : (value >= options.value);
			}
		}
	}(window.jQuery));
	;(function($) {
		$.fn.bootstrapValidator.validators.hexColor = {
			/**
			 * Return true if the input value is a valid hex color
			 *
			 * @param {BootstrapValidator} validator The validator plugin instance
			 * @param {jQuery} $field Field element
			 * @param {Object} options Can consist of the following keys:
			 * - message: The invalid message
			 * @returns {Boolean}
			 */
			validate: function(validator, $field, options) {
				var value = $field.val();
				if (value == '') {
					return true;
				}
				return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(value);
			}
		};
	}(window.jQuery));
	;(function($) {
		$.fn.bootstrapValidator.validators.identical = {
			/**
			 * Check if input value equals to value of particular one
			 *
			 * @param {BootstrapValidator} validator The validator plugin instance
			 * @param {jQuery} $field Field element
			 * @param {Object} options Consists of the following key:
			 * - field: The name of field that will be used to compare with current one
			 * @returns {Boolean}
			 */
			validate: function(validator, $field, options) {
				var value = $field.val();
				if (value == '') {
					return true;
				}
	
				var compareWith = validator.getFieldElements(options.field);
				if (compareWith == null) {
					return true;
				}
	
				if (value == compareWith.val()) {
					validator.updateStatus(compareWith, 'identical', validator.STATUS_VALID);
					return true;
				} else {
					return false;
				}
			}
		};
	}(window.jQuery));
	;(function($) {
		$.fn.bootstrapValidator.validators.lessThan = {
			/**
			 * Return true if the input value is less than or equal to given number
			 *
			 * @param {BootstrapValidator} validator The validator plugin instance
			 * @param {jQuery} $field Field element
			 * @param {Object} options Can consist of the following keys:
			 * - value: The number used to compare to
			 * - inclusive [optional]: Can be true or false. Default is true
			 * - message: The invalid message
			 * @returns {Boolean}
			 */
			validate: function(validator, $field, options) {
				var value = $field.val();
				if (value == '') {
					return true;
				}
				value = parseFloat(value);
				return (options.inclusive === true) ? (value < options.value) : (value <= options.value);
			}
		};
	}(window.jQuery));
	;(function($) {
		$.fn.bootstrapValidator.validators.notEmpty = {
			/**
			 * Check if input value is empty or not
			 *
			 * @param {BootstrapValidator} validator The validator plugin instance
			 * @param {jQuery} $field Field element
			 * @param {Object} options
			 * @returns {Boolean}
			 */
			validate: function(validator, $field, options) {
				var type = $field.attr('type');
				if ('radio' == type || 'checkbox' == type) {
					return validator
						.getFieldElements($field.attr('name'))
						.filter(':checked')
						.length > 0;
				}
	
				return $.trim($field.val()) != '';
			}
		};
	}(window.jQuery));
	;(function($) {
		$.fn.bootstrapValidator.validators.regexp = {
			/**
			 * Check if the element value matches given regular expression
			 *
			 * @param {BootstrapValidator} validator The validator plugin instance
			 * @param {jQuery} $field Field element
			 * @param {Object} options Consists of the following key:
			 * - regexp: The regular expression you need to check
			 * @returns {Boolean}
			 */
			validate: function(validator, $field, options) {
				var value = $field.val();
				if (value == '') {
					return true;
				}
	
				return options.regexp.test(value);
			}
		};
	}(window.jQuery));
	;(function($) {
		$.fn.bootstrapValidator.validators.remote = {
			/**
			 * Request a remote server to check the input value
			 *
			 * @param {BootstrapValidator} validator Plugin instance
			 * @param {jQuery} $field Field element
			 * @param {Object} options Can consist of the following keys:
			 * - url
			 * - data [optional]: By default, it will take the value
			 *  {
	         *      <fieldName>: <fieldValue>
	         *  }
			 * - message: The invalid message
			 * @returns {Boolean|Deferred}
			 */
			validate: function(validator, $field, options) {
				var value = $field.val();
				if (value == '') {
					return true;
				}
	
				var name = $field.attr('name'), data = options.data;
				if (data == null) {
					data = {};
				}
				// Support dynamic data
				if ('function' == typeof data) {
					data = data.call(this, validator);
				}
				data[name] = value;
	
				var dfd = new $.Deferred();
				var xhr = $.shopgate.ajax({
					type: 'POST',
					url: options.url,
					dataType: 'json',
					data: data
				});
				xhr.then(function(response) {
					dfd.resolve(response.valid === true || response.valid === 'true', 'remote');
				});
	
				dfd.fail(function() {
					xhr.abort();
				});
	
				return dfd;
			}
		};
	}(window.jQuery));
	;(function($) {
		$.fn.bootstrapValidator.validators.stringLength = {
			/**
			 * Check if the length of element value is less or more than given number
			 *
			 * @param {BootstrapValidator} validator The validator plugin instance
			 * @param {jQuery} $field Field element
			 * @param {Object} options Consists of following keys:
			 * - min
			 * - max
			 * At least one of two keys is required
			 * @returns {Boolean}
			 */
			validate: function(validator, $field, options) {
				var value = $field.val();
				if (value == '') {
					return true;
				}
	
				var length = $.trim(value).length;
				if ((options.min && length < options.min) || (options.max && length > options.max)) {
					return false;
				}
	
				return true;
			}
		};
	}(window.jQuery));
	;(function($) {
		$.fn.bootstrapValidator.validators.uri = {
			/**
			 * Return true if the input value is a valid URL
			 *
			 * @param {BootstrapValidator} validator The validator plugin instance
			 * @param {jQuery} $field Field element
			 * @param {Object} options
			 * @returns {Boolean}
			 */
			validate: function(validator, $field, options) {
				var value = $field.val();
				if (value == '') {
					return true;
				}
	
				// Credit to https://gist.github.com/dperini/729294
				//
				// Regular Expression for URL validation
				//
				// Author: Diego Perini
				// Updated: 2010/12/05
				//
				// the regular expression composed & commented
				// could be easily tweaked for RFC compliance,
				// it was expressly modified to fit & satisfy
				// these test for an URL shortener:
				//
				//   http://mathiasbynens.be/demo/url-regex
				//
				// Notes on possible differences from a standard/generic validation:
				//
				// - utf-8 char class take in consideration the full Unicode range
				// - TLDs have been made mandatory so single names like "localhost" fails
				// - protocols have been restricted to ftp, http and https only as requested
				//
				// Changes:
				//
				// - IP address dotted notation validation, range: 1.0.0.0 - 223.255.255.255
				//   first and last IP address of each class is considered invalid
				//   (since they are broadcast/network addresses)
				//
				// - Added exclusion of private, reserved and/or local networks ranges
				//
				// Compressed one-line versions:
				//
				// Javascript version
				//
				// /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/i
				//
				// PHP version
				//
				// _^(?:(?:https?|ftp)://)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\x{00a1}-\x{ffff}0-9]+-?)*[a-z\x{00a1}-\x{ffff}0-9]+)(?:\.(?:[a-z\x{00a1}-\x{ffff}0-9]+-?)*[a-z\x{00a1}-\x{ffff}0-9]+)*(?:\.(?:[a-z\x{00a1}-\x{ffff}]{2,})))(?::\d{2,5})?(?:/[^\s]*)?$_iuS
				var urlExp = new RegExp(
					"^" +
						// protocol identifier
						"(?:(?:https?|ftp)://)" +
						// user:pass authentication
						"(?:\\S+(?::\\S*)?@)?" +
						"(?:" +
						// IP address exclusion
						// private & local networks
						"(?!10(?:\\.\\d{1,3}){3})" +
						"(?!127(?:\\.\\d{1,3}){3})" +
						"(?!169\\.254(?:\\.\\d{1,3}){2})" +
						"(?!192\\.168(?:\\.\\d{1,3}){2})" +
						"(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
						// IP address dotted notation octets
						// excludes loopback network 0.0.0.0
						// excludes reserved space >= 224.0.0.0
						// excludes network & broacast addresses
						// (first & last IP address of each class)
						"(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
						"(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
						"(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
						"|" +
						// host name
						"(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)" +
						// domain name
						"(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*" +
						// TLD identifier
						"(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" +
						")" +
						// port number
						"(?::\\d{2,5})?" +
						// resource path
						"(?:/[^\\s]*)?" +
						"$", "i"
				);
				return urlExp.test(value);
			}
		};
	}(window.jQuery));
	;(function($) {
		$.fn.bootstrapValidator.validators.zipCode = {
			/**
			 * Return true if and only if the input value is a valid country zip code
			 *
			 * @param {BootstrapValidator} validator The validator plugin instance
			 * @param {jQuery} $field Field element
			 * @param {Object} options Consist of key:
			 * - country: The ISO 3166 country code
			 *
			 * Currently it supports the following countries:
			 * - US (United State)
			 * - DK (Denmark)
			 * - SE (Sweden)
			 *
			 * @returns {Boolean}
			 */
			validate: function(validateInstance, $field, options) {
				var value = $field.val();
				if (value == '' || !options.country) {
					return true;
				}
				switch (options.country.toUpperCase()) {
					case 'DK':
						return /^(DK(-|\s)?)?\d{4}$/i.test(value);
					case 'SE':
						return /^(S-)?\d{3}\s?\d{2}$/i.test(value);
					case 'US':
					default:
						return /^\d{5}([\-]\d{4})?$/.test(value);
				}
			}
		};
	}(window.jQuery));


/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! jQuery plugin for Hammer.JS - v1.1.3 - 2014-05-20
	 * http://eightmedia.github.com/hammer.js
	 *
	 * Copyright (c) 2014 Jorik Tangelder <j.tangelder@gmail.com>;
	 * Licensed under the MIT license */
	
	!function(a,b){"use strict";function c(){e.READY||(t.determineEventTypes(),s.each(e.gestures,function(a){v.register(a)}),t.onTouch(e.DOCUMENT,o,v.detect),t.onTouch(e.DOCUMENT,p,v.detect),e.READY=!0)}function d(a,c){Date.now||(Date.now=function(){return(new Date).getTime()}),a.utils.each(["on","off"],function(d){a.utils[d]=function(a,e,f){c(a)[d](e,function(a){var d=c.extend({},a.originalEvent,a);d.button===b&&(d.button=a.which-1),f.call(this,d)})}}),a.Instance.prototype.trigger=function(a,b){var d=c(this.element);return d.has(b.target).length&&(d=c(b.target)),d.trigger({type:a,gesture:b})},c.fn.hammer=function(b){return this.each(function(){var d=c(this),e=d.data("hammer");e?e&&b&&a.utils.extend(e.options,b):d.data("hammer",new a(this,b||{}))})}}var e=function w(a,b){return new w.Instance(a,b||{})};e.VERSION="1.1.3",e.defaults={behavior:{userSelect:"none",touchAction:"pan-y",touchCallout:"none",contentZooming:"none",userDrag:"none",tapHighlightColor:"rgba(0,0,0,0)"}},e.DOCUMENT=document,e.HAS_POINTEREVENTS=navigator.pointerEnabled||navigator.msPointerEnabled,e.HAS_TOUCHEVENTS="ontouchstart"in a,e.IS_MOBILE=/mobile|tablet|ip(ad|hone|od)|android|silk/i.test(navigator.userAgent),e.NO_MOUSEEVENTS=e.HAS_TOUCHEVENTS&&e.IS_MOBILE||e.HAS_POINTEREVENTS,e.CALCULATE_INTERVAL=25;var f={},g=e.DIRECTION_DOWN="down",h=e.DIRECTION_LEFT="left",i=e.DIRECTION_UP="up",j=e.DIRECTION_RIGHT="right",k=e.POINTER_MOUSE="mouse",l=e.POINTER_TOUCH="touch",m=e.POINTER_PEN="pen",n=e.EVENT_START="start",o=e.EVENT_MOVE="move",p=e.EVENT_END="end",q=e.EVENT_RELEASE="release",r=e.EVENT_TOUCH="touch";e.READY=!1,e.plugins=e.plugins||{},e.gestures=e.gestures||{};var s=e.utils={extend:function(a,c,d){for(var e in c)!c.hasOwnProperty(e)||a[e]!==b&&d||(a[e]=c[e]);return a},on:function(a,b,c){a.addEventListener(b,c,!1)},off:function(a,b,c){a.removeEventListener(b,c,!1)},each:function(a,c,d){var e,f;if("forEach"in a)a.forEach(c,d);else if(a.length!==b){for(e=0,f=a.length;f>e;e++)if(c.call(d,a[e],e,a)===!1)return}else for(e in a)if(a.hasOwnProperty(e)&&c.call(d,a[e],e,a)===!1)return},inStr:function(a,b){return a.indexOf(b)>-1},inArray:function(a,b){if(a.indexOf){var c=a.indexOf(b);return-1===c?!1:c}for(var d=0,e=a.length;e>d;d++)if(a[d]===b)return d;return!1},toArray:function(a){return Array.prototype.slice.call(a,0)},hasParent:function(a,b){for(;a;){if(a==b)return!0;a=a.parentNode}return!1},getCenter:function(a){var b=[],c=[],d=[],e=[],f=Math.min,g=Math.max;return 1===a.length?{pageX:a[0].pageX,pageY:a[0].pageY,clientX:a[0].clientX,clientY:a[0].clientY}:(s.each(a,function(a){b.push(a.pageX),c.push(a.pageY),d.push(a.clientX),e.push(a.clientY)}),{pageX:(f.apply(Math,b)+g.apply(Math,b))/2,pageY:(f.apply(Math,c)+g.apply(Math,c))/2,clientX:(f.apply(Math,d)+g.apply(Math,d))/2,clientY:(f.apply(Math,e)+g.apply(Math,e))/2})},getVelocity:function(a,b,c){return{x:Math.abs(b/a)||0,y:Math.abs(c/a)||0}},getAngle:function(a,b){var c=b.clientX-a.clientX,d=b.clientY-a.clientY;return 180*Math.atan2(d,c)/Math.PI},getDirection:function(a,b){var c=Math.abs(a.clientX-b.clientX),d=Math.abs(a.clientY-b.clientY);return c>=d?a.clientX-b.clientX>0?h:j:a.clientY-b.clientY>0?i:g},getDistance:function(a,b){var c=b.clientX-a.clientX,d=b.clientY-a.clientY;return Math.sqrt(c*c+d*d)},getScale:function(a,b){return a.length>=2&&b.length>=2?this.getDistance(b[0],b[1])/this.getDistance(a[0],a[1]):1},getRotation:function(a,b){return a.length>=2&&b.length>=2?this.getAngle(b[1],b[0])-this.getAngle(a[1],a[0]):0},isVertical:function(a){return a==i||a==g},setPrefixedCss:function(a,b,c,d){var e=["","Webkit","Moz","O","ms"];b=s.toCamelCase(b);for(var f=0;f<e.length;f++){var g=b;if(e[f]&&(g=e[f]+g.slice(0,1).toUpperCase()+g.slice(1)),g in a.style){a.style[g]=(null==d||d)&&c||"";break}}},toggleBehavior:function(a,b,c){if(b&&a&&a.style){s.each(b,function(b,d){s.setPrefixedCss(a,d,b,c)});var d=c&&function(){return!1};"none"==b.userSelect&&(a.onselectstart=d),"none"==b.userDrag&&(a.ondragstart=d)}},toCamelCase:function(a){return a.replace(/[_-]([a-z])/g,function(a){return a[1].toUpperCase()})}};e.Instance=function(a,b){var d=this;c(),this.element=a,this.enabled=!0,s.each(b,function(a,c){delete b[c],b[s.toCamelCase(c)]=a}),this.options=s.extend(s.extend({},e.defaults),b||{}),this.options.behavior&&s.toggleBehavior(this.element,this.options.behavior,!0),this.eventStartHandler=t.onTouch(a,n,function(a){d.enabled&&a.eventType==n?v.startDetect(d,a):a.eventType==r&&v.detect(a)}),this.eventHandlers=[]},e.Instance.prototype={on:function(a,b){var c=this;return t.on(c.element,a,b,function(a){c.eventHandlers.push({gesture:a,handler:b})}),c},off:function(a,b){var c=this;return t.off(c.element,a,b,function(a){var d=s.inArray({gesture:a,handler:b});d!==!1&&c.eventHandlers.splice(d,1)}),c},trigger:function(a,b){b||(b={});var c=e.DOCUMENT.createEvent("Event");c.initEvent(a,!0,!0),c.gesture=b;var d=this.element;return s.hasParent(b.target,d)&&(d=b.target),d.dispatchEvent(c),this},enable:function(a){return this.enabled=a,this},dispose:function(){var a,b;for(s.toggleBehavior(this.element,this.options.behavior,!1),a=-1;b=this.eventHandlers[++a];)s.off(this.element,b.gesture,b.handler);return this.eventHandlers=[],t.off(this.element,f[n],this.eventStartHandler),null}};var t=e.event={preventMouseEvents:!1,started:!1,shouldDetect:!1,on:function(a,b,c,d){var e=b.split(" ");s.each(e,function(b){s.on(a,b,c),d&&d(b)})},off:function(a,b,c,d){var e=b.split(" ");s.each(e,function(b){s.off(a,b,c),d&&d(b)})},onTouch:function(a,b,c){var d=this,g=function(f){var g,h=f.type.toLowerCase(),i=e.HAS_POINTEREVENTS,j=s.inStr(h,"mouse");j&&d.preventMouseEvents||(j&&b==n&&0===f.button?(d.preventMouseEvents=!1,d.shouldDetect=!0):i&&b==n?d.shouldDetect=1===f.buttons||u.matchType(l,f):j||b!=n||(d.preventMouseEvents=!0,d.shouldDetect=!0),i&&b!=p&&u.updatePointer(b,f),d.shouldDetect&&(g=d.doDetect.call(d,f,b,a,c)),g==p&&(d.preventMouseEvents=!1,d.shouldDetect=!1,u.reset()),i&&b==p&&u.updatePointer(b,f))};return this.on(a,f[b],g),g},doDetect:function(a,b,c,d){var e=this.getTouchList(a,b),f=e.length,g=b,h=e.trigger,i=f;b==n?h=r:b==p&&(h=q,i=e.length-(a.changedTouches?a.changedTouches.length:1)),i>0&&this.started&&(g=o),this.started=!0;var j=this.collectEventData(c,g,e,a);return b!=p&&d.call(v,j),h&&(j.changedLength=i,j.eventType=h,d.call(v,j),j.eventType=g,delete j.changedLength),g==p&&(d.call(v,j),this.started=!1),g},determineEventTypes:function(){var b;return b=e.HAS_POINTEREVENTS?a.PointerEvent?["pointerdown","pointermove","pointerup pointercancel lostpointercapture"]:["MSPointerDown","MSPointerMove","MSPointerUp MSPointerCancel MSLostPointerCapture"]:e.NO_MOUSEEVENTS?["touchstart","touchmove","touchend touchcancel"]:["touchstart mousedown","touchmove mousemove","touchend touchcancel mouseup"],f[n]=b[0],f[o]=b[1],f[p]=b[2],f},getTouchList:function(a,b){if(e.HAS_POINTEREVENTS)return u.getTouchList();if(a.touches){if(b==o)return a.touches;var c=[],d=[].concat(s.toArray(a.touches),s.toArray(a.changedTouches)),f=[];return s.each(d,function(a){s.inArray(c,a.identifier)===!1&&f.push(a),c.push(a.identifier)}),f}return a.identifier=1,[a]},collectEventData:function(a,b,c,d){var e=l;return s.inStr(d.type,"mouse")||u.matchType(k,d)?e=k:u.matchType(m,d)&&(e=m),{center:s.getCenter(c),timeStamp:Date.now(),target:d.target,touches:c,eventType:b,pointerType:e,srcEvent:d,preventDefault:function(){var a=this.srcEvent;a.preventManipulation&&a.preventManipulation(),a.preventDefault&&a.preventDefault()},stopPropagation:function(){this.srcEvent.stopPropagation()},stopDetect:function(){return v.stopDetect()}}}},u=e.PointerEvent={pointers:{},getTouchList:function(){var a=[];return s.each(this.pointers,function(b){a.push(b)}),a},updatePointer:function(a,b){a==p||a!=p&&1!==b.buttons?delete this.pointers[b.pointerId]:(b.identifier=b.pointerId,this.pointers[b.pointerId]=b)},matchType:function(a,b){if(!b.pointerType)return!1;var c=b.pointerType,d={};return d[k]=c===(b.MSPOINTER_TYPE_MOUSE||k),d[l]=c===(b.MSPOINTER_TYPE_TOUCH||l),d[m]=c===(b.MSPOINTER_TYPE_PEN||m),d[a]},reset:function(){this.pointers={}}},v=e.detection={gestures:[],current:null,previous:null,stopped:!1,startDetect:function(a,b){this.current||(this.stopped=!1,this.current={inst:a,startEvent:s.extend({},b),lastEvent:!1,lastCalcEvent:!1,futureCalcEvent:!1,lastCalcData:{},name:""},this.detect(b))},detect:function(a){if(this.current&&!this.stopped){a=this.extendEventData(a);var b=this.current.inst,c=b.options;return s.each(this.gestures,function(d){!this.stopped&&b.enabled&&c[d.name]&&d.handler.call(d,a,b)},this),this.current&&(this.current.lastEvent=a),a.eventType==p&&this.stopDetect(),a}},stopDetect:function(){this.previous=s.extend({},this.current),this.current=null,this.stopped=!0},getCalculatedData:function(a,b,c,d,f){var g=this.current,h=!1,i=g.lastCalcEvent,j=g.lastCalcData;i&&a.timeStamp-i.timeStamp>e.CALCULATE_INTERVAL&&(b=i.center,c=a.timeStamp-i.timeStamp,d=a.center.clientX-i.center.clientX,f=a.center.clientY-i.center.clientY,h=!0),(a.eventType==r||a.eventType==q)&&(g.futureCalcEvent=a),(!g.lastCalcEvent||h)&&(j.velocity=s.getVelocity(c,d,f),j.angle=s.getAngle(b,a.center),j.direction=s.getDirection(b,a.center),g.lastCalcEvent=g.futureCalcEvent||a,g.futureCalcEvent=a),a.velocityX=j.velocity.x,a.velocityY=j.velocity.y,a.interimAngle=j.angle,a.interimDirection=j.direction},extendEventData:function(a){var b=this.current,c=b.startEvent,d=b.lastEvent||c;(a.eventType==r||a.eventType==q)&&(c.touches=[],s.each(a.touches,function(a){c.touches.push({clientX:a.clientX,clientY:a.clientY})}));var e=a.timeStamp-c.timeStamp,f=a.center.clientX-c.center.clientX,g=a.center.clientY-c.center.clientY;return this.getCalculatedData(a,d.center,e,f,g),s.extend(a,{startEvent:c,deltaTime:e,deltaX:f,deltaY:g,distance:s.getDistance(c.center,a.center),angle:s.getAngle(c.center,a.center),direction:s.getDirection(c.center,a.center),scale:s.getScale(c.touches,a.touches),rotation:s.getRotation(c.touches,a.touches)}),a},register:function(a){var c=a.defaults||{};return c[a.name]===b&&(c[a.name]=!0),s.extend(e.defaults,c,!0),a.index=a.index||1e3,this.gestures.push(a),this.gestures.sort(function(a,b){return a.index<b.index?-1:a.index>b.index?1:0}),this.gestures}};!function(a){function b(b,d){var e=v.current;if(!(d.options.dragMaxTouches>0&&b.touches.length>d.options.dragMaxTouches))switch(b.eventType){case n:c=!1;break;case o:if(b.distance<d.options.dragMinDistance&&e.name!=a)return;var f=e.startEvent.center;if(e.name!=a&&(e.name=a,d.options.dragDistanceCorrection&&b.distance>0)){var k=Math.abs(d.options.dragMinDistance/b.distance);f.pageX+=b.deltaX*k,f.pageY+=b.deltaY*k,f.clientX+=b.deltaX*k,f.clientY+=b.deltaY*k,b=v.extendEventData(b)}(e.lastEvent.dragLockToAxis||d.options.dragLockToAxis&&d.options.dragLockMinDistance<=b.distance)&&(b.dragLockToAxis=!0);var l=e.lastEvent.direction;b.dragLockToAxis&&l!==b.direction&&(b.direction=s.isVertical(l)?b.deltaY<0?i:g:b.deltaX<0?h:j),c||(d.trigger(a+"start",b),c=!0),d.trigger(a,b),d.trigger(a+b.direction,b);var m=s.isVertical(b.direction);(d.options.dragBlockVertical&&m||d.options.dragBlockHorizontal&&!m)&&b.preventDefault();break;case q:c&&b.changedLength<=d.options.dragMaxTouches&&(d.trigger(a+"end",b),c=!1);break;case p:c=!1}}var c=!1;e.gestures.Drag={name:a,index:50,handler:b,defaults:{dragMinDistance:10,dragDistanceCorrection:!0,dragMaxTouches:1,dragBlockHorizontal:!1,dragBlockVertical:!1,dragLockToAxis:!1,dragLockMinDistance:25}}}("drag"),e.gestures.Gesture={name:"gesture",index:1337,handler:function(a,b){b.trigger(this.name,a)}},function(a){function b(b,d){var e=d.options,f=v.current;switch(b.eventType){case n:clearTimeout(c),f.name=a,c=setTimeout(function(){f&&f.name==a&&d.trigger(a,b)},e.holdTimeout);break;case o:b.distance>e.holdThreshold&&clearTimeout(c);break;case q:clearTimeout(c)}}var c;e.gestures.Hold={name:a,index:10,defaults:{holdTimeout:500,holdThreshold:2},handler:b}}("hold"),e.gestures.Release={name:"release",index:1/0,handler:function(a,b){a.eventType==q&&b.trigger(this.name,a)}},e.gestures.Swipe={name:"swipe",index:40,defaults:{swipeMinTouches:1,swipeMaxTouches:1,swipeVelocityX:.6,swipeVelocityY:.6},handler:function(a,b){if(a.eventType==q){var c=a.touches.length,d=b.options;if(c<d.swipeMinTouches||c>d.swipeMaxTouches)return;(a.velocityX>d.swipeVelocityX||a.velocityY>d.swipeVelocityY)&&(b.trigger(this.name,a),b.trigger(this.name+a.direction,a))}}},function(a){function b(b,d){var e,f,g=d.options,h=v.current,i=v.previous;switch(b.eventType){case n:c=!1;break;case o:c=c||b.distance>g.tapMaxDistance;break;case p:!s.inStr(b.srcEvent.type,"cancel")&&b.deltaTime<g.tapMaxTime&&!c&&(e=i&&i.lastEvent&&b.timeStamp-i.lastEvent.timeStamp,f=!1,i&&i.name==a&&e&&e<g.doubleTapInterval&&b.distance<g.doubleTapDistance&&(d.trigger("doubletap",b),f=!0),(!f||g.tapAlways)&&(h.name=a,d.trigger(h.name,b)))}}var c=!1;e.gestures.Tap={name:a,index:100,handler:b,defaults:{tapMaxTime:250,tapMaxDistance:10,tapAlways:!0,doubleTapDistance:20,doubleTapInterval:300}}}("tap"),e.gestures.Touch={name:"touch",index:-1/0,defaults:{preventDefault:!1,preventMouse:!1},handler:function(a,b){return b.options.preventMouse&&a.pointerType==k?void a.stopDetect():(b.options.preventDefault&&a.preventDefault(),void(a.eventType==r&&b.trigger("touch",a)))}},function(a){function b(b,d){switch(b.eventType){case n:c=!1;break;case o:if(b.touches.length<2)return;var e=Math.abs(1-b.scale),f=Math.abs(b.rotation);if(e<d.options.transformMinScale&&f<d.options.transformMinRotation)return;v.current.name=a,c||(d.trigger(a+"start",b),c=!0),d.trigger(a,b),f>d.options.transformMinRotation&&d.trigger("rotate",b),e>d.options.transformMinScale&&(d.trigger("pinch",b),d.trigger("pinch"+(b.scale<1?"in":"out"),b));break;case q:c&&b.changedLength<2&&(d.trigger(a+"end",b),c=!1)}}var c=!1;e.gestures.Transform={name:a,index:45,defaults:{transformMinScale:.01,transformMinRotation:1},handler:b}}("transform"),a.Hammer=e,"undefined"!=typeof module&&module.exports&&(module.exports=e), true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(433)], __WEBPACK_AMD_DEFINE_RESULT__ = function(b){return d(a.Hammer,b)}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):d(a.Hammer,a.jQuery||a.Zepto)}(window);

/***/ }),

/***/ 433:
/***/ (function(module, exports) {

	module.exports = jQuery;

/***/ }),

/***/ 434:
/***/ (function(module, exports) {

	/*!
	 *	Cliplister Content Integration Lib.
	 *
	 *	File:			cllib.inc.js
	 *	Copyright by:           Cliplister GmbH
	 *	Author: 		Cliplister GmbH
	 *	Version:		2.5
	 * 	lastChanges:            @Changelog.txt 
	 *
	 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
	 * -----------------------------------SPECAIL ADAPTION---------------------------------------
	 *
	 * default script: http://mycliplister.com/static/clplayer/cllib.inc.min.js
	 *
	 *	Normally this script waits on two events before it sends the request to the cliplister
	 *	server. But because of our lazy loading these events (window.document.DOMContentLoaded
	 *	and window.document.onload) are triggered before this script was loaded.
	 *
	 *  So we removed the document.onload event and replaced the document.DOMContentLoaded
	 *  with a custom event(cliplister_load_config_finished_event).
	 *  Now we can create a player first and then trigger the event which starts the cliplister
	 *  logic.
	 *  This is executed in jquery.shopgate-product-details-cliplister.js from line 64 to line 94
	 *
	 * changes line 227
	 * from:
	 * }, n.Cliplister = n.CL = c(), n.Clip = l, i.addEventListener ? i.addEventListener("DOMContentLoaded", function () {
	 *	  n.Cliplister.addLoadEvent(function () {
	 *    	i.removeEventListener("DOMContentLoaded", arguments.callee, !1), n.Cliplister.clips.length > 0 && n.Cliplister.onReadyBuildHTML()
	 *	  })
	 * to:
	 * }, n.Cliplister = n.CL = c(), n.Clip = l, i.addEventListener ? i.addEventListener("cliplister_load_config_finished_event", function () {
	 *		i.removeEventListener("cliplister_load_config_finished_event", arguments.callee, !1), n.Cliplister.clips.length > 0 && n.Cliplister.onReadyBuildHTML()
	 *
	 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
	 */
	(function (n, t) {
		function l(n) {
			return new Object(n)
		}
	
		if (n.Cliplister === t) {
			var c = function () {
				return new e
			}, u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", e = function () {
			}, i = n.document, h = "mycliplister.com/cliplister/";
			var s = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, r, o, a = {
				"\b": "\\b",
				"\t": "\\t",
				"\n": "\\n",
				"\f": "\\f",
				"\r": "\\r",
				'"': '\\"',
				"\\": "\\\\"
			}, f;
			e.prototype = {
				clips: [], tmplist: [], request: {}, log: [], config: {shopId: 0, SEO: !1, autoplay: !1, callbacks: {}}, setID: function (n) {
					this.setshopId(n)
				}, setshopId: function (n) {
					this.config.shopId = n
				}, setSEO: function (n) {
					this.config.SEO = n
				}, setAutoplay: function (n) {
					this.config.autoplay = n
				}, player: function () {
					for (var n = 0; n < this.player.arguments.length; n++)switch (this.clTypeOf(this.player.arguments[n])) {
						case"string":
							this.setID(this.player.arguments[n]);
							break;
						case"number":
							this.setID(this.player.arguments[n]);
							break;
						case"boolean":
							this.setSEO(this.player.arguments[n]);
							break;
						default:
							this.addClip(this.player.arguments[n])
					}
				}, onReadyBuildHTML: function () {
					this.config.shopId === 0 && this.readshopId(), this.readAutoplay(), this.readSEO(), this.addSEO(), this.addshopId();
					for (var n = 0; n < this.clips.length; n++)this.clips[n].timer = (new Date).getTime();
					this.buildRequest()
				}, readshopId: function () {
					for (var n = 0; n < this.clips.length; n++)if (this.clips[n].shopId !== t) {
						this.config.shopId = this.clips[n].shopId;
						break
					}
				}, getCallback: function (n) {
					return this.config.callbacks[n]
				}, readSEO: function () {
					for (var n = 0; n < this.clips.length; n++)if (this.clips[n].SEO !== t) {
						this.setSEO(this.clips[n].SEO);
						break
					}
				}, readAutoplay: function () {
					for (var n = 0; n < this.clips.length; n++)if (this.clips[n].autoplay !== t) {
						this.setAutoplay(this.clips[n].autoplay);
						break
					}
				}, addshopId: function () {
					for (var n = 0; n < this.clips.length; n++)this.clips[n].shopId = this.config.shopId
				}, addSEO: function () {
					for (var n = 0; n < this.clips.length; n++)this.clips[n].SEO = this.config.SEO
				}, addClip: function (n) {
					this.clTypeOf(n) === "array" ? this.clips = this.clips.concat(n) : this.clTypeOf(n) === "object" && this.clips.push(n)
				}, checkVideoAvailability: function (n) {
					var t = new Image, i;
					t.onload = function () {
						t.width < 2 && (n.style.height = "0", n.style.width = "0", n.style.visibility = "hidden")
					}, i = n.src.replace(/\/ind/g, ""), t.src = i.replace(/\?.*/g, "") + "/cx"
				}, JSONstringify: function (n, t, i) {
					var u;
					if (r = "", o = "", typeof i == "number")for (u = 0; u < i; u += 1)o += " "; else typeof i == "string" && (o = i);
					if (f = t, t && typeof t != "function" && (typeof t != "object" || typeof t.length != "number"))throw new Error("this.JSONstringify");
					return this.JSONstr("", {"": n})
				}, JSONstr: function (n, t) {
					var u, h, e, c, l = r, s, i = t[n];
					typeof f == "function" && (i = f.call(t, n, i));
					switch (typeof i) {
						case"string":
							return this.JSONquote(i);
						case"number":
							return isFinite(i) ? String(i) : "null";
						case"boolean":
						case"null":
							return String(i);
						case"object":
							if (!i)return "null";
							if (r += o, s = [], Object.prototype.toString.apply(i) === "[object Array]") {
								for (c = i.length, u = 0; u < c; u += 1)s[u] = this.JSONstr(u, i) || "null";
								return e = s.length === 0 ? "[]" : r ? "[\n" + r + s.join(",\n" + r) + "\n" + l + "]" : "[" + s.join(",") + "]", r = l, e
							}
							if (f && typeof f == "object")for (c = f.length, u = 0; u < c; u += 1)typeof f[u] == "string" && (h = f[u], e = this.JSONstr(h, i), e && s.push(this.JSONquote(h) + (r ? ": " : ":") + e)); else for (h in i)Object.prototype.hasOwnProperty.call(i, h) && (e = this.JSONstr(h, i), e && s.push(this.JSONquote(h) + (r ? ": " : ":") + e));
							return e = s.length === 0 ? "{}" : r ? "{\n" + r + s.join(",\n" + r) + "\n" + l + "}" : "{" + s.join(",") + "}", r = l, e
					}
				}, JSONquote: function (n) {
					return s.lastIndex = 0, s.test(n) ? '"' + n.replace(s, function (n) {
						var t = a[n];
						return typeof t == "string" ? t : "\\u" + ("0000" + n.charCodeAt(0).toString(16)).slice(-4)
					}) + '"' : '"' + n.replace(/[\u00A0-\u2666<>\&]/g, function (n) {
						return "&#" + n.charCodeAt(0) + ";"
					}) + '"'
				}, clTypeOf: function (n) {
					return typeof n == "object" ? n.length ? "array" : "object" : typeof n
				}, getHTML: function (r, f, e) {
					var o = this.clips[r].playerID, s, c, l;
					o || (o = e ? e : "Cliplister_" + this.getRandom(100, 999999999999), this.clips[r].playerID = o), this.clips[r].onReady && typeof this.clips[r].onReady == "function" && (this.config.callbacks[o] = this.clips[r].onReady);
					var p = this.clips[r].urlPattern !== t ? this.clips[r].urlPattern : "lcplay", w = this.config.autoplay !== t ? this.config.autoplay : "false", a = "";
					if (this.clips[r].param !== t)for (s in this.clips[r].param)a += "&" + s + "=" + encodeURIComponent(this.clips[r].param[s]);
					var v = this.clips[r].geo, y = n.location.protocol + "//" + (v ? v + "." : "") + h + p + u.charAt(63) + this.clips[r].shopId + u.charAt(63) + this.clips[r].request + "?id=" + o + "&autoplay=" + w + a, b = this.clips[r].seoString !== t ? this.clips[r].seoString : "";
					this.clips[r].request && (i.getElementById(o) || (c = i.createElement("div"), c.id = o, f.appendChild(c)), typeof this.clips[r].indirect == "boolean" && this.clips[r].indirect ? (l = n.Cliplister.clips[r].size.split("x"), i.getElementById(o).innerHTML += '<iframe width="' + l[0] + '" height="' + l[1] + '" src="' + y + '" frameborder="0" onload="javascript:Cliplister.checkVideoAvailability(this)" scrolling="no"><\/iframe>') : this.ajax(y, !0, this.setupResponse, r))
				}, setupResponse: function (n, r) {
					if (typeof n !== t) {
						e.clips[r].response = n;
						try {
							eval(n.responseText + "")
						} catch (f) {
							if (n.responseText.replace(/^[\s\xA0]+/, "").replace(/[\s\xA0]+$/, "").match("^<")) {
								var u = n.responseText;
								u.replace(/\ /g, "").match("position:absolute;") && (u = u.replace(/ style=\"([a-z:0-9;]*)\"/g, "")), i.getElementById(e.clips[r].playerID).innerHTML += u
							}
						}
					}
				}, buildRequest: function () {
					for (var r = 0, i = 0; i < this.clips.length; i++)this.request[i] = !0, this.clips[i] && !this.clips[i].response && this.config.shopId && (this.request[i] = !1, this.ajax(n.location.protocol + "//" + h + "lc" + u.charAt(63) + this.config.shopId + u.charAt(63) + "?" + this.encode(this.JSONstringify([this.clips[i]])), !0, function (i, r) {
						var u, f, o;
						e = n.Cliplister;
						try {
							u = eval("(" + i.responseText + ")"), n.Cliplister.clips[r] = Object.deepExtend(n.Cliplister.clips[r], u != t ? u[0] : []), n.Cliplister.tmplist.length > 0 && (n.Cliplister.clips = n.Cliplister.tmplist.concat(n.Cliplister.clips), n.Cliplister.tmplist = []), n.Cliplister.request[r] = !0, f = !0;
							for (o in n.Cliplister.request)n.Cliplister.request[o] || (f = !1);
							f && n.Cliplister.setupClipBuild()
						} catch (s) {
						}
					}, i), r++);
					r == 0 && this.setupClipBuild()
				}, reloadClips: function () {
					for (var n, t = 0; t < this.clips.length; t++)if (n = i.getElementById(this.clips[t].playerID), n)while (n.hasChildNodes())n.removeChild(n.firstChild);
					this.onReadyBuildHTML()
				}, setupClipBuild: function () {
					for (var r, n = 0; n < this.clips.length; n++)this.clips[n].elementID !== t && (r = i.getElementById(this.clips[n].elementID), r && this.getHTML(n, r))
				}, getRandom: function (n, t) {
					if (n > t)return -1;
					if (n == t)return n;
					var i;
					do i = Math.random(); while (i == 1);
					return n + parseInt(i * (t - n + 1))
				}, ajax: function (t, i, r, u) {
					var f = null;
					!n.XDomainRequest && n.XMLHttpRequest ? (f = new XMLHttpRequest, f.open("GET", t, i), f.timeout = 5e3, f.onreadystatechange = function () {
						f.readyState == 4 && (f.status == 200 && f.responseText != "" ? r(f, u) : f.abort())
					}) : (f = new XDomainRequest, f.timeout = 5e3, f.onload = function () {
						r(f, u)
					}, f.onprogress = function () {
					}, f.ontimeout = function () {
					}, f.onerror = function () {
					}, f.open("GET", t)), n.setTimeout(function () {
						f.send()
					}, 0)
				}, ajaxPOST: function (t, i, r, u, f) {
					var e = null;
					!n.XDomainRequest && n.XMLHttpRequest ? (e = new XMLHttpRequest, e.open("POST", t, r), e.timeout = 5e3, e.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), e.onreadystatechange = function () {
						e.readyState == 4 && e.status == 200 && e.responseText != "" && u(e, f)
					}) : (e = new XDomainRequest, e.timeout = 5e3, e.onload = function () {
						u(e, f)
					}, e.onprogress = function () {
					}, e.ontimeout = function () {
					}, e.onerror = function () {
					}, e.open("POST", t)), n.setTimeout(function () {
						e.send("cldata=" + i)
					}, 0)
				}, loadJS: function (n, r) {
					var e = i.getElementsByTagName("HEAD").item(0), u = i.createElement("script"), f = !1;
					u.language = "javascript", u.type = "text/javascript", typeof r === t && (r = function () {
					}), u.onreadystatechange = u.onload = function () {
						f || this.readyState && !/loaded|complete/.test(this.readyState) || (f = !0, r())
					}, u.src = n, e.appendChild(u)
				}, encode: function (n) {
					n = escape(n);
					var s = "", f, t, i = "", h, c, e, r = "", o = 0;
					do f = n.charCodeAt(o++), t = n.charCodeAt(o++), i = n.charCodeAt(o++), h = f >> 2, c = (f & 3) << 4 | t >> 4, e = (t & 15) << 2 | i >> 6, r = i & 63, isNaN(t) ? e = r = 64 : isNaN(i) && (r = 64), s = s + u.charAt(h) + u.charAt(c) + u.charAt(e) + u.charAt(r), f = t = i = "", h = c = e = r = ""; while (o < n.length);
					return s
				}, decode: function (n) {
					var t = "", o, s, h = "", c, f, i, e = "", r = 0;
					/[^A-Za-z0-9\+\/\=]/g.exec(n), n = n.replace(/[^A-Za-z0-9\+\/\=]/g, "");
					do c = u.indexOf(n.charAt(r++)), f = u.indexOf(n.charAt(r++)), i = u.indexOf(n.charAt(r++)), e = u.indexOf(n.charAt(r++)), o = c << 2 | f >> 4, s = (f & 15) << 4 | i >> 2, h = (i & 3) << 6 | e, t = t + String.fromCharCode(o), i !== 64 && (t = t + String.fromCharCode(s)), e !== 64 && (t = t + String.fromCharCode(h)), o = s = h = "", c = f = i = e = ""; while (r < n.length);
					return unescape(t)
				}, addLoadEvent: function (t) {
					var i = n.onload;
					n.onload = typeof n.onload != "function" ? t : function () {
						try {
							i()
						} catch (n) {
						}
						t()
					}
				}
			}, n.Cliplister = n.CL = c(), n.Clip = l, i.addEventListener ? i.addEventListener("cliplister_load_config_finished_event", function () {
				i.removeEventListener("cliplister_load_config_finished_event", arguments.callee, !1), n.Cliplister.clips.length > 0 && n.Cliplister.onReadyBuildHTML()
			}, !1) : i.attachEvent && i.attachEvent("onreadystatechange", function () {
				(i.readyState === "complete" || i.readyState === "loaded") && n.Cliplister.addLoadEvent(function () {
					i.detachEvent("onreadystatechange", arguments.callee), n.Cliplister.clips.length > 0 && n.Cliplister.onReadyBuildHTML()
				})
			}), Object.isObjectLiteral = function (n) {
				return n && n.constructor && n.constructor === Object
			}, Object.deepExtend = function (n, t) {
				for (var i in t)Object.isObjectLiteral(n[i]) && Object.isObjectLiteral(t[i]) ? (n[i] = n[i] || {}, arguments.callee(n[i], t[i])) : n[i] = t[i];
				return n
			}
		}
	})(window, undefined)

/***/ }),

/***/ 435:
/***/ (function(module, exports) {

	!function(e){if(!e.hasInitialised){var t={escapeRegExp:function(e){return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,"\\$&")},hasClass:function(e,t){var i=" ";return 1===e.nodeType&&(i+e.className+i).replace(/[\n\t]/g,i).indexOf(i+t+i)>=0},addClass:function(e,t){e.className+=" "+t},removeClass:function(e,t){var i=new RegExp("\\b"+this.escapeRegExp(t)+"\\b");e.className=e.className.replace(i,"")},interpolateString:function(e,t){var i=/{{([a-z][a-z0-9\-_]*)}}/gi;return e.replace(i,function(e){return t(arguments[1])||""})},getCookie:function(e){var t="; "+document.cookie,i=t.split("; "+e+"=");return 2!=i.length?void 0:i.pop().split(";").shift()},setCookie:function(e,t,i,n,o){var s=new Date;s.setDate(s.getDate()+(i||365));var r=[e+"="+t,"expires="+s.toUTCString(),"path="+(o||"/")];n&&r.push("domain="+n),document.cookie=r.join(";")},deepExtend:function(e,t){for(var i in t)t.hasOwnProperty(i)&&(i in e&&this.isPlainObject(e[i])&&this.isPlainObject(t[i])?this.deepExtend(e[i],t[i]):e[i]=t[i]);return e},throttle:function(e,t){var i=!1;return function(){i||(e.apply(this,arguments),i=!0,setTimeout(function(){i=!1},t))}},hash:function(e){var t,i,n,o=0;if(0===e.length)return o;for(t=0,n=e.length;t<n;++t)i=e.charCodeAt(t),o=(o<<5)-o+i,o|=0;return o},normaliseHex:function(e){return"#"==e[0]&&(e=e.substr(1)),3==e.length&&(e=e[0]+e[0]+e[1]+e[1]+e[2]+e[2]),e},getContrast:function(e){e=this.normaliseHex(e);var t=parseInt(e.substr(0,2),16),i=parseInt(e.substr(2,2),16),n=parseInt(e.substr(4,2),16),o=(299*t+587*i+114*n)/1e3;return o>=128?"#000":"#fff"},getLuminance:function(e){var t=parseInt(this.normaliseHex(e),16),i=38,n=(t>>16)+i,o=(t>>8&255)+i,s=(255&t)+i,r=(16777216+65536*(n<255?n<1?0:n:255)+256*(o<255?o<1?0:o:255)+(s<255?s<1?0:s:255)).toString(16).slice(1);return"#"+r},isMobile:function(){return/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)},isPlainObject:function(e){return"object"==typeof e&&null!==e&&e.constructor==Object}};e.status={deny:"deny",allow:"allow",dismiss:"dismiss"},e.transitionEnd=function(){var e=document.createElement("div"),t={t:"transitionend",OT:"oTransitionEnd",msT:"MSTransitionEnd",MozT:"transitionend",WebkitT:"webkitTransitionEnd"};for(var i in t)if(t.hasOwnProperty(i)&&"undefined"!=typeof e.style[i+"ransition"])return t[i];return""}(),e.hasTransition=!!e.transitionEnd;var i=Object.keys(e.status).map(t.escapeRegExp);e.customStyles={},e.Popup=function(){function n(){this.initialise.apply(this,arguments)}function o(e){this.openingTimeout=null,t.removeClass(e,"cc-invisible")}function s(t){t.style.display="none",t.removeEventListener(e.transitionEnd,this.afterTransition),this.afterTransition=null}function r(){var t=this.options.onInitialise.bind(this);if(!window.navigator.cookieEnabled)return t(e.status.deny),!0;if(window.CookiesOK||window.navigator.CookiesOK)return t(e.status.allow),!0;var i=Object.keys(e.status),n=this.getStatus(),o=i.indexOf(n)>=0;return o&&t(n),o}function a(){var e=this.options.position.split("-"),t=[];return e.forEach(function(e){t.push("cc-"+e)}),t}function c(){var e=this.options,i="top"==e.position||"bottom"==e.position?"banner":"floating";t.isMobile()&&(i="floating");var n=["cc-"+i,"cc-type-"+e.type,"cc-theme-"+e.theme];e["static"]&&n.push("cc-static"),n.push.apply(n,a.call(this));p.call(this,this.options.palette);return this.customStyleSelector&&n.push(this.customStyleSelector),n}function l(){var e={},i=this.options;i.showLink||(i.elements.link="",i.elements.messagelink=i.elements.message),Object.keys(i.elements).forEach(function(n){e[n]=t.interpolateString(i.elements[n],function(e){var t=i.content[e];return e&&"string"==typeof t&&t.length?t:""})});var n=i.compliance[i.type];n||(n=i.compliance.info),e.compliance=t.interpolateString(n,function(t){return e[t]});var o=i.layouts[i.layout];return o||(o=i.layouts.basic),t.interpolateString(o,function(t){return e[t]})}function u(i){var n=this.options,o=document.createElement("div"),s=n.container&&1===n.container.nodeType?n.container:document.body;o.innerHTML=i;var r=o.children[0];return r.style.display="none",t.hasClass(r,"cc-window")&&e.hasTransition&&t.addClass(r,"cc-invisible"),this.onButtonClick=h.bind(this),r.addEventListener("click",this.onButtonClick),n.autoAttach&&(s.firstChild?s.insertBefore(r,s.firstChild):s.appendChild(r)),r}function h(n){var o=n.target;if(t.hasClass(o,"cc-btn")){var s=o.className.match(new RegExp("\\bcc-("+i.join("|")+")\\b")),r=s&&s[1]||!1;r&&(this.setStatus(r),this.close(!0))}t.hasClass(o,"cc-close")&&(this.setStatus(e.status.dismiss),this.close(!0)),t.hasClass(o,"cc-revoke")&&this.revokeChoice()}function p(e){var i=t.hash(JSON.stringify(e)),n="cc-color-override-"+i,o=t.isPlainObject(e);return this.customStyleSelector=o?n:null,o&&d(i,e,"."+n),o}function d(i,n,o){if(e.customStyles[i])return void++e.customStyles[i].references;var s={},r=n.popup,a=n.button,c=n.highlight;r&&(r.text=r.text?r.text:t.getContrast(r.background),r.link=r.link?r.link:r.text,s[o+".cc-window"]=["color: "+r.text,"background-color: "+r.background],s[o+".cc-revoke"]=["color: "+r.text,"background-color: "+r.background],s[o+" .cc-link,"+o+" .cc-link:active,"+o+" .cc-link:visited"]=["color: "+r.link],a&&(a.text=a.text?a.text:t.getContrast(a.background),a.border=a.border?a.border:"transparent",s[o+" .cc-btn"]=["color: "+a.text,"border-color: "+a.border,"background-color: "+a.background],"transparent"!=a.background&&(s[o+" .cc-btn:hover, "+o+" .cc-btn:focus"]=["background-color: "+v(a.background)]),c?(c.text=c.text?c.text:t.getContrast(c.background),c.border=c.border?c.border:"transparent",s[o+" .cc-highlight .cc-btn:first-child"]=["color: "+c.text,"border-color: "+c.border,"background-color: "+c.background]):s[o+" .cc-highlight .cc-btn:first-child"]=["color: "+r.text]));var l=document.createElement("style");document.head.appendChild(l),e.customStyles[i]={references:1,element:l.sheet};var u=-1;for(var h in s)s.hasOwnProperty(h)&&l.sheet.insertRule(h+"{"+s[h].join(";")+"}",++u)}function v(e){return e=t.normaliseHex(e),"000000"==e?"#222":t.getLuminance(e)}function f(i){if(t.isPlainObject(i)){var n=t.hash(JSON.stringify(i)),o=e.customStyles[n];if(o&&!--o.references){var s=o.element.ownerNode;s&&s.parentNode&&s.parentNode.removeChild(s),e.customStyles[n]=null}}}function m(e,t){for(var i=0,n=e.length;i<n;++i){var o=e[i];if(o instanceof RegExp&&o.test(t)||"string"==typeof o&&o.length&&o===t)return!0}return!1}function b(){var t=this.setStatus.bind(this),i=this.options.dismissOnTimeout;"number"==typeof i&&i>=0&&(this.dismissTimeout=window.setTimeout(function(){t(e.status.dismiss)},Math.floor(i)));var n=this.options.dismissOnScroll;if("number"==typeof n&&n>=0){var o=function(i){window.pageYOffset>Math.floor(n)&&(t(e.status.dismiss),window.removeEventListener("scroll",o),this.onWindowScroll=null)};this.onWindowScroll=o,window.addEventListener("scroll",o)}}function y(){if("info"!=this.options.type&&(this.options.revokable=!0),t.isMobile()&&(this.options.animateRevokable=!1),this.options.revokable){var e=a.call(this);this.options.animateRevokable&&e.push("cc-animate"),this.customStyleSelector&&e.push(this.customStyleSelector);var i=this.options.revokeBtn.replace("{{classes}}",e.join(" "));this.revokeBtn=u.call(this,i);var n=this.revokeBtn;if(this.options.animateRevokable){var o=t.throttle(function(e){var i=!1,o=20,s=window.innerHeight-20;t.hasClass(n,"cc-top")&&e.clientY<o&&(i=!0),t.hasClass(n,"cc-bottom")&&e.clientY>s&&(i=!0),i?t.hasClass(n,"cc-active")||t.addClass(n,"cc-active"):t.hasClass(n,"cc-active")&&t.removeClass(n,"cc-active")},200);this.onMouseMove=o,window.addEventListener("mousemove",o)}}}var g={enabled:!0,container:null,cookie:{name:"cookieconsent_status",path:"/",domain:"",expiryDays:365},onPopupOpen:function(){},onPopupClose:function(){},onInitialise:function(e){},onStatusChange:function(e,t){},onRevokeChoice:function(){},content:{header:"Cookies used on the website!",message:"This website uses cookies to ensure you get the best experience on our website.",dismiss:"Got it!",allow:"Allow cookies",deny:"Decline",link:"Learn more",href:"http://cookiesandyou.com",close:"&#x274c;"},elements:{header:'<span class="cc-header">{{header}}</span>&nbsp;',message:'<span id="cookieconsent:desc" class="cc-message">{{message}}</span>',messagelink:'<span id="cookieconsent:desc" class="cc-message">{{message}} <a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" rel="noopener noreferrer nofollow" target="_blank">{{link}}</a></span>',dismiss:'<a aria-label="dismiss cookie message" role=button tabindex="0" class="cc-btn cc-dismiss">{{dismiss}}</a>',allow:'<a aria-label="allow cookies" role=button tabindex="0"  class="cc-btn cc-allow">{{allow}}</a>',deny:'<a aria-label="deny cookies" role=button tabindex="0" class="cc-btn cc-deny">{{deny}}</a>',link:'<a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" target="_blank">{{link}}</a>',close:'<span aria-label="dismiss cookie message" role=button tabindex="0" class="cc-close">{{close}}</span>'},window:'<div role="dialog" aria-live="polite" aria-label="cookieconsent" aria-describedby="cookieconsent:desc" class="cc-window {{classes}}"><!--googleoff: all-->{{children}}<!--googleon: all--></div>',revokeBtn:'<div class="cc-revoke {{classes}}">Cookie Policy</div>',compliance:{info:'<div class="cc-compliance">{{dismiss}}</div>',"opt-in":'<div class="cc-compliance cc-highlight">{{dismiss}}{{allow}}</div>',"opt-out":'<div class="cc-compliance cc-highlight">{{deny}}{{dismiss}}</div>'},type:"info",layouts:{basic:"{{messagelink}}{{compliance}}","basic-close":"{{messagelink}}{{compliance}}{{close}}","basic-header":"{{header}}{{message}}{{link}}{{compliance}}"},layout:"basic",position:"bottom",theme:"block","static":!1,palette:null,revokable:!1,animateRevokable:!0,showLink:!0,dismissOnScroll:!1,dismissOnTimeout:!1,autoOpen:!0,autoAttach:!0,whitelistPage:[],blacklistPage:[],overrideHTML:null};return n.prototype.initialise=function(e){this.options&&this.destroy(),t.deepExtend(this.options={},g),t.isPlainObject(e)&&t.deepExtend(this.options,e),r.call(this)&&(this.options.enabled=!1),m(this.options.blacklistPage,location.pathname)&&(this.options.enabled=!1),m(this.options.whitelistPage,location.pathname)&&(this.options.enabled=!0);var i=this.options.window.replace("{{classes}}",c.call(this).join(" ")).replace("{{children}}",l.call(this)),n=this.options.overrideHTML;if("string"==typeof n&&n.length&&(i=n),this.options["static"]){var o=u.call(this,'<div class="cc-grower">'+i+"</div>");o.style.display="",this.element=o.firstChild,this.element.style.display="none",t.addClass(this.element,"cc-invisible")}else this.element=u.call(this,i);b.call(this),y.call(this),this.options.autoOpen&&this.autoOpen()},n.prototype.destroy=function(){this.onButtonClick&&this.element&&(this.element.removeEventListener("click",this.onButtonClick),this.onButtonClick=null),this.dismissTimeout&&(clearTimeout(this.dismissTimeout),this.dismissTimeout=null),this.onWindowScroll&&(window.removeEventListener("scroll",this.onWindowScroll),this.onWindowScroll=null),this.onMouseMove&&(window.removeEventListener("mousemove",this.onMouseMove),this.onMouseMove=null),this.element&&this.element.parentNode&&this.element.parentNode.removeChild(this.element),this.element=null,this.revokeBtn&&this.revokeBtn.parentNode&&this.revokeBtn.parentNode.removeChild(this.revokeBtn),this.revokeBtn=null,f(this.options.palette),this.options=null},n.prototype.open=function(t){if(this.element)return this.isOpen()||(e.hasTransition?this.fadeIn():this.element.style.display="",this.options.revokable&&this.toggleRevokeButton(),this.options.onPopupOpen.call(this)),this},n.prototype.close=function(t){if(this.element)return this.isOpen()&&(e.hasTransition?this.fadeOut():this.element.style.display="none",t&&this.options.revokable&&this.toggleRevokeButton(!0),this.options.onPopupClose.call(this)),this},n.prototype.fadeIn=function(){var i=this.element;if(e.hasTransition&&i&&(this.afterTransition&&s.call(this,i),t.hasClass(i,"cc-invisible"))){if(i.style.display="",this.options["static"]){var n=this.element.clientHeight;this.element.parentNode.style.maxHeight=n+"px"}var r=20;this.openingTimeout=setTimeout(o.bind(this,i),r)}},n.prototype.fadeOut=function(){var i=this.element;e.hasTransition&&i&&(this.openingTimeout&&(clearTimeout(this.openingTimeout),o.bind(this,i)),t.hasClass(i,"cc-invisible")||(this.options["static"]&&(this.element.parentNode.style.maxHeight=""),this.afterTransition=s.bind(this,i),i.addEventListener(e.transitionEnd,this.afterTransition),t.addClass(i,"cc-invisible")))},n.prototype.isOpen=function(){return this.element&&""==this.element.style.display&&(!e.hasTransition||!t.hasClass(this.element,"cc-invisible"))},n.prototype.toggleRevokeButton=function(e){this.revokeBtn&&(this.revokeBtn.style.display=e?"":"none")},n.prototype.revokeChoice=function(e){this.options.enabled=!0,this.clearStatus(),this.options.onRevokeChoice.call(this),e||this.autoOpen()},n.prototype.hasAnswered=function(t){return Object.keys(e.status).indexOf(this.getStatus())>=0},n.prototype.hasConsented=function(t){var i=this.getStatus();return i==e.status.allow||i==e.status.dismiss},n.prototype.autoOpen=function(e){!this.hasAnswered()&&this.options.enabled&&this.open()},n.prototype.setStatus=function(i){var n=this.options.cookie,o=t.getCookie(n.name),s=Object.keys(e.status).indexOf(o)>=0;Object.keys(e.status).indexOf(i)>=0?(t.setCookie(n.name,i,n.expiryDays,n.domain,n.path),this.options.onStatusChange.call(this,i,s)):this.clearStatus()},n.prototype.getStatus=function(){return t.getCookie(this.options.cookie.name)},n.prototype.clearStatus=function(){var e=this.options.cookie;t.setCookie(e.name,"",-1,e.domain,e.path)},n}(),e.Location=function(){function e(e){t.deepExtend(this.options={},s),t.isPlainObject(e)&&t.deepExtend(this.options,e),this.currentServiceIndex=-1}function i(e,t,i){var n,o=document.createElement("script");o.type="text/"+(e.type||"javascript"),o.src=e.src||e,o.async=!1,o.onreadystatechange=o.onload=function(){var e=o.readyState;clearTimeout(n),t.done||e&&!/loaded|complete/.test(e)||(t.done=!0,t(),o.onreadystatechange=o.onload=null)},document.body.appendChild(o),n=setTimeout(function(){t.done=!0,t(),o.onreadystatechange=o.onload=null},i)}function n(e,t,i,n,o){var s=new(window.XMLHttpRequest||window.ActiveXObject)("MSXML2.XMLHTTP.3.0");if(s.open(n?"POST":"GET",e,1),s.setRequestHeader("X-Requested-With","XMLHttpRequest"),s.setRequestHeader("Content-type","application/x-www-form-urlencoded"),Array.isArray(o))for(var r=0,a=o.length;r<a;++r){var c=o[r].split(":",2);s.setRequestHeader(c[0].replace(/^\s+|\s+$/g,""),c[1].replace(/^\s+|\s+$/g,""))}"function"==typeof t&&(s.onreadystatechange=function(){s.readyState>3&&t(s)}),s.send(n)}function o(e){return new Error("Error ["+(e.code||"UNKNOWN")+"]: "+e.error)}var s={timeout:5e3,services:["freegeoip","ipinfo","maxmind"],serviceDefinitions:{freegeoip:function(){return{url:"//freegeoip.net/json/?callback={callback}",isScript:!0,callback:function(e,t){try{var i=JSON.parse(t);return i.error?o(i):{code:i.country_code}}catch(n){return o({error:"Invalid response ("+n+")"})}}}},ipinfo:function(){return{url:"//ipinfo.io",headers:["Accept: application/json"],callback:function(e,t){try{var i=JSON.parse(t);return i.error?o(i):{code:i.country}}catch(n){return o({error:"Invalid response ("+n+")"})}}}},ipinfodb:function(e){return{url:"//api.ipinfodb.com/v3/ip-country/?key={api_key}&format=json&callback={callback}",isScript:!0,callback:function(e,t){try{var i=JSON.parse(t);return"ERROR"==i.statusCode?o({error:i.statusMessage}):{code:i.countryCode}}catch(n){return o({error:"Invalid response ("+n+")"})}}}},maxmind:function(){return{url:"//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js",isScript:!0,callback:function(e){return window.geoip2?void geoip2.country(function(t){try{e({code:t.country.iso_code})}catch(i){e(o(i))}},function(t){e(o(t))}):void e(new Error("Unexpected response format. The downloaded script should have exported `geoip2` to the global scope"))}}}}};return e.prototype.getNextService=function(){var e;do e=this.getServiceByIdx(++this.currentServiceIndex);while(this.currentServiceIndex<this.options.services.length&&!e);return e},e.prototype.getServiceByIdx=function(e){var i=this.options.services[e];if("function"==typeof i){var n=i();return n.name&&t.deepExtend(n,this.options.serviceDefinitions[n.name](n)),n}return"string"==typeof i?this.options.serviceDefinitions[i]():t.isPlainObject(i)?this.options.serviceDefinitions[i.name](i):null},e.prototype.locate=function(e,t){var i=this.getNextService();return i?(this.callbackComplete=e,this.callbackError=t,void this.runService(i,this.runNextServiceOnError.bind(this))):void t(new Error("No services to run"))},e.prototype.setupUrl=function(e){var t=this.getCurrentServiceOpts();return e.url.replace(/\{(.*?)\}/g,function(i,n){if("callback"===n){var o="callback"+Date.now();return window[o]=function(t){e.__JSONP_DATA=JSON.stringify(t)},o}if(n in t.interpolateUrl)return t.interpolateUrl[n]})},e.prototype.runService=function(e,t){var o=this;if(e&&e.url&&e.callback){var s=e.isScript?i:n,r=this.setupUrl(e);s(r,function(i){var n=i?i.responseText:"";e.__JSONP_DATA&&(n=e.__JSONP_DATA,delete e.__JSONP_DATA),o.runServiceCallback.call(o,t,e,n)},this.options.timeout,e.data,e.headers)}},e.prototype.runServiceCallback=function(e,t,i){var n=this,o=function(t){s||n.onServiceResult.call(n,e,t)},s=t.callback(o,i);s&&this.onServiceResult.call(this,e,s)},e.prototype.onServiceResult=function(e,t){t instanceof Error||t&&t.error?e.call(this,t,null):e.call(this,null,t)},e.prototype.runNextServiceOnError=function(e,t){if(e){this.logError(e);var i=this.getNextService();i?this.runService(i,this.runNextServiceOnError.bind(this)):this.completeService.call(this,this.callbackError,new Error("All services failed"))}else this.completeService.call(this,this.callbackComplete,t)},e.prototype.getCurrentServiceOpts=function(){var e=this.options.services[this.currentServiceIndex];return"string"==typeof e?{name:e}:"function"==typeof e?e():t.isPlainObject(e)?e:{}},e.prototype.completeService=function(e,t){this.currentServiceIndex=-1,e&&e(t)},e.prototype.logError=function(e){var t=this.currentServiceIndex,i=this.getServiceByIdx(t);console.error("The service["+t+"] ("+i.url+") responded with the following error",e)},e}(),e.Law=function(){function e(e){this.initialise.apply(this,arguments)}var i={regionalLaw:!0,hasLaw:["AT","BE","BG","HR","CZ","CY","DK","EE","FI","FR","DE","EL","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","SK","SI","ES","SE","GB","UK"],revokable:["HR","CY","DK","EE","FR","DE","LV","LT","NL","PT","ES"],explicitAction:["HR","IT","ES"]};return e.prototype.initialise=function(e){t.deepExtend(this.options={},i),t.isPlainObject(e)&&t.deepExtend(this.options,e)},e.prototype.get=function(e){var t=this.options;return{hasLaw:t.hasLaw.indexOf(e)>=0,revokable:t.revokable.indexOf(e)>=0,explicitAction:t.explicitAction.indexOf(e)>=0}},e.prototype.applyLaw=function(e,t){var i=this.get(t);return i.hasLaw||(e.enabled=!1),this.options.regionalLaw&&(i.revokable&&(e.revokable=!0),i.explicitAction&&(e.dismissOnScroll=!1,e.dismissOnTimeout=!1)),e},e}(),e.initialise=function(t,i,n){var o=new e.Law(t.law);i||(i=function(){}),n||(n=function(){}),e.getCountryCode(t,function(n){delete t.law,delete t.location,n.code&&(t=o.applyLaw(t,n.code)),i(new e.Popup(t))},function(i){delete t.law,delete t.location,n(i,new e.Popup(t))})},e.getCountryCode=function(t,i,n){if(t.law&&t.law.countryCode)return void i({code:t.law.countryCode});if(t.location){var o=new e.Location(t.location);return void o.locate(function(e){i(e||{})},n)}i({})},e.utils=t,e.hasInitialised=!0,window.cookieconsent=e}}(window.cookieconsent||{});

/***/ })

/******/ });


// WEBPACK FOOTER //
// 7ab37a1c99401871c949/lib/1.0/vendor.js